import * as Types from "./graphql";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchApplicantCvSummaryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchApplicantCvSummaryQuery = { __typename?: 'Query', applicant?: { __typename?: 'Applicant', id: string, protectedProfile?: { __typename?: 'ListingApplicantProtectedProfile', candidateId: string, summaryId?: string | null, summary?: string | null } | null } | null };

export type FetchApplicantsListQueryVariables = Types.Exact<{
  filter: Types.ApplicantFilter;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type FetchApplicantsListQuery = { __typename?: 'Query', applicants: { __typename?: 'ApplicantsResult', items: Array<{ __typename?: 'Applicant', id: string, rank?: number | null, name?: string | null, candidateId: string, isNew?: boolean | null, unsuccessful?: boolean | null, previouslyApplied: boolean, salaryMatch?: boolean | null, locationMatch?: boolean | null, preScreeningMatch?: boolean | null, applicationCreatedAt?: any | null, scores: { __typename?: 'ApplicantScores', total?: number | null, qualifications?: number | null, skills?: number | null, assessments?: number | null }, location?: { __typename?: 'ApplicantLocation', city?: string | null, state?: string | null, country?: string | null } | null, hiredForListing?: { __typename?: 'Listing', id: string } | null, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, status: { __typename?: 'ApplicantStatus', invited: boolean }, profile?: { __typename?: 'ApplicantProfile', cvId?: string | null, latestJob?: { __typename?: 'ApplicantProfileJob', title?: string | null, company?: string | null } | null, prePopulate?: { __typename?: 'ApplicantProfilePrePopulate', isPrePopulated?: boolean | null, userConfirmed?: boolean | null } | null } | null, application?: { __typename?: 'Application', id: string, unavailable: boolean, hired: boolean, isUnsuccessful: boolean, isNew: boolean, isActionPending: boolean, hiredForListing?: { __typename?: 'Listing', id: string } | null, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, source: { __typename?: 'ApplicationSource', referrerUrl?: any | null, name: string } } | null }>, pageInfo: { __typename?: 'PageInfo', page: number, pageSize: number, totalItems: number, totalPages: number } } };

export type FetchApplicantProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  withDirectRank?: Types.Scalars['Boolean']['input'];
}>;


export type FetchApplicantProfileQuery = { __typename?: 'Query', applicant?: { __typename?: 'Applicant', id: string, rank?: number | null, directRank?: number | null, listingId: string, candidateId: string, isDirect: boolean, previouslyApplied: boolean, name?: string | null, firstName?: string | null, locationMatch?: boolean | null, salaryMatch?: boolean | null, authorizedForWork?: boolean | null, isNew?: boolean | null, unsuccessful?: boolean | null, removed?: boolean | null, preScreeningMatch?: boolean | null, scores: { __typename?: 'ApplicantScores', total?: number | null, qualifications?: number | null, skills?: number | null, assessments?: number | null }, location?: { __typename?: 'ApplicantLocation', city?: string | null, state?: string | null, country?: string | null, match?: boolean | null } | null, relocationLocations?: Array<{ __typename?: 'ApplicantRelocationLocation', city?: string | null, state?: string | null, country: string, authorized: boolean, match?: boolean | null }> | null, hiredForListing?: { __typename?: 'Listing', id: string } | null, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, status: { __typename?: 'ApplicantStatus', invited: boolean }, preScreeningAnswers?: Array<{ __typename?: 'ApplicantPreScreeningAnswer', questionId: string, question?: string | null, answer: boolean, match: boolean }> | null, skills?: { __typename?: 'ApplicantSkills', jobs: Array<{ __typename?: 'ApplicantJob', title?: string | null, company?: string | null, startDate?: string | null, endDate?: string | null, skills: Array<{ __typename?: 'Skill', id: string, name: string }> }>, skills?: { __typename?: 'ApplicantMatchedSkills', requested: Array<{ __typename?: 'ApplicantRequestedSkill', importance?: number | null, requestedYears?: number | null, candidateYears?: number | null, skills: Array<{ __typename?: 'Skill', id: string, name: string }> }>, workAreaMatch: Array<{ __typename?: 'ApplicantWorkAreaMatchSkill', candidateYears?: number | null, skill?: { __typename?: 'Skill', id: string, name: string } | null }>, other: Array<{ __typename?: 'ApplicantOtherSkill', candidateYears?: number | null, skill?: { __typename?: 'Skill', id: string, name: string } | null }> } | null, workAreas?: { __typename?: 'ApplicantWorkAreaLists', requested: Array<{ __typename?: 'ApplicantRequestedWorkArea', id?: string | null, match?: boolean | null, workArea?: { __typename?: 'WorkArea', id: string, name: string } | null }>, other: Array<{ __typename?: 'ApplicantOtherWorkArea', id?: string | null, workArea?: { __typename?: 'WorkArea', id: string, name: string } | null }> } | null } | null, qualifications?: { __typename?: 'ApplicantQualifications', requested: Array<{ __typename?: 'ApplicantRequestedQualification', importance?: number | null, isMatch?: boolean | null, qualifications: Array<{ __typename?: 'Qualification', id: string, name: string }> }>, candidate: Array<{ __typename?: 'ApplicantCandidateQualification', institutionName?: string | null, completed?: boolean | null, startedAt?: string | null, completedAt?: string | null, studying?: boolean | null, qualification?: { __typename?: 'Qualification', id: string, name: string } | null, institution?: { __typename?: 'Institution', id: string, name?: string | null } | null }> } | null, assessments?: { __typename?: 'ApplicantAssessments', cultureFit?: { __typename?: 'ApplicantCultureFit', importance?: number | null, percentage?: number | null, comparisons: Array<{ __typename?: 'ApplicantCultureFitComparison', answer?: { __typename?: 'ApplicantAssessmentAnswer', candidate?: number | null, listing?: number | null } | null, label?: { __typename?: 'ApplicantCultureFitLabel', left?: string | null, right?: string | null } | null }> } | null, jobFit?: { __typename?: 'ApplicantJobFit', importance?: number | null, percentage?: number | null, comparisons: Array<{ __typename?: 'ApplicantJobFitComparison', label?: string | null, answer?: { __typename?: 'ApplicantAssessmentAnswer', candidate?: number | null, listing?: number | null } | null }> } | null, personalityFit?: { __typename?: 'ApplicantPersonalityFit', importance?: number | null, percentage?: number | null, personalityTypes?: { __typename?: 'ApplicantPersonalityTypes', candidate: Array<string>, listing: Array<string> } | null } | null } | null, application?: { __typename?: 'Application', id: string, status: Types.ApplicationStatus, hired: boolean, unavailable: boolean, incomplete: boolean, isUnsuccessful: boolean, attachmentIds: Array<string>, hiredForListing?: { __typename?: 'Listing', id: string } | null, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null } | null, profile?: { __typename?: 'ApplicantProfile', cvId?: string | null, contactDetails?: { __typename?: 'ApplicantProfileContactDetails', email?: string | null, phone1?: string | null } | null, latestJob?: { __typename?: 'ApplicantProfileJob', title?: string | null, company?: string | null } | null, workPreferences?: { __typename?: 'ApplicantProfileWorkPreferences', types?: Array<string | null> | null, remote?: boolean | null } | null, professionalLinks?: Array<{ __typename?: 'ApplicantProfileProfessionalLink', url: string, label: string } | null> | null, prePopulate?: { __typename?: 'ApplicantProfilePrePopulate', isPrePopulated?: boolean | null, userConfirmed?: boolean | null } | null } | null, listing: { __typename?: 'Listing', id: string, title?: string | null, team?: { __typename?: 'Team', id: string } | null, applicationStages: Array<{ __typename?: 'ListingApplicationStage', id: string, name: string }>, permissions?: { __typename?: 'ListingPermissions', setStage: boolean, setStageToShortlistOnly: boolean, markAsHired: boolean, dropApplicants: boolean, viewMessages: boolean, inviteApplicants: boolean, viewAllNotes: boolean } | null } } | null };

export type FetchApplicantDocumentsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchApplicantDocumentsQuery = { __typename?: 'Query', applicant?: { __typename?: 'Applicant', id: string, candidateId: string, application?: { __typename?: 'Application', id: string, previewAttachments?: Array<{ __typename?: 'ApplicantProfilePreviewAttachment', id: string, filename?: string | null, formats?: Array<{ __typename?: 'ApplicantProfilePreviewCvFormat', mimetype?: string | null, isOriginal?: boolean | null, downloadUrl?: string | null }> | null } | null> | null } | null, profile?: { __typename?: 'ApplicantProfile', previewCv?: { __typename?: 'ApplicantProfilePreviewCvResult', id: string, filename?: string | null, formats?: Array<{ __typename?: 'ApplicantProfilePreviewCvFormat', mimetype?: string | null, isOriginal?: boolean | null, downloadUrl?: string | null }> | null } | null, previewAttachments?: Array<{ __typename?: 'ApplicantProfilePreviewAttachment', id: string, filename?: string | null, formats?: Array<{ __typename?: 'ApplicantProfilePreviewCvFormat', mimetype?: string | null, isOriginal?: boolean | null, downloadUrl?: string | null }> | null } | null> | null } | null } | null };

export type FetchApplicantHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchApplicantHistoryQuery = { __typename?: 'Query', applicant?: { __typename?: 'Applicant', id: string, applicationHistory: Array<{ __typename?: 'Application', id: string, createdAt: any, isUnsuccessful: boolean, hired: boolean, candidateId: string, hiredForListing?: { __typename?: 'Listing', id: string } | null, applicant?: { __typename?: 'Applicant', id: string } | null, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, listing: { __typename?: 'Listing', id: string, title?: string | null, permissions?: { __typename?: 'ListingPermissions', view: boolean } | null } }> } | null };

export type ApplicationsSetStageMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  input: Types.ApplicationsSetStageInput;
}>;


export type ApplicationsSetStageMutation = { __typename?: 'Mutation', applicationsSetStage: { __typename?: 'BatchApplicationMutationResult', applications: Array<{ __typename?: 'Application', id: string, hired: boolean, isUnsuccessful: boolean, isNew: boolean, isActionPending: boolean, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, hiredForListing?: { __typename?: 'Listing', id: string } | null }>, errors: Array<{ __typename?: 'ApplicationMutationError', message: string, code: Types.ApplicationMutationErrorCode }> } };

export type ApplicationHireMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ApplicationHireMutation = { __typename?: 'Mutation', applicationHire: { __typename?: 'ApplicationMutationResult', application?: { __typename?: 'Application', id: string, hired: boolean, isUnsuccessful: boolean, isNew: boolean, isActionPending: boolean, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, hiredForListing?: { __typename?: 'Listing', id: string } | null } | null, errors: Array<{ __typename?: 'ApplicationMutationError', message: string, code: Types.ApplicationMutationErrorCode }> } };

export type ApplicationsHireMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ApplicationsHireMutation = { __typename?: 'Mutation', applicationsHire: { __typename?: 'BatchApplicationMutationResult', applications: Array<{ __typename?: 'Application', id: string, hired: boolean, isUnsuccessful: boolean, isNew: boolean, isActionPending: boolean, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, hiredForListing?: { __typename?: 'Listing', id: string } | null }>, errors: Array<{ __typename?: 'ApplicationMutationError', message: string, code: Types.ApplicationMutationErrorCode }> } };

export type ApplicationMarkUnsuccessfulMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ApplicationMarkUnsuccessfulMutation = { __typename?: 'Mutation', applicationMarkUnsuccessful: { __typename?: 'BatchApplicationMutationResult', applications: Array<{ __typename?: 'Application', id: string, hired: boolean, isUnsuccessful: boolean, isNew: boolean, isActionPending: boolean, stage?: { __typename?: 'ApplicationStage', id: string, name: string } | null, hiredForListing?: { __typename?: 'Listing', id: string } | null }>, errors: Array<{ __typename?: 'ApplicationMutationError', message: string, code: Types.ApplicationMutationErrorCode }> } };

export type ApplicationMarkSeenMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ApplicationMarkSeenMutation = { __typename?: 'Mutation', applicationMarkSeen: { __typename?: 'ApplicationMutationResult', application?: { __typename?: 'Application', id: string, isNew: boolean } | null, errors: Array<{ __typename?: 'ApplicationMutationError', message: string, code: Types.ApplicationMutationErrorCode }> } };

export type ApplicantDropMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ApplicantDropMutation = { __typename?: 'Mutation', applicantDrop: { __typename?: 'ApplicantMutationResult', applicant?: { __typename?: 'Applicant', id: string } | null, errors: Array<{ __typename?: 'ApplicantMutationError', message: string, code: Types.ApplicantMutationErrorCode }> } };

export type ApplicantsDropMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ApplicantsDropMutation = { __typename?: 'Mutation', applicantsDrop: { __typename?: 'ApplicantsMutationResult', applicants: Array<{ __typename?: 'Applicant', id: string }>, errors: Array<{ __typename?: 'ApplicantMutationError', message: string, code: Types.ApplicantMutationErrorCode }> } };

export type ApplicantInviteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ApplicantInviteMutation = { __typename?: 'Mutation', applicantInvite: { __typename?: 'ApplicantMutationResult', applicant?: { __typename?: 'Applicant', id: string, status: { __typename?: 'ApplicantStatus', invited: boolean } } | null, errors: Array<{ __typename?: 'ApplicantMutationError', message: string, code: Types.ApplicantMutationErrorCode }> } };

export type FetchListingForApplicantsPageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchListingForApplicantsPageQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', id: string, slug?: string | null, title?: string | null, status: Types.ListingStatus, createdAt?: any | null, openedAt?: any | null, company?: string | null, processing?: boolean | null, isProcessingMatches: boolean, matchmakingFailed: boolean, team?: { __typename?: 'Team', id: string, name: string } | null, manager?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, organisation: { __typename?: 'Organisation', id: string }, owner?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, scoreWeights?: { __typename?: 'ListingScoreWeights', skills?: number | null, assessments?: number | null, qualifications?: number | null } | null, locations: Array<{ __typename?: 'ListingLocation', locationId?: string | null, city?: string | null, state?: string | null, country: string }>, applicationStages: Array<{ __typename?: 'ListingApplicationStage', id: string, name: string }>, permissions?: { __typename?: 'ListingPermissions', edit: boolean, viewApplicants: boolean, dropApplicants: boolean, inviteApplicants: boolean, setStage: boolean, setStageToShortlistOnly: boolean, markAsHired: boolean, createMessages: boolean, viewAllNotes: boolean, canAssignTag: boolean } | null, sectionsCompleted: { __typename?: 'ListingSectionsCompleted', prescreening: boolean }, applicantCounts: { __typename?: 'ApplicantsCounts', total: number, direct: number, pool: number, new: number, actionPending: number, stages: Array<{ __typename?: 'ApplicantStageCount', stageId?: string | null, count: number }>, completed: Array<{ __typename?: 'ApplicantCompletedCount', type: string, count: number }> } } | null };

export type FetchListingApplicantCountsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchListingApplicantCountsQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', id: string, applicantCounts: { __typename?: 'ApplicantsCounts', total: number, direct: number } } | null };

export type FetchListingProcessingStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchListingProcessingStatusQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', id: string, isProcessingMatches: boolean, matchmakingFailed: boolean } | null };

export type ListingMatchmakingMarkPendingMutationVariables = Types.Exact<{
  listingId: Types.Scalars['ID']['input'];
}>;


export type ListingMatchmakingMarkPendingMutation = { __typename?: 'Mutation', listingMatchmakingMarkPending: { __typename?: 'ListingMatchmakingMutationResult', listing?: { __typename?: 'Listing', id: string, isProcessingMatches: boolean } | null, errors: Array<{ __typename?: 'ListingMatchmakingMutationError', code: Types.ListingMatchmakingMutationErrorCode, message: string }> } };

export type GetApprovalConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetApprovalConfigQuery = { __typename?: 'Query', approvalConfig: { __typename?: 'ApprovalConfig', enabled: boolean, approvalTypes: Array<string>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type SetRequisitionWorkflowEnabledMutationVariables = Types.Exact<{
  enabled: Types.Scalars['Boolean']['input'];
}>;


export type SetRequisitionWorkflowEnabledMutation = { __typename?: 'Mutation', setRequisitionWorkflowEnabled: { __typename?: 'ApprovalConfig', enabled: boolean, approvalTypes: Array<string> } };

export type AddRequisitionApprovalTypeMutationVariables = Types.Exact<{
  label: Types.Scalars['String']['input'];
}>;


export type AddRequisitionApprovalTypeMutation = { __typename?: 'Mutation', addRequisitionApprovalType: { __typename?: 'ApprovalConfig', enabled: boolean, approvalTypes: Array<string> } };

export type RemoveRequisitionApprovalTypeMutationVariables = Types.Exact<{
  label: Types.Scalars['String']['input'];
}>;


export type RemoveRequisitionApprovalTypeMutation = { __typename?: 'Mutation', removeRequisitionApprovalType: { __typename?: 'ApprovalConfig', enabled: boolean, approvalTypes: Array<string> } };

export type AddRequisitionApproverMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type AddRequisitionApproverMutation = { __typename?: 'Mutation', addRequisitionApprover: { __typename?: 'ApprovalConfig', approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type RemoveRequisitionApproverMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type RemoveRequisitionApproverMutation = { __typename?: 'Mutation', removeRequisitionApprover: { __typename?: 'ApprovalConfig', approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type BusinessProfileFieldsFragment = { __typename?: 'BusinessProfile', id: string, source?: Types.BusinessProfileSource | null, researchedAt?: any | null, goals: Array<string>, updatedAt: any, identity?: { __typename?: 'BusinessProfileIdentity', industry?: string | null, founded?: string | null, scale?: string | null, workModel?: string | null, locations?: string | null, reach?: Types.BusinessReach | null } | null, purpose?: { __typename?: 'BusinessProfilePurpose', mission?: string | null, vision?: string | null, values: Array<{ __typename?: 'BusinessValue', name: string, meaning?: string | null }> } | null, lifecycle?: { __typename?: 'BusinessProfileLifecycle', stage: Types.LifecycleStage, stageOther?: string | null, descriptor: { __typename?: 'LifecycleStageDescriptor', stage: Types.LifecycleStage, order: number, label: string, subtitle: string, goal: string, focus: string, challenge: string } } | null, structure?: { __typename?: 'BusinessProfileStructure', shape?: string | null } | null, leader?: { __typename?: 'BusinessProfileLeader', user: { __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }, personality?: { __typename?: 'WorkPersonality', hasProfile: boolean, personalityType?: string | null, traits: Array<string>, completedAt?: any | null } | null } | null, leadershipTeam: Array<{ __typename?: 'BusinessProfileTeamMember', user: { __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }, personality?: { __typename?: 'WorkPersonality', hasProfile: boolean, personalityType?: string | null } | null }> };

export type BusinessProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BusinessProfileQuery = { __typename?: 'Query', businessProfile?: { __typename?: 'BusinessProfile', id: string, source?: Types.BusinessProfileSource | null, researchedAt?: any | null, goals: Array<string>, updatedAt: any, identity?: { __typename?: 'BusinessProfileIdentity', industry?: string | null, founded?: string | null, scale?: string | null, workModel?: string | null, locations?: string | null, reach?: Types.BusinessReach | null } | null, purpose?: { __typename?: 'BusinessProfilePurpose', mission?: string | null, vision?: string | null, values: Array<{ __typename?: 'BusinessValue', name: string, meaning?: string | null }> } | null, lifecycle?: { __typename?: 'BusinessProfileLifecycle', stage: Types.LifecycleStage, stageOther?: string | null, descriptor: { __typename?: 'LifecycleStageDescriptor', stage: Types.LifecycleStage, order: number, label: string, subtitle: string, goal: string, focus: string, challenge: string } } | null, structure?: { __typename?: 'BusinessProfileStructure', shape?: string | null } | null, leader?: { __typename?: 'BusinessProfileLeader', user: { __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }, personality?: { __typename?: 'WorkPersonality', hasProfile: boolean, personalityType?: string | null, traits: Array<string>, completedAt?: any | null } | null } | null, leadershipTeam: Array<{ __typename?: 'BusinessProfileTeamMember', user: { __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }, personality?: { __typename?: 'WorkPersonality', hasProfile: boolean, personalityType?: string | null } | null }> } | null };

export type OrganisationWebsiteQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationWebsiteQuery = { __typename?: 'Query', organisationWebsite?: string | null };

export type LifecycleStagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LifecycleStagesQuery = { __typename?: 'Query', lifecycleStages: Array<{ __typename?: 'LifecycleStageDescriptor', stage: Types.LifecycleStage, order: number, label: string, subtitle: string, goal: string, focus: string, challenge: string }> };

export type OrganisationPeopleQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OrganisationPeopleQuery = { __typename?: 'Query', organisationPeople: Array<{ __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }> };

export type BusinessProfileDeleteMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type BusinessProfileDeleteMutation = { __typename?: 'Mutation', businessProfileDelete: boolean };

export type BusinessProfileUpdateMutationVariables = Types.Exact<{
  input: Types.BusinessProfileUpdateInput;
}>;


export type BusinessProfileUpdateMutation = { __typename?: 'Mutation', businessProfileUpdate: { __typename?: 'BusinessProfileMutationResult', businessProfile?: { __typename?: 'BusinessProfile', id: string, source?: Types.BusinessProfileSource | null, researchedAt?: any | null, goals: Array<string>, updatedAt: any, identity?: { __typename?: 'BusinessProfileIdentity', industry?: string | null, founded?: string | null, scale?: string | null, workModel?: string | null, locations?: string | null, reach?: Types.BusinessReach | null } | null, purpose?: { __typename?: 'BusinessProfilePurpose', mission?: string | null, vision?: string | null, values: Array<{ __typename?: 'BusinessValue', name: string, meaning?: string | null }> } | null, lifecycle?: { __typename?: 'BusinessProfileLifecycle', stage: Types.LifecycleStage, stageOther?: string | null, descriptor: { __typename?: 'LifecycleStageDescriptor', stage: Types.LifecycleStage, order: number, label: string, subtitle: string, goal: string, focus: string, challenge: string } } | null, structure?: { __typename?: 'BusinessProfileStructure', shape?: string | null } | null, leader?: { __typename?: 'BusinessProfileLeader', user: { __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }, personality?: { __typename?: 'WorkPersonality', hasProfile: boolean, personalityType?: string | null, traits: Array<string>, completedAt?: any | null } | null } | null, leadershipTeam: Array<{ __typename?: 'BusinessProfileTeamMember', user: { __typename?: 'OrganisationPerson', id: string, name?: string | null, jobTitle?: string | null }, personality?: { __typename?: 'WorkPersonality', hasProfile: boolean, personalityType?: string | null } | null }> } | null, errors: Array<{ __typename?: 'BusinessProfileMutationError', message: string, code: Types.BusinessProfileMutationErrorCode, field?: string | null }> } };

export type CulturePerceptionQueryVariables = Types.Exact<{
  assessmentSk: Types.Scalars['String']['input'];
  filters?: Types.InputMaybe<Array<Types.InputMaybe<Types.CulturePerceptionFilterInput>> | Types.InputMaybe<Types.CulturePerceptionFilterInput>>;
}>;


export type CulturePerceptionQuery = { __typename?: 'Query', culturePerception?: { __typename?: 'CulturePerceptionResult', completedUsersCount?: number | null, totalUsersCompleted?: number | null, perceptionAverage?: { __typename?: 'AssessmentPerception', financial?: number | null, operational?: number | null, learningGrowth?: number | null, customerQuality?: number | null, jobEngagement?: number | null, jobSatisfaction?: number | null, turnoverIntention?: number | null, workMotivation?: number | null, overallClimate?: number | null } | null, perceptionList?: Array<{ __typename?: 'AssessmentPerception', financial?: number | null, operational?: number | null, learningGrowth?: number | null, customerQuality?: number | null, jobEngagement?: number | null, jobSatisfaction?: number | null, turnoverIntention?: number | null, workMotivation?: number | null, overallClimate?: number | null } | null> | null } | null };

export type GetCultureHotspotsQueryVariables = Types.Exact<{
  campaignSk?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filter?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCultureHotspotsQuery = { __typename?: 'Query', cultureHotspots?: Array<{ __typename?: 'CultureHotspot', pk?: string | null, sk?: string | null, campaignId?: string | null, campaignName?: string | null, responseCount?: number | null, aggregation?: string | null, current?: any | null, desired?: any | null, hasParent?: boolean | null, aggregateFilter?: string | null } | null> | null };

export type CultureReportProgressFieldsFragment = { __typename?: 'CultureReport', id: string, status: Types.CultureReportStatus, requestedAt: any, updatedAt: any, progress: Array<{ __typename?: 'CultureReportStageProgress', stage: Types.CultureReportStage, status: Types.CultureReportStageStatus, startedAt?: any | null, finishedAt?: any | null }>, failure?: { __typename?: 'CultureReportFailure', stage: Types.CultureReportStage, message: string } | null };

export type CultureReportProgressQueryVariables = Types.Exact<{
  campaignId: Types.Scalars['ID']['input'];
}>;


export type CultureReportProgressQuery = { __typename?: 'Query', cultureReport?: { __typename?: 'CultureReport', id: string, status: Types.CultureReportStatus, requestedAt: any, updatedAt: any, progress: Array<{ __typename?: 'CultureReportStageProgress', stage: Types.CultureReportStage, status: Types.CultureReportStageStatus, startedAt?: any | null, finishedAt?: any | null }>, failure?: { __typename?: 'CultureReportFailure', stage: Types.CultureReportStage, message: string } | null } | null };

export type CultureReportContentQueryVariables = Types.Exact<{
  campaignId: Types.Scalars['ID']['input'];
}>;


export type CultureReportContentQuery = { __typename?: 'Query', cultureReport?: { __typename?: 'CultureReport', id: string, content?: any | null, campaign: { __typename?: 'Campaign', id: string, name?: string | null, closedAt?: any | null }, entitySummaries: Array<{ __typename?: 'CultureEntitySummary', id: string, entityType: Types.CultureEntityType, entityName: string, content: any, generatedAt: any }> } | null };

export type CultureReportDeleteMutationVariables = Types.Exact<{
  campaignId: Types.Scalars['ID']['input'];
}>;


export type CultureReportDeleteMutation = { __typename?: 'Mutation', cultureReportDelete: boolean };

export type CultureReportGenerateMutationVariables = Types.Exact<{
  campaignId: Types.Scalars['ID']['input'];
  input?: Types.InputMaybe<Types.CultureReportGenerateInput>;
}>;


export type CultureReportGenerateMutation = { __typename?: 'Mutation', cultureReportGenerate: { __typename?: 'CultureReportMutationResult', cultureReport?: { __typename?: 'CultureReport', id: string, status: Types.CultureReportStatus, requestedAt: any, updatedAt: any, progress: Array<{ __typename?: 'CultureReportStageProgress', stage: Types.CultureReportStage, status: Types.CultureReportStageStatus, startedAt?: any | null, finishedAt?: any | null }>, failure?: { __typename?: 'CultureReportFailure', stage: Types.CultureReportStage, message: string } | null } | null, errors: Array<{ __typename?: 'CultureReportMutationError', message: string, code: Types.CultureReportMutationErrorCode }> } };

export type FetchDevelopPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchDevelopPermissionsQuery = { __typename?: 'Query', permissions?: { __typename?: 'Permission', learningPortal?: boolean | null } | null };

export type GetFeedbackThemesQueryVariables = Types.Exact<{
  campaignSk: Types.Scalars['String']['input'];
}>;


export type GetFeedbackThemesQuery = { __typename?: 'Query', feedbackThemes?: Array<{ __typename?: 'FeedbackTheme', id: string, title?: string | null, summary?: string | null, processed: boolean, isNoise: boolean, intents: Array<{ __typename?: 'FeedbackSentimentIntent', id?: string | null, topic?: string | null, summary?: string | null, sentiment?: string | null }>, originalFeedbackSks: Array<{ __typename?: 'OriginalFeedbackReference', sk: string, index: number }> }> | null };

export type MyGroupMembersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyGroupMembersQuery = { __typename?: 'Query', myGroupMembers?: Array<{ __typename?: 'GroupMember', memberId: string, organisationId: string, groupId: string, memberType?: Types.MemberType | null, role?: Types.GroupRole | null, roleDisplayName?: string | null } | null> | null };

export type GetHirePipelineListingsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ListingFilter>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetHirePipelineListingsQuery = { __typename?: 'Query', listings: { __typename?: 'ListingsResult', items: Array<{ __typename?: 'Listing', id: string, title?: string | null, applicantCounts: { __typename?: 'ApplicantsCounts', new: number, actionPending: number, stages: Array<{ __typename?: 'ApplicantStageCount', stageId?: string | null, count: number }>, completed: Array<{ __typename?: 'ApplicantCompletedCount', type: string, count: number }> } }>, pageInfo: { __typename?: 'PageInfo', page: number, pageSize: number, totalItems: number, totalPages: number } } };

export type GetHirePipelineStageApplicantsQueryVariables = Types.Exact<{
  filter: Types.ApplicantFilter;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetHirePipelineStageApplicantsQuery = { __typename?: 'Query', applicants: { __typename?: 'ApplicantsResult', items: Array<{ __typename?: 'Applicant', id: string, listingId: string, name?: string | null, applicationCreatedAt?: any | null, unsuccessful?: boolean | null, stage?: { __typename?: 'ApplicationStage', id: string } | null }>, pageInfo: { __typename?: 'PageInfo', totalItems: number } } };

export type UpdateListingScoreWeightsMutationVariables = Types.Exact<{
  listingId: Types.Scalars['ID']['input'];
  input: Types.ListingScoreWeightsUpdateInput;
}>;


export type UpdateListingScoreWeightsMutation = { __typename?: 'Mutation', listingScoreWeightsUpdate: { __typename?: 'ListingScoreWeightsMutationResult', listingScoreWeights?: { __typename?: 'ListingScoreWeights', skills?: number | null, assessments?: number | null, qualifications?: number | null } | null, errors: Array<{ __typename?: 'ListingScoreWeightsMutationError', message: string, code: Types.ListingScoreWeightsMutationErrorCode }> } };

export type GetMessageTemplatesQueryVariables = Types.Exact<{
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetMessageTemplatesQuery = { __typename?: 'Query', messageTemplates?: Array<{ __typename?: 'MessageTemplate', id?: string | null, organisationId?: string | null, name?: string | null, description?: string | null, subject?: string | null, content?: string | null, enabled?: boolean | null } | null> | null };

export type OfferCoreFieldsFragment = { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } };

export type OfferFieldsFragment = { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } };

export type GetOfferQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
}>;


export type GetOfferQuery = { __typename?: 'Query', offer?: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } | null };

export type GetOfferActivityQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
}>;


export type GetOfferActivityQuery = { __typename?: 'Query', offer?: { __typename?: 'Offer', id: string, activity: Array<{ __typename?: 'ActivityLogEntry', id: string, action: string, actor: string, details?: string | null, timestamp: string, actorUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> } | null };

export type OfferStartMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  input?: Types.InputMaybe<Types.OfferDetailsInput>;
}>;


export type OfferStartMutation = { __typename?: 'Mutation', offerStart: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferSaveDetailsMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  input: Types.OfferDetailsInput;
}>;


export type OfferSaveDetailsMutation = { __typename?: 'Mutation', offerSaveDetails: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalStartMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
}>;


export type OfferApprovalStartMutation = { __typename?: 'Mutation', offerApprovalStart: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalSubmitMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  input: Types.OfferApprovalSubmitInput;
}>;


export type OfferApprovalSubmitMutation = { __typename?: 'Mutation', offerApprovalSubmit: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalApproveMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OfferApprovalApproveMutation = { __typename?: 'Mutation', offerApprovalApprove: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalDeclineMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  comment: Types.Scalars['String']['input'];
}>;


export type OfferApprovalDeclineMutation = { __typename?: 'Mutation', offerApprovalDecline: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalResubmitMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  amendmentsSummary?: Types.InputMaybe<Types.Scalars['String']['input']>;
  input: Types.OfferApprovalSubmitInput;
}>;


export type OfferApprovalResubmitMutation = { __typename?: 'Mutation', offerApprovalResubmit: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalWithdrawMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
}>;


export type OfferApprovalWithdrawMutation = { __typename?: 'Mutation', offerApprovalWithdraw: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalAddApproverMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
  approvalTypes: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type OfferApprovalAddApproverMutation = { __typename?: 'Mutation', offerApprovalAddApprover: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type OfferApprovalRemoveApproverMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type OfferApprovalRemoveApproverMutation = { __typename?: 'Mutation', offerApprovalRemoveApprover: { __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } } };

export type GetMyOfferApprovalsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyOfferApprovalsQuery = { __typename?: 'Query', myOfferApprovals: Array<{ __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, documents: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileKey?: string | null, previewFileKey?: string | null, previewStatus?: Types.OfferDocumentPreviewStatus | null, messageId?: string | null, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }>, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } }> };

export type GetOfferApprovalsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOfferApprovalsQuery = { __typename?: 'Query', offerApprovals: Array<{ __typename?: 'Offer', id: string, reference: string, organisationId: string, applicationId: string, status: Types.OfferStatus, editable: boolean, documentationUnlocked: boolean, createdAt: any, updatedAt?: any | null, application: { __typename?: 'Application', id: string, listing: { __typename?: 'Listing', id: string }, applicant?: { __typename?: 'Applicant', id: string, name?: string | null } | null }, jobDetails?: { __typename?: 'OfferJobDetails', jobTitle: string, jobTitleId?: string | null, reportingManager?: string | null, startDate?: string | null, employmentType?: Types.OfferEmploymentType | null, workLocation?: string | null, workSetting?: Types.OfferWorkSetting | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'OfferCompensation', currency: string, baseSalaryMin?: number | null, baseSalaryMax?: number | null, salaryPeriod?: Types.OfferSalaryPeriod | null, paymentSchedule?: Types.OfferPaymentSchedule | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, approvalToHire?: { __typename?: 'OfferApproval', status: Types.OfferApprovalStatus, approvalMode: Types.OfferApprovalMode, supportingNotes?: string | null, amendmentsSummary?: string | null, submittedAt?: string | null, headcount?: { __typename?: 'OfferHeadcount', fte: number, requestType: Types.OfferRequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null, positionNumber?: string | null } | null, approvers: Array<{ __typename?: 'OfferApprover', approvalTypes: Array<string>, decision: Types.OfferApproverDecision, turn: Types.OfferApproverTurn, comment?: string | null, decidedAt?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, supportingDocuments: Array<{ __typename?: 'OfferFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, submittedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, permissions: { __typename?: 'OfferPermissions', view: boolean, manage: boolean, approve: boolean } }> };

export type GetOfferEligibleApproversQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOfferEligibleApproversQuery = { __typename?: 'Query', offerEligibleApprovers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> };

export type GetOfferApprovalConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOfferApprovalConfigQuery = { __typename?: 'Query', offerApprovalConfig?: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } | null };

export type OfferApprovalConfigFieldsFragment = { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> };

export type OfferApprovalConfigSetEnabledMutationVariables = Types.Exact<{
  enabled: Types.Scalars['Boolean']['input'];
}>;


export type OfferApprovalConfigSetEnabledMutation = { __typename?: 'Mutation', offerApprovalConfigSetEnabled: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type OfferApprovalTypeAddMutationVariables = Types.Exact<{
  label: Types.Scalars['String']['input'];
}>;


export type OfferApprovalTypeAddMutation = { __typename?: 'Mutation', offerApprovalTypeAdd: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type OfferApprovalTypeRemoveMutationVariables = Types.Exact<{
  label: Types.Scalars['String']['input'];
}>;


export type OfferApprovalTypeRemoveMutation = { __typename?: 'Mutation', offerApprovalTypeRemove: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type OfferApprovalConfigSetCandidateSectionMutationVariables = Types.Exact<{
  section: Types.OfferCandidateSection;
  visible: Types.Scalars['Boolean']['input'];
}>;


export type OfferApprovalConfigSetCandidateSectionMutation = { __typename?: 'Mutation', offerApprovalConfigSetCandidateSection: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type OfferApproverAddMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type OfferApproverAddMutation = { __typename?: 'Mutation', offerApproverAdd: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type OfferApproverRemoveMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type OfferApproverRemoveMutation = { __typename?: 'Mutation', offerApproverRemove: { __typename?: 'OfferApprovalConfig', enabled: boolean, approvalTypes: Array<string>, hiddenCandidateSections: Array<Types.OfferCandidateSection>, approvers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type GetOfferDocumentTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOfferDocumentTypesQuery = { __typename?: 'Query', offerDocumentTypes: Array<{ __typename?: 'OfferDocumentType', id: string, name: string }> };

export type GetOfferDocumentTemplatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOfferDocumentTemplatesQuery = { __typename?: 'Query', offerDocumentTemplates: Array<{ __typename?: 'OfferDocumentTemplate', id: string, name: string, documentTypeId: string, fileName: string, updatedAt: any }> };

export type GetOfferDocumentPackagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOfferDocumentPackagesQuery = { __typename?: 'Query', offerDocumentPackages: Array<{ __typename?: 'OfferDocumentPackage', id: string, name: string, description?: string | null, templateIds: Array<string> }> };

export type OfferDocumentTypeCreateMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type OfferDocumentTypeCreateMutation = { __typename?: 'Mutation', offerDocumentTypeCreate: { __typename?: 'OfferDocumentType', id: string, name: string } };

export type OfferDocumentTypeRemoveMutationVariables = Types.Exact<{
  documentTypeId: Types.Scalars['ID']['input'];
}>;


export type OfferDocumentTypeRemoveMutation = { __typename?: 'Mutation', offerDocumentTypeRemove: Array<{ __typename?: 'OfferDocumentType', id: string, name: string }> };

export type OfferDocumentTemplateCreateMutationVariables = Types.Exact<{
  input: Types.OfferDocumentTemplateCreateInput;
}>;


export type OfferDocumentTemplateCreateMutation = { __typename?: 'Mutation', offerDocumentTemplateCreate: { __typename?: 'OfferDocumentTemplate', id: string, name: string, documentTypeId: string, fileName: string, updatedAt: any } };

export type OfferDocumentTemplateRemoveMutationVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type OfferDocumentTemplateRemoveMutation = { __typename?: 'Mutation', offerDocumentTemplateRemove: Array<{ __typename?: 'OfferDocumentTemplate', id: string, name: string, documentTypeId: string, fileName: string, updatedAt: any }> };

export type OfferDocumentPackageCreateMutationVariables = Types.Exact<{
  input: Types.OfferDocumentPackageInput;
}>;


export type OfferDocumentPackageCreateMutation = { __typename?: 'Mutation', offerDocumentPackageCreate: { __typename?: 'OfferDocumentPackage', id: string, name: string, description?: string | null, templateIds: Array<string> } };

export type OfferDocumentPackageUpdateMutationVariables = Types.Exact<{
  packageId: Types.Scalars['ID']['input'];
  input: Types.OfferDocumentPackageInput;
}>;


export type OfferDocumentPackageUpdateMutation = { __typename?: 'Mutation', offerDocumentPackageUpdate: { __typename?: 'OfferDocumentPackage', id: string, name: string, description?: string | null, templateIds: Array<string> } };

export type OfferDocumentPackageRemoveMutationVariables = Types.Exact<{
  packageId: Types.Scalars['ID']['input'];
}>;


export type OfferDocumentPackageRemoveMutation = { __typename?: 'Mutation', offerDocumentPackageRemove: Array<{ __typename?: 'OfferDocumentPackage', id: string, name: string, description?: string | null, templateIds: Array<string> }> };

export type OfferDocumentFieldsFragment = { __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null };

export type OfferDocumentAddFromUploadMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  input: Types.OfferDocumentUploadInput;
}>;


export type OfferDocumentAddFromUploadMutation = { __typename?: 'Mutation', offerDocumentAddFromUpload: { __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type OfferDocumentAddFromTemplateMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  templateId: Types.Scalars['ID']['input'];
}>;


export type OfferDocumentAddFromTemplateMutation = { __typename?: 'Mutation', offerDocumentAddFromTemplate: { __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type OfferDocumentAddFromPackageMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  packageId: Types.Scalars['ID']['input'];
}>;


export type OfferDocumentAddFromPackageMutation = { __typename?: 'Mutation', offerDocumentAddFromPackage: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type OfferDocumentMarkSentMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  documentId: Types.Scalars['ID']['input'];
  messageId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OfferDocumentMarkSentMutation = { __typename?: 'Mutation', offerDocumentMarkSent: { __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type OfferDocumentRemoveMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  documentId: Types.Scalars['ID']['input'];
}>;


export type OfferDocumentRemoveMutation = { __typename?: 'Mutation', offerDocumentRemove: Array<{ __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type OfferDocumentAddToRepositoryMutationVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  input: Types.OfferDocumentUploadInput;
}>;


export type OfferDocumentAddToRepositoryMutation = { __typename?: 'Mutation', offerDocumentAddToRepository: { __typename?: 'OfferDocument', id: string, category: Types.OfferDocumentCategory, documentTypeId: string, documentTypeName: string, source: Types.OfferDocumentSource, templateId?: string | null, packageId?: string | null, fileName: string, fileSizeBytes?: number | null, generationStatus: Types.OfferDocumentGenerationStatus, generationError?: string | null, signatureStatus: Types.OfferSignatureStatus, sentAt?: string | null, sentBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type GetOfferDocumentDownloadUrlQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  fileKey: Types.Scalars['String']['input'];
  fileName?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOfferDocumentDownloadUrlQuery = { __typename?: 'Query', offerDocumentDownloadUrl?: string | null };

export type GetOfferCandidateContextQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['ID']['input'];
  listingId: Types.Scalars['ID']['input'];
}>;


export type GetOfferCandidateContextQuery = { __typename?: 'Query', application?: { __typename?: 'Application', id: string, applicant?: { __typename?: 'Applicant', id: string } | null } | null, listing?: { __typename?: 'Listing', id: string, applicantCounts: { __typename?: 'ApplicantsCounts', total: number, direct: number } } | null };

export type GetListingRequisitionIdQueryVariables = Types.Exact<{
  listingId: Types.Scalars['ID']['input'];
}>;


export type GetListingRequisitionIdQuery = { __typename?: 'Query', listing?: { __typename?: 'Listing', id: string, requisitionId?: string | null } | null };

export type GetRequisitionForPrefillQueryVariables = Types.Exact<{
  requisitionId: Types.Scalars['ID']['input'];
}>;


export type GetRequisitionForPrefillQuery = { __typename?: 'Query', requisition?: { __typename?: 'Requisition', id: string, reference?: string | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null } | null };

export type PersonalityAssessmentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PersonalityAssessmentQuery = { __typename?: 'Query', personalityAssessment?: { __typename?: 'PersonalityAssessment', id?: string | null, result: string, characteristics: Array<string | null>, catchPhrase: string, answers: Array<{ __typename?: 'PersonalityAssessmentAnswer', questionId: string, answer: string }> } | null };

export type PersonalityAssessmentSaveAnswersMutationVariables = Types.Exact<{
  input: Types.PersonalityAssessmentAnswersInput;
}>;


export type PersonalityAssessmentSaveAnswersMutation = { __typename?: 'Mutation', personalityAssessmentSaveAnswers?: { __typename?: 'PersonalityAssessment', id?: string | null } | null };

export type PersonalityAssessmentInviteMembersMutationVariables = Types.Exact<{
  input: Types.PersonalityAssessmentInviteMembersInput;
}>;


export type PersonalityAssessmentInviteMembersMutation = { __typename?: 'Mutation', personalityAssessmentInviteMembers?: { __typename?: 'PersonalityAssessmentInviteMembers', error?: string | null } | null };

export type GetPersonalityResultsQueriesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Array<Types.InputMaybe<Types.PersonalityResultsQueryInput>> | Types.InputMaybe<Types.PersonalityResultsQueryInput>>;
}>;


export type GetPersonalityResultsQueriesQuery = { __typename?: 'Query', personalityResults?: Array<{ __typename?: 'PersonalityAssessmentResult', personalityType?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, completedDate?: string | null, division?: string | null, jobTitle?: string | null } | null> | null };

export type GetInsightsMutationVariables = Types.Exact<{
  input: Types.PersonalityInsightsInput;
}>;


export type GetInsightsMutation = { __typename?: 'Mutation', getInsights?: { __typename?: 'PersonalityInsights', distributionType?: string | null, distributionTypeSummary?: string | null, teamSummary?: string | null, mergedSummaries?: string | null, headline?: string | null } | null };

export type GetRequisitionsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.RequisitionFilter>;
}>;


export type GetRequisitionsQuery = { __typename?: 'Query', requisitions: { __typename?: 'RequisitionsResult', items: Array<{ __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, approvalMode: Types.ApprovalMode, createdAt?: any | null, updatedAt?: any | null, headcount?: { __typename?: 'Headcount', fte: number } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, division?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', page: number, pageSize: number, totalItems: number, totalPages: number } } };

export type GetRequisitionDocumentDownloadUrlQueryVariables = Types.Exact<{
  requisitionId: Types.Scalars['ID']['input'];
  fileKey: Types.Scalars['ID']['input'];
}>;


export type GetRequisitionDocumentDownloadUrlQuery = { __typename?: 'Query', requisitionDocumentDownloadUrl?: string | null };

export type RequisitionDetailFieldsFragment = { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } };

export type GetMyApprovalsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyApprovalsQuery = { __typename?: 'Query', myApprovals: Array<{ __typename?: 'ApprovalItem', id: string, type: Types.ApprovalItemType, status: string, createdAt?: any | null, actionable: boolean, position?: number | null, requestedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, requisition?: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } | null }> };

export type GetApprovalsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetApprovalsQuery = { __typename?: 'Query', approvals: Array<{ __typename?: 'ApprovalItem', id: string, type: Types.ApprovalItemType, status: string, createdAt?: any | null, actionable: boolean, position?: number | null, requestedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, requisition?: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } | null }> };

export type ApproveRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ApproveRequisitionMutation = { __typename?: 'Mutation', approveRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type DeclineRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DeclineRequisitionMutation = { __typename?: 'Mutation', declineRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type GetApproverCandidatesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetApproverCandidatesQuery = { __typename?: 'Query', eligibleApprovers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }>, orgUsers: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> };

export type CreateRequisitionMutationVariables = Types.Exact<{
  input: Types.RequisitionInput;
}>;


export type CreateRequisitionMutation = { __typename?: 'Mutation', createRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type SaveRequisitionDraftMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.RequisitionInput;
}>;


export type SaveRequisitionDraftMutation = { __typename?: 'Mutation', saveRequisitionDraft: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type SubmitRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SubmitRequisitionMutation = { __typename?: 'Mutation', submitRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type GetRequisitionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetRequisitionQuery = { __typename?: 'Query', requisition?: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } | null };

export type GetRequisitionActivityQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetRequisitionActivityQuery = { __typename?: 'Query', requisition?: { __typename?: 'Requisition', id: string, activity: Array<{ __typename?: 'ActivityLogEntry', id: string, action: string, actor: string, details?: string | null, timestamp: string, actorUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> } | null };

export type GetLinkedJobHiredCountsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetLinkedJobHiredCountsQuery = { __typename?: 'Query', requisition?: { __typename?: 'Requisition', id: string, linkedJobs: Array<{ __typename?: 'Listing', id: string, applicantCounts: { __typename?: 'ApplicantsCounts', completed: Array<{ __typename?: 'ApplicantCompletedCount', type: string, count: number }> } }> } | null };

export type UpdateApprovedRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.RequisitionInput;
}>;


export type UpdateApprovedRequisitionMutation = { __typename?: 'Mutation', updateApprovedRequisition: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } };

export type AddApproverToRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  approver: Types.ApproverInput;
}>;


export type AddApproverToRequisitionMutation = { __typename?: 'Mutation', addApproverToRequisition: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } };

export type SetRequisitionApproversMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  approvers: Array<Types.ApproverInput> | Types.ApproverInput;
}>;


export type SetRequisitionApproversMutation = { __typename?: 'Mutation', setRequisitionApprovers: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } };

export type RemoveApproverFromRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
}>;


export type RemoveApproverFromRequisitionMutation = { __typename?: 'Mutation', removeApproverFromRequisition: { __typename?: 'Requisition', id: string, reference?: string | null, status: Types.RequisitionStatus, archived: boolean, createdAt?: any | null, updatedAt?: any | null, supportingNotes?: string | null, amendmentsSummary?: string | null, approvalMode: Types.ApprovalMode, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, headcount?: { __typename?: 'Headcount', fte: number, requestType: Types.RequestType, replacingWho?: string | null, unplannedReason?: string | null, budgetNotes?: string | null } | null, jobDetails?: { __typename?: 'JobDetails', jobTitle: string, jobTitleId?: string | null, hiringTeamId?: string | null, hiringTeamName?: string | null, employmentType: string, reportingManager?: string | null, idealStartDate?: string | null, workLocation?: string | null, workSetting?: string | null, division?: string | null, costCentre?: string | null } | null, compensation?: { __typename?: 'Compensation', currency: string, baseSalaryMin: number, baseSalaryMax: number, salaryPeriod: string, paymentSchedule?: string | null, superannuation?: string | null, salaryConditions?: string | null, bonuses?: string | null, commission?: string | null, otherCompensation?: string | null, benefits?: string | null } | null, recruitmentStrategy?: { __typename?: 'RecruitmentStrategy', strategy?: string | null, estimatedCost?: number | null } | null, positionDescription?: { __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null } | null, supportingDocuments: Array<{ __typename?: 'RequisitionFile', fileName: string, fileKey: string, fileSizeBytes?: number | null }>, approvers: Array<{ __typename?: 'Approver', approvalTypes: Array<string>, decision: Types.ApproverDecision, comment?: string | null, decidedAt?: string | null, position: number, turn: Types.ApproverTurn, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }>, linkedJobs: Array<{ __typename?: 'Listing', id: string, title?: string | null, status: Types.ListingStatus, createdAt?: any | null }>, permissions: { __typename?: 'RequisitionPermissions', view: boolean, manage: boolean, createJob: boolean, approve: boolean } } };

export type WithdrawRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type WithdrawRequisitionMutation = { __typename?: 'Mutation', withdrawRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type SetRequisitionArchivedMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  archived: Types.Scalars['Boolean']['input'];
}>;


export type SetRequisitionArchivedMutation = { __typename?: 'Mutation', setRequisitionArchived: { __typename?: 'Requisition', id: string, archived: boolean } };

export type CloseRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CloseRequisitionMutation = { __typename?: 'Mutation', closeRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type ReopenRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ReopenRequisitionMutation = { __typename?: 'Mutation', reopenRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type DeleteRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteRequisitionMutation = { __typename?: 'Mutation', deleteRequisition: boolean };

export type ResubmitRequisitionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  amendmentsSummary: Types.Scalars['String']['input'];
  input?: Types.InputMaybe<Types.RequisitionInput>;
}>;


export type ResubmitRequisitionMutation = { __typename?: 'Mutation', resubmitRequisition: { __typename?: 'Requisition', id: string, status: Types.RequisitionStatus } };

export type ShareCultureReportMutationVariables = Types.Exact<{
  input: Types.SharePageInput;
}>;


export type ShareCultureReportMutation = { __typename?: 'Mutation', shareCultureReport?: { __typename?: 'SharePage', link?: string | null } | null };

export type ExpireShareLinkMutationVariables = Types.Exact<{
  sk: Types.Scalars['String']['input'];
}>;


export type ExpireShareLinkMutation = { __typename?: 'Mutation', expireShareLink?: string | null };

export type SharePageLinksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SharePageLinksQuery = { __typename?: 'Query', sharePageLinks?: Array<{ __typename?: 'SharePage', sk?: string | null, dateShared?: string | null, link?: string | null, title?: string | null, expiryDate?: string | null, sharer?: string | null, sharerEmail?: string | null, shareContent?: string | null, type?: string | null } | null> | null };

export type TagActivityActionedByUserFieldsFragment = { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } };

export type FetchTagActivitiesWithoutHistoryQueryVariables = Types.Exact<{
  filter: Types.TagActivityFilter;
}>;


export type FetchTagActivitiesWithoutHistoryQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', id: string, action: Types.TagActivityAction, tag: { __typename: 'OrganisationTag', id: string, label?: string | null } | { __typename: 'SystemTag', id: string }, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, targetApplicant?: { __typename?: 'Applicant', candidateId: string } | null }> };

export type FetchOrganisationTagActivitiesQueryVariables = Types.Exact<{
  filter: Types.TagActivityFilter;
}>;


export type FetchOrganisationTagActivitiesQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', id: string, notes?: string | null, action: Types.TagActivityAction, tag: { __typename: 'OrganisationTag', id: string, label?: string | null } | { __typename: 'SystemTag' }, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, targetApplicant?: { __typename?: 'Applicant', candidateId: string } | null }> };

export type FetchApplicantTagActivitiesQueryVariables = Types.Exact<{
  filter: Types.TagActivityFilter;
}>;


export type FetchApplicantTagActivitiesQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', id: string, action: Types.TagActivityAction, notes?: string | null, tag: { __typename: 'OrganisationTag', id: string, label?: string | null, assignedCount?: number | null } | { __typename: 'SystemTag', id: string }, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null, targetApplicant?: { __typename?: 'Applicant', candidateId: string } | null, history: Array<{ __typename?: 'TagActivityHistory', action: Types.TagActivityAction, notes?: string | null, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null }> }> };

export type FetchOrganisationTagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchOrganisationTagsQuery = { __typename?: 'Query', organisationTags: Array<{ __typename?: 'OrganisationTag', id: string, label?: string | null, tagCategory?: string | null, assignedCount?: number | null }> };

export type SystemTagActivitySetMutationVariables = Types.Exact<{
  input: Types.SystemTagActivityInput;
}>;


export type SystemTagActivitySetMutation = { __typename?: 'Mutation', systemTagActivitySet?: { __typename?: 'TagActivityMutationResult', tagActivity?: { __typename?: 'TagActivity', id: string, action: Types.TagActivityAction, tag: { __typename?: 'OrganisationTag' } | { __typename?: 'SystemTag', id: string, label?: string | null }, targetApplicant?: { __typename?: 'Applicant', listingId: string, candidateId: string } | null, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type OrganisationTagCreateMutationVariables = Types.Exact<{
  input: Types.OrganisationTagCreateInput;
}>;


export type OrganisationTagCreateMutation = { __typename?: 'Mutation', organisationTagCreate?: { __typename?: 'OrganisationTagMutationResult', tag?: { __typename: 'OrganisationTag', id: string, label?: string | null } | { __typename: 'SystemTag' } | null, errors: Array<{ __typename?: 'CreateTagError', message?: string | null, code?: Types.CreateTagErrorCode | null }> } | null };

export type OrganisationTagActivitySetMutationVariables = Types.Exact<{
  input: Types.OrganisationTagActivityInput;
}>;


export type OrganisationTagActivitySetMutation = { __typename?: 'Mutation', organisationTagActivitySet?: { __typename?: 'OrganisationTagActivityMutationResult', tagActivities?: Array<{ __typename?: 'TagActivity', id: string, notes?: string | null, action: Types.TagActivityAction, tag: { __typename?: 'OrganisationTag', id: string, label?: string | null } | { __typename?: 'SystemTag', id: string, label?: string | null }, targetApplicant?: { __typename?: 'Applicant', listingId: string, candidateId: string } | null, actionedByUser?: { __typename?: 'TagActivityActionedByUser', timestamp?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null } | null> | null, errors: Array<{ __typename?: 'TagActivityMutationError', message?: string | null }> } | null };

export type DeleteOrganisationTagMutationVariables = Types.Exact<{
  input: Types.DeleteOrganisationTagInput;
}>;


export type DeleteOrganisationTagMutation = { __typename?: 'Mutation', deleteOrganisationTag?: { __typename?: 'DeleteOrganisationTagMutationResult', tag?: { __typename: 'OrganisationTag', id: string, label?: string | null } | null, errors?: Array<{ __typename?: 'DeleteOrganisationTagMutationError', message?: string | null } | null> | null } | null };

export type GetHirePipelineTagActivitiesQueryVariables = Types.Exact<{
  listingIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type GetHirePipelineTagActivitiesQuery = { __typename?: 'Query', tagActivities: Array<{ __typename?: 'TagActivity', id: string, action: Types.TagActivityAction, targetApplicant?: { __typename?: 'Applicant', id: string, candidateId: string, listingId: string, name?: string | null } | null, tag: { __typename?: 'OrganisationTag', id: string, label?: string | null } | { __typename?: 'SystemTag', id: string, label?: string | null } }> };

export type GetTeamMembersQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetTeamMembersQuery = { __typename?: 'Query', teams: { __typename?: 'TeamsResult', items: Array<{ __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'TeamMember', employer?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }> }>, pageInfo: { __typename?: 'PageInfo', totalPages: number } } };

export type CreateUploadRequestMutationVariables = Types.Exact<{
  input: Types.CreateUploadRequestInput;
}>;


export type CreateUploadRequestMutation = { __typename?: 'Mutation', createUploadRequest?: { __typename?: 'UploadRequest', id: string, uploadUrl: string, downloadUrl: string } | null };

export const BusinessProfileFieldsFragmentDoc = gql`
    fragment BusinessProfileFields on BusinessProfile {
  id
  source
  researchedAt
  identity {
    industry
    founded
    scale
    workModel
    locations
    reach
  }
  purpose {
    mission
    vision
    values {
      name
      meaning
    }
  }
  goals
  lifecycle {
    stage
    stageOther
    descriptor {
      stage
      order
      label
      subtitle
      goal
      focus
      challenge
    }
  }
  structure {
    shape
  }
  leader {
    user {
      id
      name
      jobTitle
    }
    personality {
      hasProfile
      personalityType
      traits
      completedAt
    }
  }
  leadershipTeam {
    user {
      id
      name
      jobTitle
    }
    personality {
      hasProfile
      personalityType
    }
  }
  updatedAt
}
    `;
export const CultureReportProgressFieldsFragmentDoc = gql`
    fragment CultureReportProgressFields on CultureReport {
  id
  status
  progress {
    stage
    status
    startedAt
    finishedAt
  }
  failure {
    stage
    message
  }
  requestedAt
  updatedAt
}
    `;
export const OfferCoreFieldsFragmentDoc = gql`
    fragment OfferCoreFields on Offer {
  id
  reference
  organisationId
  applicationId
  status
  jobDetails {
    jobTitle
    jobTitleId
    reportingManager
    startDate
    employmentType
    workLocation
    workSetting
    division
    costCentre
  }
  compensation {
    currency
    baseSalaryMin
    baseSalaryMax
    salaryPeriod
    paymentSchedule
    superannuation
    salaryConditions
    bonuses
    commission
    otherCompensation
    benefits
  }
  approvalToHire {
    status
    approvalMode
    headcount {
      fte
      requestType
      replacingWho
      unplannedReason
      budgetNotes
      positionNumber
    }
    approvers {
      user {
        id
        firstName
        lastName
        email
      }
      approvalTypes
      decision
      turn
      comment
      decidedAt
    }
    supportingNotes
    supportingDocuments {
      fileName
      fileKey
      fileSizeBytes
    }
    amendmentsSummary
    submittedAt
    submittedBy {
      id
      firstName
      lastName
      email
    }
  }
  permissions {
    view
    manage
    approve
  }
  editable
  documentationUnlocked
  createdAt
  updatedAt
}
    `;
export const OfferFieldsFragmentDoc = gql`
    fragment OfferFields on Offer {
  ...OfferCoreFields
  documents {
    id
    category
    documentTypeId
    documentTypeName
    source
    templateId
    packageId
    fileName
    fileKey
    previewFileKey
    previewStatus
    messageId
    fileSizeBytes
    generationStatus
    generationError
    signatureStatus
    sentAt
    sentBy {
      id
      firstName
      lastName
      email
    }
  }
}
    ${OfferCoreFieldsFragmentDoc}`;
export const OfferApprovalConfigFieldsFragmentDoc = gql`
    fragment OfferApprovalConfigFields on OfferApprovalConfig {
  enabled
  approvalTypes
  hiddenCandidateSections
  approvers {
    id
    firstName
    lastName
    email
  }
}
    `;
export const OfferDocumentFieldsFragmentDoc = gql`
    fragment OfferDocumentFields on OfferDocument {
  id
  category
  documentTypeId
  documentTypeName
  source
  templateId
  packageId
  fileName
  fileSizeBytes
  generationStatus
  generationError
  signatureStatus
  sentAt
  sentBy {
    id
    firstName
    lastName
    email
  }
}
    `;
export const RequisitionDetailFieldsFragmentDoc = gql`
    fragment RequisitionDetailFields on Requisition {
  id
  reference
  status
  archived
  createdAt
  updatedAt
  supportingNotes
  amendmentsSummary
  approvalMode
  requester {
    id
    firstName
    lastName
    email
  }
  headcount {
    fte
    requestType
    replacingWho
    unplannedReason
    budgetNotes
  }
  jobDetails {
    jobTitle
    jobTitleId
    hiringTeamId
    hiringTeamName
    employmentType
    reportingManager
    idealStartDate
    workLocation
    workSetting
    division
    costCentre
  }
  compensation {
    currency
    baseSalaryMin
    baseSalaryMax
    salaryPeriod
    paymentSchedule
    superannuation
    salaryConditions
    bonuses
    commission
    otherCompensation
    benefits
  }
  recruitmentStrategy {
    strategy
    estimatedCost
  }
  positionDescription {
    fileName
    fileKey
    fileSizeBytes
  }
  supportingDocuments {
    fileName
    fileKey
    fileSizeBytes
  }
  approvers {
    user {
      id
      firstName
      lastName
      email
    }
    approvalTypes
    decision
    comment
    decidedAt
    position
    turn
  }
  linkedJobs {
    id
    title
    status
    createdAt
  }
  permissions {
    view
    manage
    createJob
    approve
  }
}
    `;
export const TagActivityActionedByUserFieldsFragmentDoc = gql`
    fragment TagActivityActionedByUserFields on TagActivityActionedByUser {
  user {
    id
    firstName
    lastName
  }
  timestamp
}
    `;
export const FetchApplicantCvSummaryDocument = gql`
    query FetchApplicantCvSummary($id: ID!) {
  applicant(id: $id) {
    id
    protectedProfile {
      candidateId
      summaryId
      summary
    }
  }
}
    `;

/**
 * __useFetchApplicantCvSummaryQuery__
 *
 * To run a query within a React component, call `useFetchApplicantCvSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantCvSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantCvSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantCvSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables> & ({ variables: FetchApplicantCvSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>(FetchApplicantCvSummaryDocument, options);
      }
export function useFetchApplicantCvSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>(FetchApplicantCvSummaryDocument, options);
        }
// @ts-ignore
export function useFetchApplicantCvSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>;
export function useFetchApplicantCvSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantCvSummaryQuery | undefined, FetchApplicantCvSummaryQueryVariables>;
export function useFetchApplicantCvSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>(FetchApplicantCvSummaryDocument, options);
        }
export type FetchApplicantCvSummaryQueryHookResult = ReturnType<typeof useFetchApplicantCvSummaryQuery>;
export type FetchApplicantCvSummaryLazyQueryHookResult = ReturnType<typeof useFetchApplicantCvSummaryLazyQuery>;
export type FetchApplicantCvSummarySuspenseQueryHookResult = ReturnType<typeof useFetchApplicantCvSummarySuspenseQuery>;
export type FetchApplicantCvSummaryQueryResult = Apollo.QueryResult<FetchApplicantCvSummaryQuery, FetchApplicantCvSummaryQueryVariables>;
export const FetchApplicantsListDocument = gql`
    query FetchApplicantsList($filter: ApplicantFilter!, $pagination: Pagination) {
  applicants(filter: $filter, pagination: $pagination) {
    items {
      id
      rank
      name
      candidateId
      isNew
      unsuccessful
      previouslyApplied
      salaryMatch
      locationMatch
      preScreeningMatch
      applicationCreatedAt
      scores {
        total
        qualifications
        skills
        assessments
      }
      location {
        city
        state
        country
      }
      hiredForListing {
        id
      }
      stage {
        id
        name
      }
      status {
        invited
      }
      profile {
        latestJob {
          title
          company
        }
        cvId
        prePopulate {
          isPrePopulated
          userConfirmed
        }
      }
      application {
        id
        unavailable
        hired
        isUnsuccessful
        isNew
        isActionPending
        hiredForListing {
          id
        }
        stage {
          id
          name
        }
        source {
          referrerUrl
          name
        }
      }
    }
    pageInfo {
      page
      pageSize
      totalItems
      totalPages
    }
  }
}
    `;

/**
 * __useFetchApplicantsListQuery__
 *
 * To run a query within a React component, call `useFetchApplicantsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFetchApplicantsListQuery(baseOptions: Apollo.QueryHookOptions<FetchApplicantsListQuery, FetchApplicantsListQueryVariables> & ({ variables: FetchApplicantsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>(FetchApplicantsListDocument, options);
      }
export function useFetchApplicantsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>(FetchApplicantsListDocument, options);
        }
// @ts-ignore
export function useFetchApplicantsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>;
export function useFetchApplicantsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantsListQuery | undefined, FetchApplicantsListQueryVariables>;
export function useFetchApplicantsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>(FetchApplicantsListDocument, options);
        }
export type FetchApplicantsListQueryHookResult = ReturnType<typeof useFetchApplicantsListQuery>;
export type FetchApplicantsListLazyQueryHookResult = ReturnType<typeof useFetchApplicantsListLazyQuery>;
export type FetchApplicantsListSuspenseQueryHookResult = ReturnType<typeof useFetchApplicantsListSuspenseQuery>;
export type FetchApplicantsListQueryResult = Apollo.QueryResult<FetchApplicantsListQuery, FetchApplicantsListQueryVariables>;
export const FetchApplicantProfileDocument = gql`
    query FetchApplicantProfile($id: ID!, $withDirectRank: Boolean! = false) {
  applicant(id: $id) {
    id
    rank
    directRank @include(if: $withDirectRank)
    listingId
    candidateId
    isDirect
    previouslyApplied
    name
    firstName
    scores {
      total
      qualifications
      skills
      assessments
    }
    location {
      city
      state
      country
      match
    }
    locationMatch
    salaryMatch
    authorizedForWork
    relocationLocations {
      city
      state
      country
      authorized
      match
    }
    isNew
    unsuccessful
    removed
    hiredForListing {
      id
    }
    stage {
      id
      name
    }
    status {
      invited
    }
    preScreeningMatch
    preScreeningAnswers {
      questionId
      question
      answer
      match
    }
    skills {
      jobs {
        title
        company
        startDate
        endDate
        skills {
          id
          name
        }
      }
      skills {
        requested {
          skills {
            id
            name
          }
          importance
          requestedYears
          candidateYears
        }
        workAreaMatch {
          skill {
            id
            name
          }
          candidateYears
        }
        other {
          skill {
            id
            name
          }
          candidateYears
        }
      }
      workAreas {
        requested {
          id
          workArea {
            id
            name
          }
          match
        }
        other {
          id
          workArea {
            id
            name
          }
        }
      }
    }
    qualifications {
      requested {
        qualifications {
          id
          name
        }
        importance
        isMatch
      }
      candidate {
        qualification {
          id
          name
        }
        institution {
          id
          name
        }
        institutionName
        completed
        startedAt
        completedAt
        studying
      }
    }
    assessments {
      cultureFit {
        comparisons {
          answer {
            candidate
            listing
          }
          label {
            left
            right
          }
        }
        importance
        percentage
      }
      jobFit {
        comparisons {
          answer {
            candidate
            listing
          }
          label
        }
        importance
        percentage
      }
      personalityFit {
        importance
        percentage
        personalityTypes {
          candidate
          listing
        }
      }
    }
    application {
      id
      status
      hired
      unavailable
      incomplete
      isUnsuccessful
      hiredForListing {
        id
      }
      stage {
        id
        name
      }
      attachmentIds
    }
    profile {
      contactDetails {
        email
        phone1
      }
      latestJob {
        title
        company
      }
      workPreferences {
        types
        remote
      }
      cvId
      professionalLinks {
        url
        label
      }
      prePopulate {
        isPrePopulated
        userConfirmed
      }
    }
    listing {
      id
      title
      team {
        id
      }
      applicationStages {
        id
        name
      }
      permissions {
        setStage
        setStageToShortlistOnly
        markAsHired
        dropApplicants
        viewMessages
        inviteApplicants
        viewAllNotes
      }
    }
  }
}
    `;

/**
 * __useFetchApplicantProfileQuery__
 *
 * To run a query within a React component, call `useFetchApplicantProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withDirectRank: // value for 'withDirectRank'
 *   },
 * });
 */
export function useFetchApplicantProfileQuery(baseOptions: Apollo.QueryHookOptions<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables> & ({ variables: FetchApplicantProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>(FetchApplicantProfileDocument, options);
      }
export function useFetchApplicantProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>(FetchApplicantProfileDocument, options);
        }
// @ts-ignore
export function useFetchApplicantProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>;
export function useFetchApplicantProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantProfileQuery | undefined, FetchApplicantProfileQueryVariables>;
export function useFetchApplicantProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>(FetchApplicantProfileDocument, options);
        }
export type FetchApplicantProfileQueryHookResult = ReturnType<typeof useFetchApplicantProfileQuery>;
export type FetchApplicantProfileLazyQueryHookResult = ReturnType<typeof useFetchApplicantProfileLazyQuery>;
export type FetchApplicantProfileSuspenseQueryHookResult = ReturnType<typeof useFetchApplicantProfileSuspenseQuery>;
export type FetchApplicantProfileQueryResult = Apollo.QueryResult<FetchApplicantProfileQuery, FetchApplicantProfileQueryVariables>;
export const FetchApplicantDocumentsDocument = gql`
    query FetchApplicantDocuments($id: ID!) {
  applicant(id: $id) {
    id
    candidateId
    application {
      id
      previewAttachments {
        id
        filename
        formats {
          mimetype
          isOriginal
          downloadUrl
        }
      }
    }
    profile {
      previewCv {
        id
        filename
        formats {
          mimetype
          isOriginal
          downloadUrl
        }
      }
      previewAttachments {
        id
        filename
        formats {
          mimetype
          isOriginal
          downloadUrl
        }
      }
    }
  }
}
    `;

/**
 * __useFetchApplicantDocumentsQuery__
 *
 * To run a query within a React component, call `useFetchApplicantDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantDocumentsQuery(baseOptions: Apollo.QueryHookOptions<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables> & ({ variables: FetchApplicantDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>(FetchApplicantDocumentsDocument, options);
      }
export function useFetchApplicantDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>(FetchApplicantDocumentsDocument, options);
        }
// @ts-ignore
export function useFetchApplicantDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>;
export function useFetchApplicantDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantDocumentsQuery | undefined, FetchApplicantDocumentsQueryVariables>;
export function useFetchApplicantDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>(FetchApplicantDocumentsDocument, options);
        }
export type FetchApplicantDocumentsQueryHookResult = ReturnType<typeof useFetchApplicantDocumentsQuery>;
export type FetchApplicantDocumentsLazyQueryHookResult = ReturnType<typeof useFetchApplicantDocumentsLazyQuery>;
export type FetchApplicantDocumentsSuspenseQueryHookResult = ReturnType<typeof useFetchApplicantDocumentsSuspenseQuery>;
export type FetchApplicantDocumentsQueryResult = Apollo.QueryResult<FetchApplicantDocumentsQuery, FetchApplicantDocumentsQueryVariables>;
export const FetchApplicantHistoryDocument = gql`
    query FetchApplicantHistory($id: ID!) {
  applicant(id: $id) {
    id
    applicationHistory {
      id
      createdAt
      isUnsuccessful
      hired
      hiredForListing {
        id
      }
      candidateId
      applicant {
        id
      }
      stage {
        id
        name
      }
      listing {
        id
        title
        permissions {
          view
        }
      }
    }
  }
}
    `;

/**
 * __useFetchApplicantHistoryQuery__
 *
 * To run a query within a React component, call `useFetchApplicantHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables> & ({ variables: FetchApplicantHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>(FetchApplicantHistoryDocument, options);
      }
export function useFetchApplicantHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>(FetchApplicantHistoryDocument, options);
        }
// @ts-ignore
export function useFetchApplicantHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>;
export function useFetchApplicantHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantHistoryQuery | undefined, FetchApplicantHistoryQueryVariables>;
export function useFetchApplicantHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>(FetchApplicantHistoryDocument, options);
        }
export type FetchApplicantHistoryQueryHookResult = ReturnType<typeof useFetchApplicantHistoryQuery>;
export type FetchApplicantHistoryLazyQueryHookResult = ReturnType<typeof useFetchApplicantHistoryLazyQuery>;
export type FetchApplicantHistorySuspenseQueryHookResult = ReturnType<typeof useFetchApplicantHistorySuspenseQuery>;
export type FetchApplicantHistoryQueryResult = Apollo.QueryResult<FetchApplicantHistoryQuery, FetchApplicantHistoryQueryVariables>;
export const ApplicationsSetStageDocument = gql`
    mutation ApplicationsSetStage($ids: [ID!]!, $input: ApplicationsSetStageInput!) {
  applicationsSetStage(ids: $ids, input: $input) {
    applications {
      id
      stage {
        id
        name
      }
      hired
      isUnsuccessful
      isNew
      isActionPending
      hiredForListing {
        id
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationsSetStageMutationFn = Apollo.MutationFunction<ApplicationsSetStageMutation, ApplicationsSetStageMutationVariables>;

/**
 * __useApplicationsSetStageMutation__
 *
 * To run a mutation, you first call `useApplicationsSetStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsSetStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsSetStageMutation, { data, loading, error }] = useApplicationsSetStageMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationsSetStageMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsSetStageMutation, ApplicationsSetStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsSetStageMutation, ApplicationsSetStageMutationVariables>(ApplicationsSetStageDocument, options);
      }
export type ApplicationsSetStageMutationHookResult = ReturnType<typeof useApplicationsSetStageMutation>;
export type ApplicationsSetStageMutationResult = Apollo.MutationResult<ApplicationsSetStageMutation>;
export type ApplicationsSetStageMutationOptions = Apollo.BaseMutationOptions<ApplicationsSetStageMutation, ApplicationsSetStageMutationVariables>;
export const ApplicationHireDocument = gql`
    mutation ApplicationHire($id: ID!) {
  applicationHire(id: $id) {
    application {
      id
      stage {
        id
        name
      }
      hired
      isUnsuccessful
      isNew
      isActionPending
      hiredForListing {
        id
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationHireMutationFn = Apollo.MutationFunction<ApplicationHireMutation, ApplicationHireMutationVariables>;

/**
 * __useApplicationHireMutation__
 *
 * To run a mutation, you first call `useApplicationHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationHireMutation, { data, loading, error }] = useApplicationHireMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationHireMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationHireMutation, ApplicationHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationHireMutation, ApplicationHireMutationVariables>(ApplicationHireDocument, options);
      }
export type ApplicationHireMutationHookResult = ReturnType<typeof useApplicationHireMutation>;
export type ApplicationHireMutationResult = Apollo.MutationResult<ApplicationHireMutation>;
export type ApplicationHireMutationOptions = Apollo.BaseMutationOptions<ApplicationHireMutation, ApplicationHireMutationVariables>;
export const ApplicationsHireDocument = gql`
    mutation ApplicationsHire($ids: [ID!]!) {
  applicationsHire(ids: $ids) {
    applications {
      id
      stage {
        id
        name
      }
      hired
      isUnsuccessful
      isNew
      isActionPending
      hiredForListing {
        id
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationsHireMutationFn = Apollo.MutationFunction<ApplicationsHireMutation, ApplicationsHireMutationVariables>;

/**
 * __useApplicationsHireMutation__
 *
 * To run a mutation, you first call `useApplicationsHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsHireMutation, { data, loading, error }] = useApplicationsHireMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApplicationsHireMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsHireMutation, ApplicationsHireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsHireMutation, ApplicationsHireMutationVariables>(ApplicationsHireDocument, options);
      }
export type ApplicationsHireMutationHookResult = ReturnType<typeof useApplicationsHireMutation>;
export type ApplicationsHireMutationResult = Apollo.MutationResult<ApplicationsHireMutation>;
export type ApplicationsHireMutationOptions = Apollo.BaseMutationOptions<ApplicationsHireMutation, ApplicationsHireMutationVariables>;
export const ApplicationMarkUnsuccessfulDocument = gql`
    mutation ApplicationMarkUnsuccessful($ids: [ID!]!) {
  applicationMarkUnsuccessful(ids: $ids) {
    applications {
      id
      stage {
        id
        name
      }
      hired
      isUnsuccessful
      isNew
      isActionPending
      hiredForListing {
        id
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationMarkUnsuccessfulMutationFn = Apollo.MutationFunction<ApplicationMarkUnsuccessfulMutation, ApplicationMarkUnsuccessfulMutationVariables>;

/**
 * __useApplicationMarkUnsuccessfulMutation__
 *
 * To run a mutation, you first call `useApplicationMarkUnsuccessfulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationMarkUnsuccessfulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationMarkUnsuccessfulMutation, { data, loading, error }] = useApplicationMarkUnsuccessfulMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApplicationMarkUnsuccessfulMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationMarkUnsuccessfulMutation, ApplicationMarkUnsuccessfulMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationMarkUnsuccessfulMutation, ApplicationMarkUnsuccessfulMutationVariables>(ApplicationMarkUnsuccessfulDocument, options);
      }
export type ApplicationMarkUnsuccessfulMutationHookResult = ReturnType<typeof useApplicationMarkUnsuccessfulMutation>;
export type ApplicationMarkUnsuccessfulMutationResult = Apollo.MutationResult<ApplicationMarkUnsuccessfulMutation>;
export type ApplicationMarkUnsuccessfulMutationOptions = Apollo.BaseMutationOptions<ApplicationMarkUnsuccessfulMutation, ApplicationMarkUnsuccessfulMutationVariables>;
export const ApplicationMarkSeenDocument = gql`
    mutation ApplicationMarkSeen($id: ID!) {
  applicationMarkSeen(id: $id) {
    application {
      id
      isNew
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicationMarkSeenMutationFn = Apollo.MutationFunction<ApplicationMarkSeenMutation, ApplicationMarkSeenMutationVariables>;

/**
 * __useApplicationMarkSeenMutation__
 *
 * To run a mutation, you first call `useApplicationMarkSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationMarkSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationMarkSeenMutation, { data, loading, error }] = useApplicationMarkSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationMarkSeenMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationMarkSeenMutation, ApplicationMarkSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationMarkSeenMutation, ApplicationMarkSeenMutationVariables>(ApplicationMarkSeenDocument, options);
      }
export type ApplicationMarkSeenMutationHookResult = ReturnType<typeof useApplicationMarkSeenMutation>;
export type ApplicationMarkSeenMutationResult = Apollo.MutationResult<ApplicationMarkSeenMutation>;
export type ApplicationMarkSeenMutationOptions = Apollo.BaseMutationOptions<ApplicationMarkSeenMutation, ApplicationMarkSeenMutationVariables>;
export const ApplicantDropDocument = gql`
    mutation ApplicantDrop($id: ID!) {
  applicantDrop(id: $id) {
    applicant {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicantDropMutationFn = Apollo.MutationFunction<ApplicantDropMutation, ApplicantDropMutationVariables>;

/**
 * __useApplicantDropMutation__
 *
 * To run a mutation, you first call `useApplicantDropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicantDropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicantDropMutation, { data, loading, error }] = useApplicantDropMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicantDropMutation(baseOptions?: Apollo.MutationHookOptions<ApplicantDropMutation, ApplicantDropMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicantDropMutation, ApplicantDropMutationVariables>(ApplicantDropDocument, options);
      }
export type ApplicantDropMutationHookResult = ReturnType<typeof useApplicantDropMutation>;
export type ApplicantDropMutationResult = Apollo.MutationResult<ApplicantDropMutation>;
export type ApplicantDropMutationOptions = Apollo.BaseMutationOptions<ApplicantDropMutation, ApplicantDropMutationVariables>;
export const ApplicantsDropDocument = gql`
    mutation ApplicantsDrop($ids: [ID!]!) {
  applicantsDrop(ids: $ids) {
    applicants {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicantsDropMutationFn = Apollo.MutationFunction<ApplicantsDropMutation, ApplicantsDropMutationVariables>;

/**
 * __useApplicantsDropMutation__
 *
 * To run a mutation, you first call `useApplicantsDropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicantsDropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicantsDropMutation, { data, loading, error }] = useApplicantsDropMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApplicantsDropMutation(baseOptions?: Apollo.MutationHookOptions<ApplicantsDropMutation, ApplicantsDropMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicantsDropMutation, ApplicantsDropMutationVariables>(ApplicantsDropDocument, options);
      }
export type ApplicantsDropMutationHookResult = ReturnType<typeof useApplicantsDropMutation>;
export type ApplicantsDropMutationResult = Apollo.MutationResult<ApplicantsDropMutation>;
export type ApplicantsDropMutationOptions = Apollo.BaseMutationOptions<ApplicantsDropMutation, ApplicantsDropMutationVariables>;
export const ApplicantInviteDocument = gql`
    mutation ApplicantInvite($id: ID!) {
  applicantInvite(id: $id) {
    applicant {
      id
      status {
        invited
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type ApplicantInviteMutationFn = Apollo.MutationFunction<ApplicantInviteMutation, ApplicantInviteMutationVariables>;

/**
 * __useApplicantInviteMutation__
 *
 * To run a mutation, you first call `useApplicantInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicantInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicantInviteMutation, { data, loading, error }] = useApplicantInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicantInviteMutation(baseOptions?: Apollo.MutationHookOptions<ApplicantInviteMutation, ApplicantInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicantInviteMutation, ApplicantInviteMutationVariables>(ApplicantInviteDocument, options);
      }
export type ApplicantInviteMutationHookResult = ReturnType<typeof useApplicantInviteMutation>;
export type ApplicantInviteMutationResult = Apollo.MutationResult<ApplicantInviteMutation>;
export type ApplicantInviteMutationOptions = Apollo.BaseMutationOptions<ApplicantInviteMutation, ApplicantInviteMutationVariables>;
export const FetchListingForApplicantsPageDocument = gql`
    query FetchListingForApplicantsPage($id: ID!) {
  listing(id: $id) {
    id
    slug
    title
    status
    createdAt
    openedAt
    company
    processing
    team {
      id
      name
    }
    manager {
      id
      firstName
      lastName
    }
    organisation {
      id
    }
    owner {
      id
      firstName
      lastName
    }
    scoreWeights {
      skills
      assessments
      qualifications
    }
    locations {
      locationId
      city
      state
      country
    }
    applicationStages {
      id
      name
    }
    permissions {
      edit
      viewApplicants
      dropApplicants
      inviteApplicants
      setStage
      setStageToShortlistOnly
      markAsHired
      createMessages
      viewAllNotes
      canAssignTag
    }
    sectionsCompleted {
      prescreening
    }
    applicantCounts {
      total
      direct
      pool
      new
      actionPending
      stages {
        stageId
        count
      }
      completed {
        type
        count
      }
    }
    isProcessingMatches
    matchmakingFailed
  }
}
    `;

/**
 * __useFetchListingForApplicantsPageQuery__
 *
 * To run a query within a React component, call `useFetchListingForApplicantsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListingForApplicantsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListingForApplicantsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchListingForApplicantsPageQuery(baseOptions: Apollo.QueryHookOptions<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables> & ({ variables: FetchListingForApplicantsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>(FetchListingForApplicantsPageDocument, options);
      }
export function useFetchListingForApplicantsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>(FetchListingForApplicantsPageDocument, options);
        }
// @ts-ignore
export function useFetchListingForApplicantsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>): Apollo.UseSuspenseQueryResult<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>;
export function useFetchListingForApplicantsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>): Apollo.UseSuspenseQueryResult<FetchListingForApplicantsPageQuery | undefined, FetchListingForApplicantsPageQueryVariables>;
export function useFetchListingForApplicantsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>(FetchListingForApplicantsPageDocument, options);
        }
export type FetchListingForApplicantsPageQueryHookResult = ReturnType<typeof useFetchListingForApplicantsPageQuery>;
export type FetchListingForApplicantsPageLazyQueryHookResult = ReturnType<typeof useFetchListingForApplicantsPageLazyQuery>;
export type FetchListingForApplicantsPageSuspenseQueryHookResult = ReturnType<typeof useFetchListingForApplicantsPageSuspenseQuery>;
export type FetchListingForApplicantsPageQueryResult = Apollo.QueryResult<FetchListingForApplicantsPageQuery, FetchListingForApplicantsPageQueryVariables>;
export const FetchListingApplicantCountsDocument = gql`
    query FetchListingApplicantCounts($id: ID!) {
  listing(id: $id) {
    id
    applicantCounts {
      total
      direct
    }
  }
}
    `;

/**
 * __useFetchListingApplicantCountsQuery__
 *
 * To run a query within a React component, call `useFetchListingApplicantCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListingApplicantCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListingApplicantCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchListingApplicantCountsQuery(baseOptions: Apollo.QueryHookOptions<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables> & ({ variables: FetchListingApplicantCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>(FetchListingApplicantCountsDocument, options);
      }
export function useFetchListingApplicantCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>(FetchListingApplicantCountsDocument, options);
        }
// @ts-ignore
export function useFetchListingApplicantCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>;
export function useFetchListingApplicantCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchListingApplicantCountsQuery | undefined, FetchListingApplicantCountsQueryVariables>;
export function useFetchListingApplicantCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>(FetchListingApplicantCountsDocument, options);
        }
export type FetchListingApplicantCountsQueryHookResult = ReturnType<typeof useFetchListingApplicantCountsQuery>;
export type FetchListingApplicantCountsLazyQueryHookResult = ReturnType<typeof useFetchListingApplicantCountsLazyQuery>;
export type FetchListingApplicantCountsSuspenseQueryHookResult = ReturnType<typeof useFetchListingApplicantCountsSuspenseQuery>;
export type FetchListingApplicantCountsQueryResult = Apollo.QueryResult<FetchListingApplicantCountsQuery, FetchListingApplicantCountsQueryVariables>;
export const FetchListingProcessingStatusDocument = gql`
    query FetchListingProcessingStatus($id: ID!) {
  listing(id: $id) {
    id
    isProcessingMatches
    matchmakingFailed
  }
}
    `;

/**
 * __useFetchListingProcessingStatusQuery__
 *
 * To run a query within a React component, call `useFetchListingProcessingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListingProcessingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListingProcessingStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchListingProcessingStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables> & ({ variables: FetchListingProcessingStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>(FetchListingProcessingStatusDocument, options);
      }
export function useFetchListingProcessingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>(FetchListingProcessingStatusDocument, options);
        }
// @ts-ignore
export function useFetchListingProcessingStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>): Apollo.UseSuspenseQueryResult<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>;
export function useFetchListingProcessingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>): Apollo.UseSuspenseQueryResult<FetchListingProcessingStatusQuery | undefined, FetchListingProcessingStatusQueryVariables>;
export function useFetchListingProcessingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>(FetchListingProcessingStatusDocument, options);
        }
export type FetchListingProcessingStatusQueryHookResult = ReturnType<typeof useFetchListingProcessingStatusQuery>;
export type FetchListingProcessingStatusLazyQueryHookResult = ReturnType<typeof useFetchListingProcessingStatusLazyQuery>;
export type FetchListingProcessingStatusSuspenseQueryHookResult = ReturnType<typeof useFetchListingProcessingStatusSuspenseQuery>;
export type FetchListingProcessingStatusQueryResult = Apollo.QueryResult<FetchListingProcessingStatusQuery, FetchListingProcessingStatusQueryVariables>;
export const ListingMatchmakingMarkPendingDocument = gql`
    mutation ListingMatchmakingMarkPending($listingId: ID!) {
  listingMatchmakingMarkPending(listingId: $listingId) {
    listing {
      id
      isProcessingMatches
    }
    errors {
      code
      message
    }
  }
}
    `;
export type ListingMatchmakingMarkPendingMutationFn = Apollo.MutationFunction<ListingMatchmakingMarkPendingMutation, ListingMatchmakingMarkPendingMutationVariables>;

/**
 * __useListingMatchmakingMarkPendingMutation__
 *
 * To run a mutation, you first call `useListingMatchmakingMarkPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingMatchmakingMarkPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingMatchmakingMarkPendingMutation, { data, loading, error }] = useListingMatchmakingMarkPendingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingMatchmakingMarkPendingMutation(baseOptions?: Apollo.MutationHookOptions<ListingMatchmakingMarkPendingMutation, ListingMatchmakingMarkPendingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingMatchmakingMarkPendingMutation, ListingMatchmakingMarkPendingMutationVariables>(ListingMatchmakingMarkPendingDocument, options);
      }
export type ListingMatchmakingMarkPendingMutationHookResult = ReturnType<typeof useListingMatchmakingMarkPendingMutation>;
export type ListingMatchmakingMarkPendingMutationResult = Apollo.MutationResult<ListingMatchmakingMarkPendingMutation>;
export type ListingMatchmakingMarkPendingMutationOptions = Apollo.BaseMutationOptions<ListingMatchmakingMarkPendingMutation, ListingMatchmakingMarkPendingMutationVariables>;
export const GetApprovalConfigDocument = gql`
    query GetApprovalConfig {
  approvalConfig {
    enabled
    approvalTypes
    approvers {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetApprovalConfigQuery__
 *
 * To run a query within a React component, call `useGetApprovalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApprovalConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>(GetApprovalConfigDocument, options);
      }
export function useGetApprovalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>(GetApprovalConfigDocument, options);
        }
// @ts-ignore
export function useGetApprovalConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>;
export function useGetApprovalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalConfigQuery | undefined, GetApprovalConfigQueryVariables>;
export function useGetApprovalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>(GetApprovalConfigDocument, options);
        }
export type GetApprovalConfigQueryHookResult = ReturnType<typeof useGetApprovalConfigQuery>;
export type GetApprovalConfigLazyQueryHookResult = ReturnType<typeof useGetApprovalConfigLazyQuery>;
export type GetApprovalConfigSuspenseQueryHookResult = ReturnType<typeof useGetApprovalConfigSuspenseQuery>;
export type GetApprovalConfigQueryResult = Apollo.QueryResult<GetApprovalConfigQuery, GetApprovalConfigQueryVariables>;
export const SetRequisitionWorkflowEnabledDocument = gql`
    mutation SetRequisitionWorkflowEnabled($enabled: Boolean!) {
  setRequisitionWorkflowEnabled(enabled: $enabled) {
    enabled
    approvalTypes
  }
}
    `;
export type SetRequisitionWorkflowEnabledMutationFn = Apollo.MutationFunction<SetRequisitionWorkflowEnabledMutation, SetRequisitionWorkflowEnabledMutationVariables>;

/**
 * __useSetRequisitionWorkflowEnabledMutation__
 *
 * To run a mutation, you first call `useSetRequisitionWorkflowEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRequisitionWorkflowEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRequisitionWorkflowEnabledMutation, { data, loading, error }] = useSetRequisitionWorkflowEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetRequisitionWorkflowEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetRequisitionWorkflowEnabledMutation, SetRequisitionWorkflowEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRequisitionWorkflowEnabledMutation, SetRequisitionWorkflowEnabledMutationVariables>(SetRequisitionWorkflowEnabledDocument, options);
      }
export type SetRequisitionWorkflowEnabledMutationHookResult = ReturnType<typeof useSetRequisitionWorkflowEnabledMutation>;
export type SetRequisitionWorkflowEnabledMutationResult = Apollo.MutationResult<SetRequisitionWorkflowEnabledMutation>;
export type SetRequisitionWorkflowEnabledMutationOptions = Apollo.BaseMutationOptions<SetRequisitionWorkflowEnabledMutation, SetRequisitionWorkflowEnabledMutationVariables>;
export const AddRequisitionApprovalTypeDocument = gql`
    mutation AddRequisitionApprovalType($label: String!) {
  addRequisitionApprovalType(label: $label) {
    enabled
    approvalTypes
  }
}
    `;
export type AddRequisitionApprovalTypeMutationFn = Apollo.MutationFunction<AddRequisitionApprovalTypeMutation, AddRequisitionApprovalTypeMutationVariables>;

/**
 * __useAddRequisitionApprovalTypeMutation__
 *
 * To run a mutation, you first call `useAddRequisitionApprovalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequisitionApprovalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequisitionApprovalTypeMutation, { data, loading, error }] = useAddRequisitionApprovalTypeMutation({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useAddRequisitionApprovalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddRequisitionApprovalTypeMutation, AddRequisitionApprovalTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRequisitionApprovalTypeMutation, AddRequisitionApprovalTypeMutationVariables>(AddRequisitionApprovalTypeDocument, options);
      }
export type AddRequisitionApprovalTypeMutationHookResult = ReturnType<typeof useAddRequisitionApprovalTypeMutation>;
export type AddRequisitionApprovalTypeMutationResult = Apollo.MutationResult<AddRequisitionApprovalTypeMutation>;
export type AddRequisitionApprovalTypeMutationOptions = Apollo.BaseMutationOptions<AddRequisitionApprovalTypeMutation, AddRequisitionApprovalTypeMutationVariables>;
export const RemoveRequisitionApprovalTypeDocument = gql`
    mutation RemoveRequisitionApprovalType($label: String!) {
  removeRequisitionApprovalType(label: $label) {
    enabled
    approvalTypes
  }
}
    `;
export type RemoveRequisitionApprovalTypeMutationFn = Apollo.MutationFunction<RemoveRequisitionApprovalTypeMutation, RemoveRequisitionApprovalTypeMutationVariables>;

/**
 * __useRemoveRequisitionApprovalTypeMutation__
 *
 * To run a mutation, you first call `useRemoveRequisitionApprovalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRequisitionApprovalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRequisitionApprovalTypeMutation, { data, loading, error }] = useRemoveRequisitionApprovalTypeMutation({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useRemoveRequisitionApprovalTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRequisitionApprovalTypeMutation, RemoveRequisitionApprovalTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRequisitionApprovalTypeMutation, RemoveRequisitionApprovalTypeMutationVariables>(RemoveRequisitionApprovalTypeDocument, options);
      }
export type RemoveRequisitionApprovalTypeMutationHookResult = ReturnType<typeof useRemoveRequisitionApprovalTypeMutation>;
export type RemoveRequisitionApprovalTypeMutationResult = Apollo.MutationResult<RemoveRequisitionApprovalTypeMutation>;
export type RemoveRequisitionApprovalTypeMutationOptions = Apollo.BaseMutationOptions<RemoveRequisitionApprovalTypeMutation, RemoveRequisitionApprovalTypeMutationVariables>;
export const AddRequisitionApproverDocument = gql`
    mutation AddRequisitionApprover($userId: ID!) {
  addRequisitionApprover(userId: $userId) {
    approvers {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type AddRequisitionApproverMutationFn = Apollo.MutationFunction<AddRequisitionApproverMutation, AddRequisitionApproverMutationVariables>;

/**
 * __useAddRequisitionApproverMutation__
 *
 * To run a mutation, you first call `useAddRequisitionApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRequisitionApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRequisitionApproverMutation, { data, loading, error }] = useAddRequisitionApproverMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddRequisitionApproverMutation(baseOptions?: Apollo.MutationHookOptions<AddRequisitionApproverMutation, AddRequisitionApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRequisitionApproverMutation, AddRequisitionApproverMutationVariables>(AddRequisitionApproverDocument, options);
      }
export type AddRequisitionApproverMutationHookResult = ReturnType<typeof useAddRequisitionApproverMutation>;
export type AddRequisitionApproverMutationResult = Apollo.MutationResult<AddRequisitionApproverMutation>;
export type AddRequisitionApproverMutationOptions = Apollo.BaseMutationOptions<AddRequisitionApproverMutation, AddRequisitionApproverMutationVariables>;
export const RemoveRequisitionApproverDocument = gql`
    mutation RemoveRequisitionApprover($userId: ID!) {
  removeRequisitionApprover(userId: $userId) {
    approvers {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type RemoveRequisitionApproverMutationFn = Apollo.MutationFunction<RemoveRequisitionApproverMutation, RemoveRequisitionApproverMutationVariables>;

/**
 * __useRemoveRequisitionApproverMutation__
 *
 * To run a mutation, you first call `useRemoveRequisitionApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRequisitionApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRequisitionApproverMutation, { data, loading, error }] = useRemoveRequisitionApproverMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveRequisitionApproverMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRequisitionApproverMutation, RemoveRequisitionApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRequisitionApproverMutation, RemoveRequisitionApproverMutationVariables>(RemoveRequisitionApproverDocument, options);
      }
export type RemoveRequisitionApproverMutationHookResult = ReturnType<typeof useRemoveRequisitionApproverMutation>;
export type RemoveRequisitionApproverMutationResult = Apollo.MutationResult<RemoveRequisitionApproverMutation>;
export type RemoveRequisitionApproverMutationOptions = Apollo.BaseMutationOptions<RemoveRequisitionApproverMutation, RemoveRequisitionApproverMutationVariables>;
export const BusinessProfileDocument = gql`
    query BusinessProfile {
  businessProfile {
    ...BusinessProfileFields
  }
}
    ${BusinessProfileFieldsFragmentDoc}`;

/**
 * __useBusinessProfileQuery__
 *
 * To run a query within a React component, call `useBusinessProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessProfileQuery(baseOptions?: Apollo.QueryHookOptions<BusinessProfileQuery, BusinessProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessProfileQuery, BusinessProfileQueryVariables>(BusinessProfileDocument, options);
      }
export function useBusinessProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessProfileQuery, BusinessProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessProfileQuery, BusinessProfileQueryVariables>(BusinessProfileDocument, options);
        }
// @ts-ignore
export function useBusinessProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessProfileQuery, BusinessProfileQueryVariables>): Apollo.UseSuspenseQueryResult<BusinessProfileQuery, BusinessProfileQueryVariables>;
export function useBusinessProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessProfileQuery, BusinessProfileQueryVariables>): Apollo.UseSuspenseQueryResult<BusinessProfileQuery | undefined, BusinessProfileQueryVariables>;
export function useBusinessProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessProfileQuery, BusinessProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessProfileQuery, BusinessProfileQueryVariables>(BusinessProfileDocument, options);
        }
export type BusinessProfileQueryHookResult = ReturnType<typeof useBusinessProfileQuery>;
export type BusinessProfileLazyQueryHookResult = ReturnType<typeof useBusinessProfileLazyQuery>;
export type BusinessProfileSuspenseQueryHookResult = ReturnType<typeof useBusinessProfileSuspenseQuery>;
export type BusinessProfileQueryResult = Apollo.QueryResult<BusinessProfileQuery, BusinessProfileQueryVariables>;
export const OrganisationWebsiteDocument = gql`
    query OrganisationWebsite {
  organisationWebsite
}
    `;

/**
 * __useOrganisationWebsiteQuery__
 *
 * To run a query within a React component, call `useOrganisationWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationWebsiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationWebsiteQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>(OrganisationWebsiteDocument, options);
      }
export function useOrganisationWebsiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>(OrganisationWebsiteDocument, options);
        }
// @ts-ignore
export function useOrganisationWebsiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>): Apollo.UseSuspenseQueryResult<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>;
export function useOrganisationWebsiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>): Apollo.UseSuspenseQueryResult<OrganisationWebsiteQuery | undefined, OrganisationWebsiteQueryVariables>;
export function useOrganisationWebsiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>(OrganisationWebsiteDocument, options);
        }
export type OrganisationWebsiteQueryHookResult = ReturnType<typeof useOrganisationWebsiteQuery>;
export type OrganisationWebsiteLazyQueryHookResult = ReturnType<typeof useOrganisationWebsiteLazyQuery>;
export type OrganisationWebsiteSuspenseQueryHookResult = ReturnType<typeof useOrganisationWebsiteSuspenseQuery>;
export type OrganisationWebsiteQueryResult = Apollo.QueryResult<OrganisationWebsiteQuery, OrganisationWebsiteQueryVariables>;
export const LifecycleStagesDocument = gql`
    query LifecycleStages {
  lifecycleStages {
    stage
    order
    label
    subtitle
    goal
    focus
    challenge
  }
}
    `;

/**
 * __useLifecycleStagesQuery__
 *
 * To run a query within a React component, call `useLifecycleStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifecycleStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifecycleStagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLifecycleStagesQuery(baseOptions?: Apollo.QueryHookOptions<LifecycleStagesQuery, LifecycleStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifecycleStagesQuery, LifecycleStagesQueryVariables>(LifecycleStagesDocument, options);
      }
export function useLifecycleStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifecycleStagesQuery, LifecycleStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifecycleStagesQuery, LifecycleStagesQueryVariables>(LifecycleStagesDocument, options);
        }
// @ts-ignore
export function useLifecycleStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LifecycleStagesQuery, LifecycleStagesQueryVariables>): Apollo.UseSuspenseQueryResult<LifecycleStagesQuery, LifecycleStagesQueryVariables>;
export function useLifecycleStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LifecycleStagesQuery, LifecycleStagesQueryVariables>): Apollo.UseSuspenseQueryResult<LifecycleStagesQuery | undefined, LifecycleStagesQueryVariables>;
export function useLifecycleStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LifecycleStagesQuery, LifecycleStagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LifecycleStagesQuery, LifecycleStagesQueryVariables>(LifecycleStagesDocument, options);
        }
export type LifecycleStagesQueryHookResult = ReturnType<typeof useLifecycleStagesQuery>;
export type LifecycleStagesLazyQueryHookResult = ReturnType<typeof useLifecycleStagesLazyQuery>;
export type LifecycleStagesSuspenseQueryHookResult = ReturnType<typeof useLifecycleStagesSuspenseQuery>;
export type LifecycleStagesQueryResult = Apollo.QueryResult<LifecycleStagesQuery, LifecycleStagesQueryVariables>;
export const OrganisationPeopleDocument = gql`
    query OrganisationPeople($search: String) {
  organisationPeople(search: $search) {
    id
    name
    jobTitle
  }
}
    `;

/**
 * __useOrganisationPeopleQuery__
 *
 * To run a query within a React component, call `useOrganisationPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationPeopleQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOrganisationPeopleQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>(OrganisationPeopleDocument, options);
      }
export function useOrganisationPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>(OrganisationPeopleDocument, options);
        }
// @ts-ignore
export function useOrganisationPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>;
export function useOrganisationPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<OrganisationPeopleQuery | undefined, OrganisationPeopleQueryVariables>;
export function useOrganisationPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>(OrganisationPeopleDocument, options);
        }
export type OrganisationPeopleQueryHookResult = ReturnType<typeof useOrganisationPeopleQuery>;
export type OrganisationPeopleLazyQueryHookResult = ReturnType<typeof useOrganisationPeopleLazyQuery>;
export type OrganisationPeopleSuspenseQueryHookResult = ReturnType<typeof useOrganisationPeopleSuspenseQuery>;
export type OrganisationPeopleQueryResult = Apollo.QueryResult<OrganisationPeopleQuery, OrganisationPeopleQueryVariables>;
export const BusinessProfileDeleteDocument = gql`
    mutation BusinessProfileDelete {
  businessProfileDelete
}
    `;
export type BusinessProfileDeleteMutationFn = Apollo.MutationFunction<BusinessProfileDeleteMutation, BusinessProfileDeleteMutationVariables>;

/**
 * __useBusinessProfileDeleteMutation__
 *
 * To run a mutation, you first call `useBusinessProfileDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileDeleteMutation, { data, loading, error }] = useBusinessProfileDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useBusinessProfileDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileDeleteMutation, BusinessProfileDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileDeleteMutation, BusinessProfileDeleteMutationVariables>(BusinessProfileDeleteDocument, options);
      }
export type BusinessProfileDeleteMutationHookResult = ReturnType<typeof useBusinessProfileDeleteMutation>;
export type BusinessProfileDeleteMutationResult = Apollo.MutationResult<BusinessProfileDeleteMutation>;
export type BusinessProfileDeleteMutationOptions = Apollo.BaseMutationOptions<BusinessProfileDeleteMutation, BusinessProfileDeleteMutationVariables>;
export const BusinessProfileUpdateDocument = gql`
    mutation BusinessProfileUpdate($input: BusinessProfileUpdateInput!) {
  businessProfileUpdate(input: $input) {
    businessProfile {
      ...BusinessProfileFields
    }
    errors {
      message
      code
      field
    }
  }
}
    ${BusinessProfileFieldsFragmentDoc}`;
export type BusinessProfileUpdateMutationFn = Apollo.MutationFunction<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>;

/**
 * __useBusinessProfileUpdateMutation__
 *
 * To run a mutation, you first call `useBusinessProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileUpdateMutation, { data, loading, error }] = useBusinessProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>(BusinessProfileUpdateDocument, options);
      }
export type BusinessProfileUpdateMutationHookResult = ReturnType<typeof useBusinessProfileUpdateMutation>;
export type BusinessProfileUpdateMutationResult = Apollo.MutationResult<BusinessProfileUpdateMutation>;
export type BusinessProfileUpdateMutationOptions = Apollo.BaseMutationOptions<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>;
export const CulturePerceptionDocument = gql`
    query culturePerception($assessmentSk: String!, $filters: [CulturePerceptionFilterInput]) {
  culturePerception(assessmentSk: $assessmentSk, filters: $filters) {
    perceptionAverage {
      financial
      operational
      learningGrowth
      customerQuality
      jobEngagement
      jobSatisfaction
      turnoverIntention
      workMotivation
      overallClimate
    }
    perceptionList {
      financial
      operational
      learningGrowth
      customerQuality
      jobEngagement
      jobSatisfaction
      turnoverIntention
      workMotivation
      overallClimate
    }
    completedUsersCount
    totalUsersCompleted
  }
}
    `;

/**
 * __useCulturePerceptionQuery__
 *
 * To run a query within a React component, call `useCulturePerceptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCulturePerceptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCulturePerceptionQuery({
 *   variables: {
 *      assessmentSk: // value for 'assessmentSk'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCulturePerceptionQuery(baseOptions: Apollo.QueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables> & ({ variables: CulturePerceptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CulturePerceptionQuery, CulturePerceptionQueryVariables>(CulturePerceptionDocument, options);
      }
export function useCulturePerceptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CulturePerceptionQuery, CulturePerceptionQueryVariables>(CulturePerceptionDocument, options);
        }
// @ts-ignore
export function useCulturePerceptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables>): Apollo.UseSuspenseQueryResult<CulturePerceptionQuery, CulturePerceptionQueryVariables>;
export function useCulturePerceptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables>): Apollo.UseSuspenseQueryResult<CulturePerceptionQuery | undefined, CulturePerceptionQueryVariables>;
export function useCulturePerceptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CulturePerceptionQuery, CulturePerceptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CulturePerceptionQuery, CulturePerceptionQueryVariables>(CulturePerceptionDocument, options);
        }
export type CulturePerceptionQueryHookResult = ReturnType<typeof useCulturePerceptionQuery>;
export type CulturePerceptionLazyQueryHookResult = ReturnType<typeof useCulturePerceptionLazyQuery>;
export type CulturePerceptionSuspenseQueryHookResult = ReturnType<typeof useCulturePerceptionSuspenseQuery>;
export type CulturePerceptionQueryResult = Apollo.QueryResult<CulturePerceptionQuery, CulturePerceptionQueryVariables>;
export const GetCultureHotspotsDocument = gql`
    query getCultureHotspots($campaignSk: String, $filter: String) {
  cultureHotspots(campaignSk: $campaignSk, filter: $filter) {
    pk
    sk
    campaignId
    campaignName
    responseCount
    aggregation
    current
    desired
    responseCount
    hasParent
    aggregateFilter
  }
}
    `;

/**
 * __useGetCultureHotspotsQuery__
 *
 * To run a query within a React component, call `useGetCultureHotspotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCultureHotspotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCultureHotspotsQuery({
 *   variables: {
 *      campaignSk: // value for 'campaignSk'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCultureHotspotsQuery(baseOptions?: Apollo.QueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>(GetCultureHotspotsDocument, options);
      }
export function useGetCultureHotspotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>(GetCultureHotspotsDocument, options);
        }
// @ts-ignore
export function useGetCultureHotspotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>;
export function useGetCultureHotspotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCultureHotspotsQuery | undefined, GetCultureHotspotsQueryVariables>;
export function useGetCultureHotspotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>(GetCultureHotspotsDocument, options);
        }
export type GetCultureHotspotsQueryHookResult = ReturnType<typeof useGetCultureHotspotsQuery>;
export type GetCultureHotspotsLazyQueryHookResult = ReturnType<typeof useGetCultureHotspotsLazyQuery>;
export type GetCultureHotspotsSuspenseQueryHookResult = ReturnType<typeof useGetCultureHotspotsSuspenseQuery>;
export type GetCultureHotspotsQueryResult = Apollo.QueryResult<GetCultureHotspotsQuery, GetCultureHotspotsQueryVariables>;
export const CultureReportProgressDocument = gql`
    query CultureReportProgress($campaignId: ID!) {
  cultureReport(campaignId: $campaignId) {
    ...CultureReportProgressFields
  }
}
    ${CultureReportProgressFieldsFragmentDoc}`;

/**
 * __useCultureReportProgressQuery__
 *
 * To run a query within a React component, call `useCultureReportProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultureReportProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultureReportProgressQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCultureReportProgressQuery(baseOptions: Apollo.QueryHookOptions<CultureReportProgressQuery, CultureReportProgressQueryVariables> & ({ variables: CultureReportProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CultureReportProgressQuery, CultureReportProgressQueryVariables>(CultureReportProgressDocument, options);
      }
export function useCultureReportProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultureReportProgressQuery, CultureReportProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CultureReportProgressQuery, CultureReportProgressQueryVariables>(CultureReportProgressDocument, options);
        }
// @ts-ignore
export function useCultureReportProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CultureReportProgressQuery, CultureReportProgressQueryVariables>): Apollo.UseSuspenseQueryResult<CultureReportProgressQuery, CultureReportProgressQueryVariables>;
export function useCultureReportProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CultureReportProgressQuery, CultureReportProgressQueryVariables>): Apollo.UseSuspenseQueryResult<CultureReportProgressQuery | undefined, CultureReportProgressQueryVariables>;
export function useCultureReportProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CultureReportProgressQuery, CultureReportProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CultureReportProgressQuery, CultureReportProgressQueryVariables>(CultureReportProgressDocument, options);
        }
export type CultureReportProgressQueryHookResult = ReturnType<typeof useCultureReportProgressQuery>;
export type CultureReportProgressLazyQueryHookResult = ReturnType<typeof useCultureReportProgressLazyQuery>;
export type CultureReportProgressSuspenseQueryHookResult = ReturnType<typeof useCultureReportProgressSuspenseQuery>;
export type CultureReportProgressQueryResult = Apollo.QueryResult<CultureReportProgressQuery, CultureReportProgressQueryVariables>;
export const CultureReportContentDocument = gql`
    query CultureReportContent($campaignId: ID!) {
  cultureReport(campaignId: $campaignId) {
    id
    content
    campaign {
      id
      name
      closedAt
    }
    entitySummaries {
      id
      entityType
      entityName
      content
      generatedAt
    }
  }
}
    `;

/**
 * __useCultureReportContentQuery__
 *
 * To run a query within a React component, call `useCultureReportContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultureReportContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultureReportContentQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCultureReportContentQuery(baseOptions: Apollo.QueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables> & ({ variables: CultureReportContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CultureReportContentQuery, CultureReportContentQueryVariables>(CultureReportContentDocument, options);
      }
export function useCultureReportContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CultureReportContentQuery, CultureReportContentQueryVariables>(CultureReportContentDocument, options);
        }
// @ts-ignore
export function useCultureReportContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables>): Apollo.UseSuspenseQueryResult<CultureReportContentQuery, CultureReportContentQueryVariables>;
export function useCultureReportContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables>): Apollo.UseSuspenseQueryResult<CultureReportContentQuery | undefined, CultureReportContentQueryVariables>;
export function useCultureReportContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CultureReportContentQuery, CultureReportContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CultureReportContentQuery, CultureReportContentQueryVariables>(CultureReportContentDocument, options);
        }
export type CultureReportContentQueryHookResult = ReturnType<typeof useCultureReportContentQuery>;
export type CultureReportContentLazyQueryHookResult = ReturnType<typeof useCultureReportContentLazyQuery>;
export type CultureReportContentSuspenseQueryHookResult = ReturnType<typeof useCultureReportContentSuspenseQuery>;
export type CultureReportContentQueryResult = Apollo.QueryResult<CultureReportContentQuery, CultureReportContentQueryVariables>;
export const CultureReportDeleteDocument = gql`
    mutation CultureReportDelete($campaignId: ID!) {
  cultureReportDelete(campaignId: $campaignId)
}
    `;
export type CultureReportDeleteMutationFn = Apollo.MutationFunction<CultureReportDeleteMutation, CultureReportDeleteMutationVariables>;

/**
 * __useCultureReportDeleteMutation__
 *
 * To run a mutation, you first call `useCultureReportDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCultureReportDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cultureReportDeleteMutation, { data, loading, error }] = useCultureReportDeleteMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCultureReportDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CultureReportDeleteMutation, CultureReportDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CultureReportDeleteMutation, CultureReportDeleteMutationVariables>(CultureReportDeleteDocument, options);
      }
export type CultureReportDeleteMutationHookResult = ReturnType<typeof useCultureReportDeleteMutation>;
export type CultureReportDeleteMutationResult = Apollo.MutationResult<CultureReportDeleteMutation>;
export type CultureReportDeleteMutationOptions = Apollo.BaseMutationOptions<CultureReportDeleteMutation, CultureReportDeleteMutationVariables>;
export const CultureReportGenerateDocument = gql`
    mutation CultureReportGenerate($campaignId: ID!, $input: CultureReportGenerateInput) {
  cultureReportGenerate(campaignId: $campaignId, input: $input) {
    cultureReport {
      ...CultureReportProgressFields
    }
    errors {
      message
      code
    }
  }
}
    ${CultureReportProgressFieldsFragmentDoc}`;
export type CultureReportGenerateMutationFn = Apollo.MutationFunction<CultureReportGenerateMutation, CultureReportGenerateMutationVariables>;

/**
 * __useCultureReportGenerateMutation__
 *
 * To run a mutation, you first call `useCultureReportGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCultureReportGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cultureReportGenerateMutation, { data, loading, error }] = useCultureReportGenerateMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCultureReportGenerateMutation(baseOptions?: Apollo.MutationHookOptions<CultureReportGenerateMutation, CultureReportGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CultureReportGenerateMutation, CultureReportGenerateMutationVariables>(CultureReportGenerateDocument, options);
      }
export type CultureReportGenerateMutationHookResult = ReturnType<typeof useCultureReportGenerateMutation>;
export type CultureReportGenerateMutationResult = Apollo.MutationResult<CultureReportGenerateMutation>;
export type CultureReportGenerateMutationOptions = Apollo.BaseMutationOptions<CultureReportGenerateMutation, CultureReportGenerateMutationVariables>;
export const FetchDevelopPermissionsDocument = gql`
    query FetchDevelopPermissions {
  permissions {
    learningPortal
  }
}
    `;

/**
 * __useFetchDevelopPermissionsQuery__
 *
 * To run a query within a React component, call `useFetchDevelopPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDevelopPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDevelopPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDevelopPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>(FetchDevelopPermissionsDocument, options);
      }
export function useFetchDevelopPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>(FetchDevelopPermissionsDocument, options);
        }
// @ts-ignore
export function useFetchDevelopPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>;
export function useFetchDevelopPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchDevelopPermissionsQuery | undefined, FetchDevelopPermissionsQueryVariables>;
export function useFetchDevelopPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>(FetchDevelopPermissionsDocument, options);
        }
export type FetchDevelopPermissionsQueryHookResult = ReturnType<typeof useFetchDevelopPermissionsQuery>;
export type FetchDevelopPermissionsLazyQueryHookResult = ReturnType<typeof useFetchDevelopPermissionsLazyQuery>;
export type FetchDevelopPermissionsSuspenseQueryHookResult = ReturnType<typeof useFetchDevelopPermissionsSuspenseQuery>;
export type FetchDevelopPermissionsQueryResult = Apollo.QueryResult<FetchDevelopPermissionsQuery, FetchDevelopPermissionsQueryVariables>;
export const GetFeedbackThemesDocument = gql`
    query GetFeedbackThemes($campaignSk: String!) {
  feedbackThemes(campaignSk: $campaignSk) {
    id
    title
    summary
    processed
    isNoise
    intents {
      id
      topic
      summary
      sentiment
    }
    originalFeedbackSks {
      sk
      index
    }
  }
}
    `;

/**
 * __useGetFeedbackThemesQuery__
 *
 * To run a query within a React component, call `useGetFeedbackThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackThemesQuery({
 *   variables: {
 *      campaignSk: // value for 'campaignSk'
 *   },
 * });
 */
export function useGetFeedbackThemesQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables> & ({ variables: GetFeedbackThemesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>(GetFeedbackThemesDocument, options);
      }
export function useGetFeedbackThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>(GetFeedbackThemesDocument, options);
        }
// @ts-ignore
export function useGetFeedbackThemesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>;
export function useGetFeedbackThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeedbackThemesQuery | undefined, GetFeedbackThemesQueryVariables>;
export function useGetFeedbackThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>(GetFeedbackThemesDocument, options);
        }
export type GetFeedbackThemesQueryHookResult = ReturnType<typeof useGetFeedbackThemesQuery>;
export type GetFeedbackThemesLazyQueryHookResult = ReturnType<typeof useGetFeedbackThemesLazyQuery>;
export type GetFeedbackThemesSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackThemesSuspenseQuery>;
export type GetFeedbackThemesQueryResult = Apollo.QueryResult<GetFeedbackThemesQuery, GetFeedbackThemesQueryVariables>;
export const MyGroupMembersDocument = gql`
    query myGroupMembers {
  myGroupMembers {
    memberId
    organisationId
    groupId
    memberType
    role
    roleDisplayName
  }
}
    `;

/**
 * __useMyGroupMembersQuery__
 *
 * To run a query within a React component, call `useMyGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupMembersQuery(baseOptions?: Apollo.QueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
      }
export function useMyGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
        }
// @ts-ignore
export function useMyGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<MyGroupMembersQuery, MyGroupMembersQueryVariables>;
export function useMyGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<MyGroupMembersQuery | undefined, MyGroupMembersQueryVariables>;
export function useMyGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGroupMembersQuery, MyGroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(MyGroupMembersDocument, options);
        }
export type MyGroupMembersQueryHookResult = ReturnType<typeof useMyGroupMembersQuery>;
export type MyGroupMembersLazyQueryHookResult = ReturnType<typeof useMyGroupMembersLazyQuery>;
export type MyGroupMembersSuspenseQueryHookResult = ReturnType<typeof useMyGroupMembersSuspenseQuery>;
export type MyGroupMembersQueryResult = Apollo.QueryResult<MyGroupMembersQuery, MyGroupMembersQueryVariables>;
export const GetHirePipelineListingsDocument = gql`
    query GetHirePipelineListings($filter: ListingFilter, $pagination: Pagination) {
  listings(filter: $filter, pagination: $pagination) {
    items {
      id
      title
      applicantCounts {
        new
        actionPending
        stages {
          stageId
          count
        }
        completed {
          type
          count
        }
      }
    }
    pageInfo {
      page
      pageSize
      totalItems
      totalPages
    }
  }
}
    `;

/**
 * __useGetHirePipelineListingsQuery__
 *
 * To run a query within a React component, call `useGetHirePipelineListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirePipelineListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirePipelineListingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetHirePipelineListingsQuery(baseOptions?: Apollo.QueryHookOptions<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>(GetHirePipelineListingsDocument, options);
      }
export function useGetHirePipelineListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>(GetHirePipelineListingsDocument, options);
        }
// @ts-ignore
export function useGetHirePipelineListingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>;
export function useGetHirePipelineListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHirePipelineListingsQuery | undefined, GetHirePipelineListingsQueryVariables>;
export function useGetHirePipelineListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>(GetHirePipelineListingsDocument, options);
        }
export type GetHirePipelineListingsQueryHookResult = ReturnType<typeof useGetHirePipelineListingsQuery>;
export type GetHirePipelineListingsLazyQueryHookResult = ReturnType<typeof useGetHirePipelineListingsLazyQuery>;
export type GetHirePipelineListingsSuspenseQueryHookResult = ReturnType<typeof useGetHirePipelineListingsSuspenseQuery>;
export type GetHirePipelineListingsQueryResult = Apollo.QueryResult<GetHirePipelineListingsQuery, GetHirePipelineListingsQueryVariables>;
export const GetHirePipelineStageApplicantsDocument = gql`
    query GetHirePipelineStageApplicants($filter: ApplicantFilter!, $pagination: Pagination) {
  applicants(filter: $filter, pagination: $pagination) {
    items {
      id
      listingId
      name
      applicationCreatedAt
      stage {
        id
      }
      unsuccessful
    }
    pageInfo {
      totalItems
    }
  }
}
    `;

/**
 * __useGetHirePipelineStageApplicantsQuery__
 *
 * To run a query within a React component, call `useGetHirePipelineStageApplicantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirePipelineStageApplicantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirePipelineStageApplicantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetHirePipelineStageApplicantsQuery(baseOptions: Apollo.QueryHookOptions<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables> & ({ variables: GetHirePipelineStageApplicantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>(GetHirePipelineStageApplicantsDocument, options);
      }
export function useGetHirePipelineStageApplicantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>(GetHirePipelineStageApplicantsDocument, options);
        }
// @ts-ignore
export function useGetHirePipelineStageApplicantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>;
export function useGetHirePipelineStageApplicantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHirePipelineStageApplicantsQuery | undefined, GetHirePipelineStageApplicantsQueryVariables>;
export function useGetHirePipelineStageApplicantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>(GetHirePipelineStageApplicantsDocument, options);
        }
export type GetHirePipelineStageApplicantsQueryHookResult = ReturnType<typeof useGetHirePipelineStageApplicantsQuery>;
export type GetHirePipelineStageApplicantsLazyQueryHookResult = ReturnType<typeof useGetHirePipelineStageApplicantsLazyQuery>;
export type GetHirePipelineStageApplicantsSuspenseQueryHookResult = ReturnType<typeof useGetHirePipelineStageApplicantsSuspenseQuery>;
export type GetHirePipelineStageApplicantsQueryResult = Apollo.QueryResult<GetHirePipelineStageApplicantsQuery, GetHirePipelineStageApplicantsQueryVariables>;
export const UpdateListingScoreWeightsDocument = gql`
    mutation UpdateListingScoreWeights($listingId: ID!, $input: ListingScoreWeightsUpdateInput!) {
  listingScoreWeightsUpdate(listingId: $listingId, input: $input) {
    listingScoreWeights {
      skills
      assessments
      qualifications
    }
    errors {
      message
      code
    }
  }
}
    `;
export type UpdateListingScoreWeightsMutationFn = Apollo.MutationFunction<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>;

/**
 * __useUpdateListingScoreWeightsMutation__
 *
 * To run a mutation, you first call `useUpdateListingScoreWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingScoreWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingScoreWeightsMutation, { data, loading, error }] = useUpdateListingScoreWeightsMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingScoreWeightsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>(UpdateListingScoreWeightsDocument, options);
      }
export type UpdateListingScoreWeightsMutationHookResult = ReturnType<typeof useUpdateListingScoreWeightsMutation>;
export type UpdateListingScoreWeightsMutationResult = Apollo.MutationResult<UpdateListingScoreWeightsMutation>;
export type UpdateListingScoreWeightsMutationOptions = Apollo.BaseMutationOptions<UpdateListingScoreWeightsMutation, UpdateListingScoreWeightsMutationVariables>;
export const GetMessageTemplatesDocument = gql`
    query getMessageTemplates($enabled: Boolean) {
  messageTemplates(enabled: $enabled) {
    id
    organisationId
    name
    description
    subject
    content
    enabled
  }
}
    `;

/**
 * __useGetMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplatesQuery({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useGetMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
      }
export function useGetMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
        }
// @ts-ignore
export function useGetMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>;
export function useGetMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageTemplatesQuery | undefined, GetMessageTemplatesQueryVariables>;
export function useGetMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
        }
export type GetMessageTemplatesQueryHookResult = ReturnType<typeof useGetMessageTemplatesQuery>;
export type GetMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageTemplatesLazyQuery>;
export type GetMessageTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMessageTemplatesSuspenseQuery>;
export type GetMessageTemplatesQueryResult = Apollo.QueryResult<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>;
export const GetOfferDocument = gql`
    query GetOffer($applicationId: ID!) {
  offer(applicationId: $applicationId) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables> & ({ variables: GetOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
// @ts-ignore
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferQuery, GetOfferQueryVariables>;
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferQuery | undefined, GetOfferQueryVariables>;
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferSuspenseQueryHookResult = ReturnType<typeof useGetOfferSuspenseQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const GetOfferActivityDocument = gql`
    query GetOfferActivity($applicationId: ID!) {
  offer(applicationId: $applicationId) {
    id
    activity {
      id
      action
      actor
      details
      timestamp
      actorUser {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useGetOfferActivityQuery__
 *
 * To run a query within a React component, call `useGetOfferActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferActivityQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetOfferActivityQuery(baseOptions: Apollo.QueryHookOptions<GetOfferActivityQuery, GetOfferActivityQueryVariables> & ({ variables: GetOfferActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferActivityQuery, GetOfferActivityQueryVariables>(GetOfferActivityDocument, options);
      }
export function useGetOfferActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferActivityQuery, GetOfferActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferActivityQuery, GetOfferActivityQueryVariables>(GetOfferActivityDocument, options);
        }
// @ts-ignore
export function useGetOfferActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferActivityQuery, GetOfferActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferActivityQuery, GetOfferActivityQueryVariables>;
export function useGetOfferActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferActivityQuery, GetOfferActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferActivityQuery | undefined, GetOfferActivityQueryVariables>;
export function useGetOfferActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferActivityQuery, GetOfferActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferActivityQuery, GetOfferActivityQueryVariables>(GetOfferActivityDocument, options);
        }
export type GetOfferActivityQueryHookResult = ReturnType<typeof useGetOfferActivityQuery>;
export type GetOfferActivityLazyQueryHookResult = ReturnType<typeof useGetOfferActivityLazyQuery>;
export type GetOfferActivitySuspenseQueryHookResult = ReturnType<typeof useGetOfferActivitySuspenseQuery>;
export type GetOfferActivityQueryResult = Apollo.QueryResult<GetOfferActivityQuery, GetOfferActivityQueryVariables>;
export const OfferStartDocument = gql`
    mutation OfferStart($applicationId: ID!, $input: OfferDetailsInput) {
  offerStart(applicationId: $applicationId, input: $input) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferStartMutationFn = Apollo.MutationFunction<OfferStartMutation, OfferStartMutationVariables>;

/**
 * __useOfferStartMutation__
 *
 * To run a mutation, you first call `useOfferStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerStartMutation, { data, loading, error }] = useOfferStartMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferStartMutation(baseOptions?: Apollo.MutationHookOptions<OfferStartMutation, OfferStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferStartMutation, OfferStartMutationVariables>(OfferStartDocument, options);
      }
export type OfferStartMutationHookResult = ReturnType<typeof useOfferStartMutation>;
export type OfferStartMutationResult = Apollo.MutationResult<OfferStartMutation>;
export type OfferStartMutationOptions = Apollo.BaseMutationOptions<OfferStartMutation, OfferStartMutationVariables>;
export const OfferSaveDetailsDocument = gql`
    mutation OfferSaveDetails($applicationId: ID!, $input: OfferDetailsInput!) {
  offerSaveDetails(applicationId: $applicationId, input: $input) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferSaveDetailsMutationFn = Apollo.MutationFunction<OfferSaveDetailsMutation, OfferSaveDetailsMutationVariables>;

/**
 * __useOfferSaveDetailsMutation__
 *
 * To run a mutation, you first call `useOfferSaveDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferSaveDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerSaveDetailsMutation, { data, loading, error }] = useOfferSaveDetailsMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferSaveDetailsMutation(baseOptions?: Apollo.MutationHookOptions<OfferSaveDetailsMutation, OfferSaveDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferSaveDetailsMutation, OfferSaveDetailsMutationVariables>(OfferSaveDetailsDocument, options);
      }
export type OfferSaveDetailsMutationHookResult = ReturnType<typeof useOfferSaveDetailsMutation>;
export type OfferSaveDetailsMutationResult = Apollo.MutationResult<OfferSaveDetailsMutation>;
export type OfferSaveDetailsMutationOptions = Apollo.BaseMutationOptions<OfferSaveDetailsMutation, OfferSaveDetailsMutationVariables>;
export const OfferApprovalStartDocument = gql`
    mutation OfferApprovalStart($applicationId: ID!) {
  offerApprovalStart(applicationId: $applicationId) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalStartMutationFn = Apollo.MutationFunction<OfferApprovalStartMutation, OfferApprovalStartMutationVariables>;

/**
 * __useOfferApprovalStartMutation__
 *
 * To run a mutation, you first call `useOfferApprovalStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalStartMutation, { data, loading, error }] = useOfferApprovalStartMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useOfferApprovalStartMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalStartMutation, OfferApprovalStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalStartMutation, OfferApprovalStartMutationVariables>(OfferApprovalStartDocument, options);
      }
export type OfferApprovalStartMutationHookResult = ReturnType<typeof useOfferApprovalStartMutation>;
export type OfferApprovalStartMutationResult = Apollo.MutationResult<OfferApprovalStartMutation>;
export type OfferApprovalStartMutationOptions = Apollo.BaseMutationOptions<OfferApprovalStartMutation, OfferApprovalStartMutationVariables>;
export const OfferApprovalSubmitDocument = gql`
    mutation OfferApprovalSubmit($applicationId: ID!, $input: OfferApprovalSubmitInput!) {
  offerApprovalSubmit(applicationId: $applicationId, input: $input) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalSubmitMutationFn = Apollo.MutationFunction<OfferApprovalSubmitMutation, OfferApprovalSubmitMutationVariables>;

/**
 * __useOfferApprovalSubmitMutation__
 *
 * To run a mutation, you first call `useOfferApprovalSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalSubmitMutation, { data, loading, error }] = useOfferApprovalSubmitMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferApprovalSubmitMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalSubmitMutation, OfferApprovalSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalSubmitMutation, OfferApprovalSubmitMutationVariables>(OfferApprovalSubmitDocument, options);
      }
export type OfferApprovalSubmitMutationHookResult = ReturnType<typeof useOfferApprovalSubmitMutation>;
export type OfferApprovalSubmitMutationResult = Apollo.MutationResult<OfferApprovalSubmitMutation>;
export type OfferApprovalSubmitMutationOptions = Apollo.BaseMutationOptions<OfferApprovalSubmitMutation, OfferApprovalSubmitMutationVariables>;
export const OfferApprovalApproveDocument = gql`
    mutation OfferApprovalApprove($applicationId: ID!, $comment: String) {
  offerApprovalApprove(applicationId: $applicationId, comment: $comment) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalApproveMutationFn = Apollo.MutationFunction<OfferApprovalApproveMutation, OfferApprovalApproveMutationVariables>;

/**
 * __useOfferApprovalApproveMutation__
 *
 * To run a mutation, you first call `useOfferApprovalApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalApproveMutation, { data, loading, error }] = useOfferApprovalApproveMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useOfferApprovalApproveMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalApproveMutation, OfferApprovalApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalApproveMutation, OfferApprovalApproveMutationVariables>(OfferApprovalApproveDocument, options);
      }
export type OfferApprovalApproveMutationHookResult = ReturnType<typeof useOfferApprovalApproveMutation>;
export type OfferApprovalApproveMutationResult = Apollo.MutationResult<OfferApprovalApproveMutation>;
export type OfferApprovalApproveMutationOptions = Apollo.BaseMutationOptions<OfferApprovalApproveMutation, OfferApprovalApproveMutationVariables>;
export const OfferApprovalDeclineDocument = gql`
    mutation OfferApprovalDecline($applicationId: ID!, $comment: String!) {
  offerApprovalDecline(applicationId: $applicationId, comment: $comment) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalDeclineMutationFn = Apollo.MutationFunction<OfferApprovalDeclineMutation, OfferApprovalDeclineMutationVariables>;

/**
 * __useOfferApprovalDeclineMutation__
 *
 * To run a mutation, you first call `useOfferApprovalDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalDeclineMutation, { data, loading, error }] = useOfferApprovalDeclineMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useOfferApprovalDeclineMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalDeclineMutation, OfferApprovalDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalDeclineMutation, OfferApprovalDeclineMutationVariables>(OfferApprovalDeclineDocument, options);
      }
export type OfferApprovalDeclineMutationHookResult = ReturnType<typeof useOfferApprovalDeclineMutation>;
export type OfferApprovalDeclineMutationResult = Apollo.MutationResult<OfferApprovalDeclineMutation>;
export type OfferApprovalDeclineMutationOptions = Apollo.BaseMutationOptions<OfferApprovalDeclineMutation, OfferApprovalDeclineMutationVariables>;
export const OfferApprovalResubmitDocument = gql`
    mutation OfferApprovalResubmit($applicationId: ID!, $amendmentsSummary: String, $input: OfferApprovalSubmitInput!) {
  offerApprovalResubmit(applicationId: $applicationId, amendmentsSummary: $amendmentsSummary, input: $input) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalResubmitMutationFn = Apollo.MutationFunction<OfferApprovalResubmitMutation, OfferApprovalResubmitMutationVariables>;

/**
 * __useOfferApprovalResubmitMutation__
 *
 * To run a mutation, you first call `useOfferApprovalResubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalResubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalResubmitMutation, { data, loading, error }] = useOfferApprovalResubmitMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      amendmentsSummary: // value for 'amendmentsSummary'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferApprovalResubmitMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalResubmitMutation, OfferApprovalResubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalResubmitMutation, OfferApprovalResubmitMutationVariables>(OfferApprovalResubmitDocument, options);
      }
export type OfferApprovalResubmitMutationHookResult = ReturnType<typeof useOfferApprovalResubmitMutation>;
export type OfferApprovalResubmitMutationResult = Apollo.MutationResult<OfferApprovalResubmitMutation>;
export type OfferApprovalResubmitMutationOptions = Apollo.BaseMutationOptions<OfferApprovalResubmitMutation, OfferApprovalResubmitMutationVariables>;
export const OfferApprovalWithdrawDocument = gql`
    mutation OfferApprovalWithdraw($applicationId: ID!) {
  offerApprovalWithdraw(applicationId: $applicationId) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalWithdrawMutationFn = Apollo.MutationFunction<OfferApprovalWithdrawMutation, OfferApprovalWithdrawMutationVariables>;

/**
 * __useOfferApprovalWithdrawMutation__
 *
 * To run a mutation, you first call `useOfferApprovalWithdrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalWithdrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalWithdrawMutation, { data, loading, error }] = useOfferApprovalWithdrawMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useOfferApprovalWithdrawMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalWithdrawMutation, OfferApprovalWithdrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalWithdrawMutation, OfferApprovalWithdrawMutationVariables>(OfferApprovalWithdrawDocument, options);
      }
export type OfferApprovalWithdrawMutationHookResult = ReturnType<typeof useOfferApprovalWithdrawMutation>;
export type OfferApprovalWithdrawMutationResult = Apollo.MutationResult<OfferApprovalWithdrawMutation>;
export type OfferApprovalWithdrawMutationOptions = Apollo.BaseMutationOptions<OfferApprovalWithdrawMutation, OfferApprovalWithdrawMutationVariables>;
export const OfferApprovalAddApproverDocument = gql`
    mutation OfferApprovalAddApprover($applicationId: ID!, $userId: ID!, $approvalTypes: [String!]!) {
  offerApprovalAddApprover(applicationId: $applicationId, userId: $userId, approvalTypes: $approvalTypes) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalAddApproverMutationFn = Apollo.MutationFunction<OfferApprovalAddApproverMutation, OfferApprovalAddApproverMutationVariables>;

/**
 * __useOfferApprovalAddApproverMutation__
 *
 * To run a mutation, you first call `useOfferApprovalAddApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalAddApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalAddApproverMutation, { data, loading, error }] = useOfferApprovalAddApproverMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      userId: // value for 'userId'
 *      approvalTypes: // value for 'approvalTypes'
 *   },
 * });
 */
export function useOfferApprovalAddApproverMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalAddApproverMutation, OfferApprovalAddApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalAddApproverMutation, OfferApprovalAddApproverMutationVariables>(OfferApprovalAddApproverDocument, options);
      }
export type OfferApprovalAddApproverMutationHookResult = ReturnType<typeof useOfferApprovalAddApproverMutation>;
export type OfferApprovalAddApproverMutationResult = Apollo.MutationResult<OfferApprovalAddApproverMutation>;
export type OfferApprovalAddApproverMutationOptions = Apollo.BaseMutationOptions<OfferApprovalAddApproverMutation, OfferApprovalAddApproverMutationVariables>;
export const OfferApprovalRemoveApproverDocument = gql`
    mutation OfferApprovalRemoveApprover($applicationId: ID!, $userId: ID!) {
  offerApprovalRemoveApprover(applicationId: $applicationId, userId: $userId) {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;
export type OfferApprovalRemoveApproverMutationFn = Apollo.MutationFunction<OfferApprovalRemoveApproverMutation, OfferApprovalRemoveApproverMutationVariables>;

/**
 * __useOfferApprovalRemoveApproverMutation__
 *
 * To run a mutation, you first call `useOfferApprovalRemoveApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalRemoveApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalRemoveApproverMutation, { data, loading, error }] = useOfferApprovalRemoveApproverMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOfferApprovalRemoveApproverMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalRemoveApproverMutation, OfferApprovalRemoveApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalRemoveApproverMutation, OfferApprovalRemoveApproverMutationVariables>(OfferApprovalRemoveApproverDocument, options);
      }
export type OfferApprovalRemoveApproverMutationHookResult = ReturnType<typeof useOfferApprovalRemoveApproverMutation>;
export type OfferApprovalRemoveApproverMutationResult = Apollo.MutationResult<OfferApprovalRemoveApproverMutation>;
export type OfferApprovalRemoveApproverMutationOptions = Apollo.BaseMutationOptions<OfferApprovalRemoveApproverMutation, OfferApprovalRemoveApproverMutationVariables>;
export const GetMyOfferApprovalsDocument = gql`
    query GetMyOfferApprovals {
  myOfferApprovals {
    ...OfferFields
  }
}
    ${OfferFieldsFragmentDoc}`;

/**
 * __useGetMyOfferApprovalsQuery__
 *
 * To run a query within a React component, call `useGetMyOfferApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOfferApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOfferApprovalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOfferApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>(GetMyOfferApprovalsDocument, options);
      }
export function useGetMyOfferApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>(GetMyOfferApprovalsDocument, options);
        }
// @ts-ignore
export function useGetMyOfferApprovalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>;
export function useGetMyOfferApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyOfferApprovalsQuery | undefined, GetMyOfferApprovalsQueryVariables>;
export function useGetMyOfferApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>(GetMyOfferApprovalsDocument, options);
        }
export type GetMyOfferApprovalsQueryHookResult = ReturnType<typeof useGetMyOfferApprovalsQuery>;
export type GetMyOfferApprovalsLazyQueryHookResult = ReturnType<typeof useGetMyOfferApprovalsLazyQuery>;
export type GetMyOfferApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetMyOfferApprovalsSuspenseQuery>;
export type GetMyOfferApprovalsQueryResult = Apollo.QueryResult<GetMyOfferApprovalsQuery, GetMyOfferApprovalsQueryVariables>;
export const GetOfferApprovalsDocument = gql`
    query GetOfferApprovals {
  offerApprovals {
    ...OfferCoreFields
    application {
      id
      listing {
        id
      }
      applicant {
        id
        name
      }
    }
  }
}
    ${OfferCoreFieldsFragmentDoc}`;

/**
 * __useGetOfferApprovalsQuery__
 *
 * To run a query within a React component, call `useGetOfferApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferApprovalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>(GetOfferApprovalsDocument, options);
      }
export function useGetOfferApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>(GetOfferApprovalsDocument, options);
        }
// @ts-ignore
export function useGetOfferApprovalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>;
export function useGetOfferApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferApprovalsQuery | undefined, GetOfferApprovalsQueryVariables>;
export function useGetOfferApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>(GetOfferApprovalsDocument, options);
        }
export type GetOfferApprovalsQueryHookResult = ReturnType<typeof useGetOfferApprovalsQuery>;
export type GetOfferApprovalsLazyQueryHookResult = ReturnType<typeof useGetOfferApprovalsLazyQuery>;
export type GetOfferApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetOfferApprovalsSuspenseQuery>;
export type GetOfferApprovalsQueryResult = Apollo.QueryResult<GetOfferApprovalsQuery, GetOfferApprovalsQueryVariables>;
export const GetOfferEligibleApproversDocument = gql`
    query GetOfferEligibleApprovers {
  offerEligibleApprovers {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useGetOfferEligibleApproversQuery__
 *
 * To run a query within a React component, call `useGetOfferEligibleApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferEligibleApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferEligibleApproversQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferEligibleApproversQuery(baseOptions?: Apollo.QueryHookOptions<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>(GetOfferEligibleApproversDocument, options);
      }
export function useGetOfferEligibleApproversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>(GetOfferEligibleApproversDocument, options);
        }
// @ts-ignore
export function useGetOfferEligibleApproversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>;
export function useGetOfferEligibleApproversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferEligibleApproversQuery | undefined, GetOfferEligibleApproversQueryVariables>;
export function useGetOfferEligibleApproversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>(GetOfferEligibleApproversDocument, options);
        }
export type GetOfferEligibleApproversQueryHookResult = ReturnType<typeof useGetOfferEligibleApproversQuery>;
export type GetOfferEligibleApproversLazyQueryHookResult = ReturnType<typeof useGetOfferEligibleApproversLazyQuery>;
export type GetOfferEligibleApproversSuspenseQueryHookResult = ReturnType<typeof useGetOfferEligibleApproversSuspenseQuery>;
export type GetOfferEligibleApproversQueryResult = Apollo.QueryResult<GetOfferEligibleApproversQuery, GetOfferEligibleApproversQueryVariables>;
export const GetOfferApprovalConfigDocument = gql`
    query GetOfferApprovalConfig {
  offerApprovalConfig {
    enabled
    approvalTypes
    hiddenCandidateSections
    approvers {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetOfferApprovalConfigQuery__
 *
 * To run a query within a React component, call `useGetOfferApprovalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferApprovalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferApprovalConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferApprovalConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>(GetOfferApprovalConfigDocument, options);
      }
export function useGetOfferApprovalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>(GetOfferApprovalConfigDocument, options);
        }
// @ts-ignore
export function useGetOfferApprovalConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>;
export function useGetOfferApprovalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferApprovalConfigQuery | undefined, GetOfferApprovalConfigQueryVariables>;
export function useGetOfferApprovalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>(GetOfferApprovalConfigDocument, options);
        }
export type GetOfferApprovalConfigQueryHookResult = ReturnType<typeof useGetOfferApprovalConfigQuery>;
export type GetOfferApprovalConfigLazyQueryHookResult = ReturnType<typeof useGetOfferApprovalConfigLazyQuery>;
export type GetOfferApprovalConfigSuspenseQueryHookResult = ReturnType<typeof useGetOfferApprovalConfigSuspenseQuery>;
export type GetOfferApprovalConfigQueryResult = Apollo.QueryResult<GetOfferApprovalConfigQuery, GetOfferApprovalConfigQueryVariables>;
export const OfferApprovalConfigSetEnabledDocument = gql`
    mutation OfferApprovalConfigSetEnabled($enabled: Boolean!) {
  offerApprovalConfigSetEnabled(enabled: $enabled) {
    ...OfferApprovalConfigFields
  }
}
    ${OfferApprovalConfigFieldsFragmentDoc}`;
export type OfferApprovalConfigSetEnabledMutationFn = Apollo.MutationFunction<OfferApprovalConfigSetEnabledMutation, OfferApprovalConfigSetEnabledMutationVariables>;

/**
 * __useOfferApprovalConfigSetEnabledMutation__
 *
 * To run a mutation, you first call `useOfferApprovalConfigSetEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalConfigSetEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalConfigSetEnabledMutation, { data, loading, error }] = useOfferApprovalConfigSetEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useOfferApprovalConfigSetEnabledMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalConfigSetEnabledMutation, OfferApprovalConfigSetEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalConfigSetEnabledMutation, OfferApprovalConfigSetEnabledMutationVariables>(OfferApprovalConfigSetEnabledDocument, options);
      }
export type OfferApprovalConfigSetEnabledMutationHookResult = ReturnType<typeof useOfferApprovalConfigSetEnabledMutation>;
export type OfferApprovalConfigSetEnabledMutationResult = Apollo.MutationResult<OfferApprovalConfigSetEnabledMutation>;
export type OfferApprovalConfigSetEnabledMutationOptions = Apollo.BaseMutationOptions<OfferApprovalConfigSetEnabledMutation, OfferApprovalConfigSetEnabledMutationVariables>;
export const OfferApprovalTypeAddDocument = gql`
    mutation OfferApprovalTypeAdd($label: String!) {
  offerApprovalTypeAdd(label: $label) {
    ...OfferApprovalConfigFields
  }
}
    ${OfferApprovalConfigFieldsFragmentDoc}`;
export type OfferApprovalTypeAddMutationFn = Apollo.MutationFunction<OfferApprovalTypeAddMutation, OfferApprovalTypeAddMutationVariables>;

/**
 * __useOfferApprovalTypeAddMutation__
 *
 * To run a mutation, you first call `useOfferApprovalTypeAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalTypeAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalTypeAddMutation, { data, loading, error }] = useOfferApprovalTypeAddMutation({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useOfferApprovalTypeAddMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalTypeAddMutation, OfferApprovalTypeAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalTypeAddMutation, OfferApprovalTypeAddMutationVariables>(OfferApprovalTypeAddDocument, options);
      }
export type OfferApprovalTypeAddMutationHookResult = ReturnType<typeof useOfferApprovalTypeAddMutation>;
export type OfferApprovalTypeAddMutationResult = Apollo.MutationResult<OfferApprovalTypeAddMutation>;
export type OfferApprovalTypeAddMutationOptions = Apollo.BaseMutationOptions<OfferApprovalTypeAddMutation, OfferApprovalTypeAddMutationVariables>;
export const OfferApprovalTypeRemoveDocument = gql`
    mutation OfferApprovalTypeRemove($label: String!) {
  offerApprovalTypeRemove(label: $label) {
    ...OfferApprovalConfigFields
  }
}
    ${OfferApprovalConfigFieldsFragmentDoc}`;
export type OfferApprovalTypeRemoveMutationFn = Apollo.MutationFunction<OfferApprovalTypeRemoveMutation, OfferApprovalTypeRemoveMutationVariables>;

/**
 * __useOfferApprovalTypeRemoveMutation__
 *
 * To run a mutation, you first call `useOfferApprovalTypeRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalTypeRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalTypeRemoveMutation, { data, loading, error }] = useOfferApprovalTypeRemoveMutation({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useOfferApprovalTypeRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalTypeRemoveMutation, OfferApprovalTypeRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalTypeRemoveMutation, OfferApprovalTypeRemoveMutationVariables>(OfferApprovalTypeRemoveDocument, options);
      }
export type OfferApprovalTypeRemoveMutationHookResult = ReturnType<typeof useOfferApprovalTypeRemoveMutation>;
export type OfferApprovalTypeRemoveMutationResult = Apollo.MutationResult<OfferApprovalTypeRemoveMutation>;
export type OfferApprovalTypeRemoveMutationOptions = Apollo.BaseMutationOptions<OfferApprovalTypeRemoveMutation, OfferApprovalTypeRemoveMutationVariables>;
export const OfferApprovalConfigSetCandidateSectionDocument = gql`
    mutation OfferApprovalConfigSetCandidateSection($section: OfferCandidateSection!, $visible: Boolean!) {
  offerApprovalConfigSetCandidateSection(section: $section, visible: $visible) {
    ...OfferApprovalConfigFields
  }
}
    ${OfferApprovalConfigFieldsFragmentDoc}`;
export type OfferApprovalConfigSetCandidateSectionMutationFn = Apollo.MutationFunction<OfferApprovalConfigSetCandidateSectionMutation, OfferApprovalConfigSetCandidateSectionMutationVariables>;

/**
 * __useOfferApprovalConfigSetCandidateSectionMutation__
 *
 * To run a mutation, you first call `useOfferApprovalConfigSetCandidateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApprovalConfigSetCandidateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApprovalConfigSetCandidateSectionMutation, { data, loading, error }] = useOfferApprovalConfigSetCandidateSectionMutation({
 *   variables: {
 *      section: // value for 'section'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useOfferApprovalConfigSetCandidateSectionMutation(baseOptions?: Apollo.MutationHookOptions<OfferApprovalConfigSetCandidateSectionMutation, OfferApprovalConfigSetCandidateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApprovalConfigSetCandidateSectionMutation, OfferApprovalConfigSetCandidateSectionMutationVariables>(OfferApprovalConfigSetCandidateSectionDocument, options);
      }
export type OfferApprovalConfigSetCandidateSectionMutationHookResult = ReturnType<typeof useOfferApprovalConfigSetCandidateSectionMutation>;
export type OfferApprovalConfigSetCandidateSectionMutationResult = Apollo.MutationResult<OfferApprovalConfigSetCandidateSectionMutation>;
export type OfferApprovalConfigSetCandidateSectionMutationOptions = Apollo.BaseMutationOptions<OfferApprovalConfigSetCandidateSectionMutation, OfferApprovalConfigSetCandidateSectionMutationVariables>;
export const OfferApproverAddDocument = gql`
    mutation OfferApproverAdd($userId: ID!) {
  offerApproverAdd(userId: $userId) {
    ...OfferApprovalConfigFields
  }
}
    ${OfferApprovalConfigFieldsFragmentDoc}`;
export type OfferApproverAddMutationFn = Apollo.MutationFunction<OfferApproverAddMutation, OfferApproverAddMutationVariables>;

/**
 * __useOfferApproverAddMutation__
 *
 * To run a mutation, you first call `useOfferApproverAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApproverAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApproverAddMutation, { data, loading, error }] = useOfferApproverAddMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOfferApproverAddMutation(baseOptions?: Apollo.MutationHookOptions<OfferApproverAddMutation, OfferApproverAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApproverAddMutation, OfferApproverAddMutationVariables>(OfferApproverAddDocument, options);
      }
export type OfferApproverAddMutationHookResult = ReturnType<typeof useOfferApproverAddMutation>;
export type OfferApproverAddMutationResult = Apollo.MutationResult<OfferApproverAddMutation>;
export type OfferApproverAddMutationOptions = Apollo.BaseMutationOptions<OfferApproverAddMutation, OfferApproverAddMutationVariables>;
export const OfferApproverRemoveDocument = gql`
    mutation OfferApproverRemove($userId: ID!) {
  offerApproverRemove(userId: $userId) {
    ...OfferApprovalConfigFields
  }
}
    ${OfferApprovalConfigFieldsFragmentDoc}`;
export type OfferApproverRemoveMutationFn = Apollo.MutationFunction<OfferApproverRemoveMutation, OfferApproverRemoveMutationVariables>;

/**
 * __useOfferApproverRemoveMutation__
 *
 * To run a mutation, you first call `useOfferApproverRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferApproverRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerApproverRemoveMutation, { data, loading, error }] = useOfferApproverRemoveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOfferApproverRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OfferApproverRemoveMutation, OfferApproverRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferApproverRemoveMutation, OfferApproverRemoveMutationVariables>(OfferApproverRemoveDocument, options);
      }
export type OfferApproverRemoveMutationHookResult = ReturnType<typeof useOfferApproverRemoveMutation>;
export type OfferApproverRemoveMutationResult = Apollo.MutationResult<OfferApproverRemoveMutation>;
export type OfferApproverRemoveMutationOptions = Apollo.BaseMutationOptions<OfferApproverRemoveMutation, OfferApproverRemoveMutationVariables>;
export const GetOfferDocumentTypesDocument = gql`
    query GetOfferDocumentTypes {
  offerDocumentTypes {
    id
    name
  }
}
    `;

/**
 * __useGetOfferDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetOfferDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferDocumentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferDocumentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>(GetOfferDocumentTypesDocument, options);
      }
export function useGetOfferDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>(GetOfferDocumentTypesDocument, options);
        }
// @ts-ignore
export function useGetOfferDocumentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>;
export function useGetOfferDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentTypesQuery | undefined, GetOfferDocumentTypesQueryVariables>;
export function useGetOfferDocumentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>(GetOfferDocumentTypesDocument, options);
        }
export type GetOfferDocumentTypesQueryHookResult = ReturnType<typeof useGetOfferDocumentTypesQuery>;
export type GetOfferDocumentTypesLazyQueryHookResult = ReturnType<typeof useGetOfferDocumentTypesLazyQuery>;
export type GetOfferDocumentTypesSuspenseQueryHookResult = ReturnType<typeof useGetOfferDocumentTypesSuspenseQuery>;
export type GetOfferDocumentTypesQueryResult = Apollo.QueryResult<GetOfferDocumentTypesQuery, GetOfferDocumentTypesQueryVariables>;
export const GetOfferDocumentTemplatesDocument = gql`
    query GetOfferDocumentTemplates {
  offerDocumentTemplates {
    id
    name
    documentTypeId
    fileName
    updatedAt
  }
}
    `;

/**
 * __useGetOfferDocumentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetOfferDocumentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferDocumentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferDocumentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferDocumentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>(GetOfferDocumentTemplatesDocument, options);
      }
export function useGetOfferDocumentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>(GetOfferDocumentTemplatesDocument, options);
        }
// @ts-ignore
export function useGetOfferDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>;
export function useGetOfferDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentTemplatesQuery | undefined, GetOfferDocumentTemplatesQueryVariables>;
export function useGetOfferDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>(GetOfferDocumentTemplatesDocument, options);
        }
export type GetOfferDocumentTemplatesQueryHookResult = ReturnType<typeof useGetOfferDocumentTemplatesQuery>;
export type GetOfferDocumentTemplatesLazyQueryHookResult = ReturnType<typeof useGetOfferDocumentTemplatesLazyQuery>;
export type GetOfferDocumentTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetOfferDocumentTemplatesSuspenseQuery>;
export type GetOfferDocumentTemplatesQueryResult = Apollo.QueryResult<GetOfferDocumentTemplatesQuery, GetOfferDocumentTemplatesQueryVariables>;
export const GetOfferDocumentPackagesDocument = gql`
    query GetOfferDocumentPackages {
  offerDocumentPackages {
    id
    name
    description
    templateIds
  }
}
    `;

/**
 * __useGetOfferDocumentPackagesQuery__
 *
 * To run a query within a React component, call `useGetOfferDocumentPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferDocumentPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferDocumentPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferDocumentPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>(GetOfferDocumentPackagesDocument, options);
      }
export function useGetOfferDocumentPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>(GetOfferDocumentPackagesDocument, options);
        }
// @ts-ignore
export function useGetOfferDocumentPackagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>;
export function useGetOfferDocumentPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentPackagesQuery | undefined, GetOfferDocumentPackagesQueryVariables>;
export function useGetOfferDocumentPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>(GetOfferDocumentPackagesDocument, options);
        }
export type GetOfferDocumentPackagesQueryHookResult = ReturnType<typeof useGetOfferDocumentPackagesQuery>;
export type GetOfferDocumentPackagesLazyQueryHookResult = ReturnType<typeof useGetOfferDocumentPackagesLazyQuery>;
export type GetOfferDocumentPackagesSuspenseQueryHookResult = ReturnType<typeof useGetOfferDocumentPackagesSuspenseQuery>;
export type GetOfferDocumentPackagesQueryResult = Apollo.QueryResult<GetOfferDocumentPackagesQuery, GetOfferDocumentPackagesQueryVariables>;
export const OfferDocumentTypeCreateDocument = gql`
    mutation OfferDocumentTypeCreate($name: String!) {
  offerDocumentTypeCreate(name: $name) {
    id
    name
  }
}
    `;
export type OfferDocumentTypeCreateMutationFn = Apollo.MutationFunction<OfferDocumentTypeCreateMutation, OfferDocumentTypeCreateMutationVariables>;

/**
 * __useOfferDocumentTypeCreateMutation__
 *
 * To run a mutation, you first call `useOfferDocumentTypeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentTypeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentTypeCreateMutation, { data, loading, error }] = useOfferDocumentTypeCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOfferDocumentTypeCreateMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentTypeCreateMutation, OfferDocumentTypeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentTypeCreateMutation, OfferDocumentTypeCreateMutationVariables>(OfferDocumentTypeCreateDocument, options);
      }
export type OfferDocumentTypeCreateMutationHookResult = ReturnType<typeof useOfferDocumentTypeCreateMutation>;
export type OfferDocumentTypeCreateMutationResult = Apollo.MutationResult<OfferDocumentTypeCreateMutation>;
export type OfferDocumentTypeCreateMutationOptions = Apollo.BaseMutationOptions<OfferDocumentTypeCreateMutation, OfferDocumentTypeCreateMutationVariables>;
export const OfferDocumentTypeRemoveDocument = gql`
    mutation OfferDocumentTypeRemove($documentTypeId: ID!) {
  offerDocumentTypeRemove(documentTypeId: $documentTypeId) {
    id
    name
  }
}
    `;
export type OfferDocumentTypeRemoveMutationFn = Apollo.MutationFunction<OfferDocumentTypeRemoveMutation, OfferDocumentTypeRemoveMutationVariables>;

/**
 * __useOfferDocumentTypeRemoveMutation__
 *
 * To run a mutation, you first call `useOfferDocumentTypeRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentTypeRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentTypeRemoveMutation, { data, loading, error }] = useOfferDocumentTypeRemoveMutation({
 *   variables: {
 *      documentTypeId: // value for 'documentTypeId'
 *   },
 * });
 */
export function useOfferDocumentTypeRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentTypeRemoveMutation, OfferDocumentTypeRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentTypeRemoveMutation, OfferDocumentTypeRemoveMutationVariables>(OfferDocumentTypeRemoveDocument, options);
      }
export type OfferDocumentTypeRemoveMutationHookResult = ReturnType<typeof useOfferDocumentTypeRemoveMutation>;
export type OfferDocumentTypeRemoveMutationResult = Apollo.MutationResult<OfferDocumentTypeRemoveMutation>;
export type OfferDocumentTypeRemoveMutationOptions = Apollo.BaseMutationOptions<OfferDocumentTypeRemoveMutation, OfferDocumentTypeRemoveMutationVariables>;
export const OfferDocumentTemplateCreateDocument = gql`
    mutation OfferDocumentTemplateCreate($input: OfferDocumentTemplateCreateInput!) {
  offerDocumentTemplateCreate(input: $input) {
    id
    name
    documentTypeId
    fileName
    updatedAt
  }
}
    `;
export type OfferDocumentTemplateCreateMutationFn = Apollo.MutationFunction<OfferDocumentTemplateCreateMutation, OfferDocumentTemplateCreateMutationVariables>;

/**
 * __useOfferDocumentTemplateCreateMutation__
 *
 * To run a mutation, you first call `useOfferDocumentTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentTemplateCreateMutation, { data, loading, error }] = useOfferDocumentTemplateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferDocumentTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentTemplateCreateMutation, OfferDocumentTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentTemplateCreateMutation, OfferDocumentTemplateCreateMutationVariables>(OfferDocumentTemplateCreateDocument, options);
      }
export type OfferDocumentTemplateCreateMutationHookResult = ReturnType<typeof useOfferDocumentTemplateCreateMutation>;
export type OfferDocumentTemplateCreateMutationResult = Apollo.MutationResult<OfferDocumentTemplateCreateMutation>;
export type OfferDocumentTemplateCreateMutationOptions = Apollo.BaseMutationOptions<OfferDocumentTemplateCreateMutation, OfferDocumentTemplateCreateMutationVariables>;
export const OfferDocumentTemplateRemoveDocument = gql`
    mutation OfferDocumentTemplateRemove($templateId: ID!) {
  offerDocumentTemplateRemove(templateId: $templateId) {
    id
    name
    documentTypeId
    fileName
    updatedAt
  }
}
    `;
export type OfferDocumentTemplateRemoveMutationFn = Apollo.MutationFunction<OfferDocumentTemplateRemoveMutation, OfferDocumentTemplateRemoveMutationVariables>;

/**
 * __useOfferDocumentTemplateRemoveMutation__
 *
 * To run a mutation, you first call `useOfferDocumentTemplateRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentTemplateRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentTemplateRemoveMutation, { data, loading, error }] = useOfferDocumentTemplateRemoveMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useOfferDocumentTemplateRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentTemplateRemoveMutation, OfferDocumentTemplateRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentTemplateRemoveMutation, OfferDocumentTemplateRemoveMutationVariables>(OfferDocumentTemplateRemoveDocument, options);
      }
export type OfferDocumentTemplateRemoveMutationHookResult = ReturnType<typeof useOfferDocumentTemplateRemoveMutation>;
export type OfferDocumentTemplateRemoveMutationResult = Apollo.MutationResult<OfferDocumentTemplateRemoveMutation>;
export type OfferDocumentTemplateRemoveMutationOptions = Apollo.BaseMutationOptions<OfferDocumentTemplateRemoveMutation, OfferDocumentTemplateRemoveMutationVariables>;
export const OfferDocumentPackageCreateDocument = gql`
    mutation OfferDocumentPackageCreate($input: OfferDocumentPackageInput!) {
  offerDocumentPackageCreate(input: $input) {
    id
    name
    description
    templateIds
  }
}
    `;
export type OfferDocumentPackageCreateMutationFn = Apollo.MutationFunction<OfferDocumentPackageCreateMutation, OfferDocumentPackageCreateMutationVariables>;

/**
 * __useOfferDocumentPackageCreateMutation__
 *
 * To run a mutation, you first call `useOfferDocumentPackageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentPackageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentPackageCreateMutation, { data, loading, error }] = useOfferDocumentPackageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferDocumentPackageCreateMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentPackageCreateMutation, OfferDocumentPackageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentPackageCreateMutation, OfferDocumentPackageCreateMutationVariables>(OfferDocumentPackageCreateDocument, options);
      }
export type OfferDocumentPackageCreateMutationHookResult = ReturnType<typeof useOfferDocumentPackageCreateMutation>;
export type OfferDocumentPackageCreateMutationResult = Apollo.MutationResult<OfferDocumentPackageCreateMutation>;
export type OfferDocumentPackageCreateMutationOptions = Apollo.BaseMutationOptions<OfferDocumentPackageCreateMutation, OfferDocumentPackageCreateMutationVariables>;
export const OfferDocumentPackageUpdateDocument = gql`
    mutation OfferDocumentPackageUpdate($packageId: ID!, $input: OfferDocumentPackageInput!) {
  offerDocumentPackageUpdate(packageId: $packageId, input: $input) {
    id
    name
    description
    templateIds
  }
}
    `;
export type OfferDocumentPackageUpdateMutationFn = Apollo.MutationFunction<OfferDocumentPackageUpdateMutation, OfferDocumentPackageUpdateMutationVariables>;

/**
 * __useOfferDocumentPackageUpdateMutation__
 *
 * To run a mutation, you first call `useOfferDocumentPackageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentPackageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentPackageUpdateMutation, { data, loading, error }] = useOfferDocumentPackageUpdateMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferDocumentPackageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentPackageUpdateMutation, OfferDocumentPackageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentPackageUpdateMutation, OfferDocumentPackageUpdateMutationVariables>(OfferDocumentPackageUpdateDocument, options);
      }
export type OfferDocumentPackageUpdateMutationHookResult = ReturnType<typeof useOfferDocumentPackageUpdateMutation>;
export type OfferDocumentPackageUpdateMutationResult = Apollo.MutationResult<OfferDocumentPackageUpdateMutation>;
export type OfferDocumentPackageUpdateMutationOptions = Apollo.BaseMutationOptions<OfferDocumentPackageUpdateMutation, OfferDocumentPackageUpdateMutationVariables>;
export const OfferDocumentPackageRemoveDocument = gql`
    mutation OfferDocumentPackageRemove($packageId: ID!) {
  offerDocumentPackageRemove(packageId: $packageId) {
    id
    name
    description
    templateIds
  }
}
    `;
export type OfferDocumentPackageRemoveMutationFn = Apollo.MutationFunction<OfferDocumentPackageRemoveMutation, OfferDocumentPackageRemoveMutationVariables>;

/**
 * __useOfferDocumentPackageRemoveMutation__
 *
 * To run a mutation, you first call `useOfferDocumentPackageRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentPackageRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentPackageRemoveMutation, { data, loading, error }] = useOfferDocumentPackageRemoveMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useOfferDocumentPackageRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentPackageRemoveMutation, OfferDocumentPackageRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentPackageRemoveMutation, OfferDocumentPackageRemoveMutationVariables>(OfferDocumentPackageRemoveDocument, options);
      }
export type OfferDocumentPackageRemoveMutationHookResult = ReturnType<typeof useOfferDocumentPackageRemoveMutation>;
export type OfferDocumentPackageRemoveMutationResult = Apollo.MutationResult<OfferDocumentPackageRemoveMutation>;
export type OfferDocumentPackageRemoveMutationOptions = Apollo.BaseMutationOptions<OfferDocumentPackageRemoveMutation, OfferDocumentPackageRemoveMutationVariables>;
export const OfferDocumentAddFromUploadDocument = gql`
    mutation OfferDocumentAddFromUpload($applicationId: ID!, $input: OfferDocumentUploadInput!) {
  offerDocumentAddFromUpload(applicationId: $applicationId, input: $input) {
    ...OfferDocumentFields
  }
}
    ${OfferDocumentFieldsFragmentDoc}`;
export type OfferDocumentAddFromUploadMutationFn = Apollo.MutationFunction<OfferDocumentAddFromUploadMutation, OfferDocumentAddFromUploadMutationVariables>;

/**
 * __useOfferDocumentAddFromUploadMutation__
 *
 * To run a mutation, you first call `useOfferDocumentAddFromUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentAddFromUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentAddFromUploadMutation, { data, loading, error }] = useOfferDocumentAddFromUploadMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferDocumentAddFromUploadMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentAddFromUploadMutation, OfferDocumentAddFromUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentAddFromUploadMutation, OfferDocumentAddFromUploadMutationVariables>(OfferDocumentAddFromUploadDocument, options);
      }
export type OfferDocumentAddFromUploadMutationHookResult = ReturnType<typeof useOfferDocumentAddFromUploadMutation>;
export type OfferDocumentAddFromUploadMutationResult = Apollo.MutationResult<OfferDocumentAddFromUploadMutation>;
export type OfferDocumentAddFromUploadMutationOptions = Apollo.BaseMutationOptions<OfferDocumentAddFromUploadMutation, OfferDocumentAddFromUploadMutationVariables>;
export const OfferDocumentAddFromTemplateDocument = gql`
    mutation OfferDocumentAddFromTemplate($applicationId: ID!, $templateId: ID!) {
  offerDocumentAddFromTemplate(applicationId: $applicationId, templateId: $templateId) {
    ...OfferDocumentFields
  }
}
    ${OfferDocumentFieldsFragmentDoc}`;
export type OfferDocumentAddFromTemplateMutationFn = Apollo.MutationFunction<OfferDocumentAddFromTemplateMutation, OfferDocumentAddFromTemplateMutationVariables>;

/**
 * __useOfferDocumentAddFromTemplateMutation__
 *
 * To run a mutation, you first call `useOfferDocumentAddFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentAddFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentAddFromTemplateMutation, { data, loading, error }] = useOfferDocumentAddFromTemplateMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useOfferDocumentAddFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentAddFromTemplateMutation, OfferDocumentAddFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentAddFromTemplateMutation, OfferDocumentAddFromTemplateMutationVariables>(OfferDocumentAddFromTemplateDocument, options);
      }
export type OfferDocumentAddFromTemplateMutationHookResult = ReturnType<typeof useOfferDocumentAddFromTemplateMutation>;
export type OfferDocumentAddFromTemplateMutationResult = Apollo.MutationResult<OfferDocumentAddFromTemplateMutation>;
export type OfferDocumentAddFromTemplateMutationOptions = Apollo.BaseMutationOptions<OfferDocumentAddFromTemplateMutation, OfferDocumentAddFromTemplateMutationVariables>;
export const OfferDocumentAddFromPackageDocument = gql`
    mutation OfferDocumentAddFromPackage($applicationId: ID!, $packageId: ID!) {
  offerDocumentAddFromPackage(applicationId: $applicationId, packageId: $packageId) {
    ...OfferDocumentFields
  }
}
    ${OfferDocumentFieldsFragmentDoc}`;
export type OfferDocumentAddFromPackageMutationFn = Apollo.MutationFunction<OfferDocumentAddFromPackageMutation, OfferDocumentAddFromPackageMutationVariables>;

/**
 * __useOfferDocumentAddFromPackageMutation__
 *
 * To run a mutation, you first call `useOfferDocumentAddFromPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentAddFromPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentAddFromPackageMutation, { data, loading, error }] = useOfferDocumentAddFromPackageMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useOfferDocumentAddFromPackageMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentAddFromPackageMutation, OfferDocumentAddFromPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentAddFromPackageMutation, OfferDocumentAddFromPackageMutationVariables>(OfferDocumentAddFromPackageDocument, options);
      }
export type OfferDocumentAddFromPackageMutationHookResult = ReturnType<typeof useOfferDocumentAddFromPackageMutation>;
export type OfferDocumentAddFromPackageMutationResult = Apollo.MutationResult<OfferDocumentAddFromPackageMutation>;
export type OfferDocumentAddFromPackageMutationOptions = Apollo.BaseMutationOptions<OfferDocumentAddFromPackageMutation, OfferDocumentAddFromPackageMutationVariables>;
export const OfferDocumentMarkSentDocument = gql`
    mutation OfferDocumentMarkSent($applicationId: ID!, $documentId: ID!, $messageId: ID) {
  offerDocumentMarkSent(applicationId: $applicationId, documentId: $documentId, messageId: $messageId) {
    ...OfferDocumentFields
  }
}
    ${OfferDocumentFieldsFragmentDoc}`;
export type OfferDocumentMarkSentMutationFn = Apollo.MutationFunction<OfferDocumentMarkSentMutation, OfferDocumentMarkSentMutationVariables>;

/**
 * __useOfferDocumentMarkSentMutation__
 *
 * To run a mutation, you first call `useOfferDocumentMarkSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentMarkSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentMarkSentMutation, { data, loading, error }] = useOfferDocumentMarkSentMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      documentId: // value for 'documentId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useOfferDocumentMarkSentMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentMarkSentMutation, OfferDocumentMarkSentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentMarkSentMutation, OfferDocumentMarkSentMutationVariables>(OfferDocumentMarkSentDocument, options);
      }
export type OfferDocumentMarkSentMutationHookResult = ReturnType<typeof useOfferDocumentMarkSentMutation>;
export type OfferDocumentMarkSentMutationResult = Apollo.MutationResult<OfferDocumentMarkSentMutation>;
export type OfferDocumentMarkSentMutationOptions = Apollo.BaseMutationOptions<OfferDocumentMarkSentMutation, OfferDocumentMarkSentMutationVariables>;
export const OfferDocumentRemoveDocument = gql`
    mutation OfferDocumentRemove($applicationId: ID!, $documentId: ID!) {
  offerDocumentRemove(applicationId: $applicationId, documentId: $documentId) {
    ...OfferDocumentFields
  }
}
    ${OfferDocumentFieldsFragmentDoc}`;
export type OfferDocumentRemoveMutationFn = Apollo.MutationFunction<OfferDocumentRemoveMutation, OfferDocumentRemoveMutationVariables>;

/**
 * __useOfferDocumentRemoveMutation__
 *
 * To run a mutation, you first call `useOfferDocumentRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentRemoveMutation, { data, loading, error }] = useOfferDocumentRemoveMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useOfferDocumentRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentRemoveMutation, OfferDocumentRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentRemoveMutation, OfferDocumentRemoveMutationVariables>(OfferDocumentRemoveDocument, options);
      }
export type OfferDocumentRemoveMutationHookResult = ReturnType<typeof useOfferDocumentRemoveMutation>;
export type OfferDocumentRemoveMutationResult = Apollo.MutationResult<OfferDocumentRemoveMutation>;
export type OfferDocumentRemoveMutationOptions = Apollo.BaseMutationOptions<OfferDocumentRemoveMutation, OfferDocumentRemoveMutationVariables>;
export const OfferDocumentAddToRepositoryDocument = gql`
    mutation OfferDocumentAddToRepository($applicationId: ID!, $input: OfferDocumentUploadInput!) {
  offerDocumentAddToRepository(applicationId: $applicationId, input: $input) {
    ...OfferDocumentFields
  }
}
    ${OfferDocumentFieldsFragmentDoc}`;
export type OfferDocumentAddToRepositoryMutationFn = Apollo.MutationFunction<OfferDocumentAddToRepositoryMutation, OfferDocumentAddToRepositoryMutationVariables>;

/**
 * __useOfferDocumentAddToRepositoryMutation__
 *
 * To run a mutation, you first call `useOfferDocumentAddToRepositoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferDocumentAddToRepositoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerDocumentAddToRepositoryMutation, { data, loading, error }] = useOfferDocumentAddToRepositoryMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferDocumentAddToRepositoryMutation(baseOptions?: Apollo.MutationHookOptions<OfferDocumentAddToRepositoryMutation, OfferDocumentAddToRepositoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferDocumentAddToRepositoryMutation, OfferDocumentAddToRepositoryMutationVariables>(OfferDocumentAddToRepositoryDocument, options);
      }
export type OfferDocumentAddToRepositoryMutationHookResult = ReturnType<typeof useOfferDocumentAddToRepositoryMutation>;
export type OfferDocumentAddToRepositoryMutationResult = Apollo.MutationResult<OfferDocumentAddToRepositoryMutation>;
export type OfferDocumentAddToRepositoryMutationOptions = Apollo.BaseMutationOptions<OfferDocumentAddToRepositoryMutation, OfferDocumentAddToRepositoryMutationVariables>;
export const GetOfferDocumentDownloadUrlDocument = gql`
    query GetOfferDocumentDownloadUrl($applicationId: ID!, $fileKey: String!, $fileName: String) {
  offerDocumentDownloadUrl(applicationId: $applicationId, fileKey: $fileKey, fileName: $fileName)
}
    `;

/**
 * __useGetOfferDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetOfferDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferDocumentDownloadUrlQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      fileKey: // value for 'fileKey'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetOfferDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables> & ({ variables: GetOfferDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>(GetOfferDocumentDownloadUrlDocument, options);
      }
export function useGetOfferDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>(GetOfferDocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetOfferDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>;
export function useGetOfferDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferDocumentDownloadUrlQuery | undefined, GetOfferDocumentDownloadUrlQueryVariables>;
export function useGetOfferDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>(GetOfferDocumentDownloadUrlDocument, options);
        }
export type GetOfferDocumentDownloadUrlQueryHookResult = ReturnType<typeof useGetOfferDocumentDownloadUrlQuery>;
export type GetOfferDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetOfferDocumentDownloadUrlLazyQuery>;
export type GetOfferDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetOfferDocumentDownloadUrlSuspenseQuery>;
export type GetOfferDocumentDownloadUrlQueryResult = Apollo.QueryResult<GetOfferDocumentDownloadUrlQuery, GetOfferDocumentDownloadUrlQueryVariables>;
export const GetOfferCandidateContextDocument = gql`
    query GetOfferCandidateContext($applicationId: ID!, $listingId: ID!) {
  application(id: $applicationId) {
    id
    applicant {
      id
    }
  }
  listing(id: $listingId) {
    id
    applicantCounts {
      total
      direct
    }
  }
}
    `;

/**
 * __useGetOfferCandidateContextQuery__
 *
 * To run a query within a React component, call `useGetOfferCandidateContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferCandidateContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferCandidateContextQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetOfferCandidateContextQuery(baseOptions: Apollo.QueryHookOptions<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables> & ({ variables: GetOfferCandidateContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>(GetOfferCandidateContextDocument, options);
      }
export function useGetOfferCandidateContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>(GetOfferCandidateContextDocument, options);
        }
// @ts-ignore
export function useGetOfferCandidateContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>;
export function useGetOfferCandidateContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferCandidateContextQuery | undefined, GetOfferCandidateContextQueryVariables>;
export function useGetOfferCandidateContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>(GetOfferCandidateContextDocument, options);
        }
export type GetOfferCandidateContextQueryHookResult = ReturnType<typeof useGetOfferCandidateContextQuery>;
export type GetOfferCandidateContextLazyQueryHookResult = ReturnType<typeof useGetOfferCandidateContextLazyQuery>;
export type GetOfferCandidateContextSuspenseQueryHookResult = ReturnType<typeof useGetOfferCandidateContextSuspenseQuery>;
export type GetOfferCandidateContextQueryResult = Apollo.QueryResult<GetOfferCandidateContextQuery, GetOfferCandidateContextQueryVariables>;
export const GetListingRequisitionIdDocument = gql`
    query GetListingRequisitionId($listingId: ID!) {
  listing(id: $listingId) {
    id
    requisitionId
  }
}
    `;

/**
 * __useGetListingRequisitionIdQuery__
 *
 * To run a query within a React component, call `useGetListingRequisitionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingRequisitionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingRequisitionIdQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetListingRequisitionIdQuery(baseOptions: Apollo.QueryHookOptions<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables> & ({ variables: GetListingRequisitionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>(GetListingRequisitionIdDocument, options);
      }
export function useGetListingRequisitionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>(GetListingRequisitionIdDocument, options);
        }
// @ts-ignore
export function useGetListingRequisitionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>;
export function useGetListingRequisitionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetListingRequisitionIdQuery | undefined, GetListingRequisitionIdQueryVariables>;
export function useGetListingRequisitionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>(GetListingRequisitionIdDocument, options);
        }
export type GetListingRequisitionIdQueryHookResult = ReturnType<typeof useGetListingRequisitionIdQuery>;
export type GetListingRequisitionIdLazyQueryHookResult = ReturnType<typeof useGetListingRequisitionIdLazyQuery>;
export type GetListingRequisitionIdSuspenseQueryHookResult = ReturnType<typeof useGetListingRequisitionIdSuspenseQuery>;
export type GetListingRequisitionIdQueryResult = Apollo.QueryResult<GetListingRequisitionIdQuery, GetListingRequisitionIdQueryVariables>;
export const GetRequisitionForPrefillDocument = gql`
    query GetRequisitionForPrefill($requisitionId: ID!) {
  requisition(id: $requisitionId) {
    id
    reference
    jobDetails {
      jobTitle
      jobTitleId
      employmentType
      reportingManager
      idealStartDate
      workLocation
      workSetting
      division
      costCentre
    }
    compensation {
      currency
      baseSalaryMin
      baseSalaryMax
      salaryPeriod
      paymentSchedule
      superannuation
      salaryConditions
      bonuses
      commission
      otherCompensation
      benefits
    }
  }
}
    `;

/**
 * __useGetRequisitionForPrefillQuery__
 *
 * To run a query within a React component, call `useGetRequisitionForPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionForPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionForPrefillQuery({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useGetRequisitionForPrefillQuery(baseOptions: Apollo.QueryHookOptions<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables> & ({ variables: GetRequisitionForPrefillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>(GetRequisitionForPrefillDocument, options);
      }
export function useGetRequisitionForPrefillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>(GetRequisitionForPrefillDocument, options);
        }
// @ts-ignore
export function useGetRequisitionForPrefillSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>;
export function useGetRequisitionForPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionForPrefillQuery | undefined, GetRequisitionForPrefillQueryVariables>;
export function useGetRequisitionForPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>(GetRequisitionForPrefillDocument, options);
        }
export type GetRequisitionForPrefillQueryHookResult = ReturnType<typeof useGetRequisitionForPrefillQuery>;
export type GetRequisitionForPrefillLazyQueryHookResult = ReturnType<typeof useGetRequisitionForPrefillLazyQuery>;
export type GetRequisitionForPrefillSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionForPrefillSuspenseQuery>;
export type GetRequisitionForPrefillQueryResult = Apollo.QueryResult<GetRequisitionForPrefillQuery, GetRequisitionForPrefillQueryVariables>;
export const PersonalityAssessmentDocument = gql`
    query PersonalityAssessment {
  personalityAssessment {
    id
    result
    answers {
      questionId
      answer
    }
    characteristics
    catchPhrase
  }
}
    `;

/**
 * __usePersonalityAssessmentQuery__
 *
 * To run a query within a React component, call `usePersonalityAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalityAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalityAssessmentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalityAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>(PersonalityAssessmentDocument, options);
      }
export function usePersonalityAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>(PersonalityAssessmentDocument, options);
        }
// @ts-ignore
export function usePersonalityAssessmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>;
export function usePersonalityAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<PersonalityAssessmentQuery | undefined, PersonalityAssessmentQueryVariables>;
export function usePersonalityAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>(PersonalityAssessmentDocument, options);
        }
export type PersonalityAssessmentQueryHookResult = ReturnType<typeof usePersonalityAssessmentQuery>;
export type PersonalityAssessmentLazyQueryHookResult = ReturnType<typeof usePersonalityAssessmentLazyQuery>;
export type PersonalityAssessmentSuspenseQueryHookResult = ReturnType<typeof usePersonalityAssessmentSuspenseQuery>;
export type PersonalityAssessmentQueryResult = Apollo.QueryResult<PersonalityAssessmentQuery, PersonalityAssessmentQueryVariables>;
export const PersonalityAssessmentSaveAnswersDocument = gql`
    mutation PersonalityAssessmentSaveAnswers($input: PersonalityAssessmentAnswersInput!) {
  personalityAssessmentSaveAnswers(input: $input) {
    id
  }
}
    `;
export type PersonalityAssessmentSaveAnswersMutationFn = Apollo.MutationFunction<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>;

/**
 * __usePersonalityAssessmentSaveAnswersMutation__
 *
 * To run a mutation, you first call `usePersonalityAssessmentSaveAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalityAssessmentSaveAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalityAssessmentSaveAnswersMutation, { data, loading, error }] = usePersonalityAssessmentSaveAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonalityAssessmentSaveAnswersMutation(baseOptions?: Apollo.MutationHookOptions<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>(PersonalityAssessmentSaveAnswersDocument, options);
      }
export type PersonalityAssessmentSaveAnswersMutationHookResult = ReturnType<typeof usePersonalityAssessmentSaveAnswersMutation>;
export type PersonalityAssessmentSaveAnswersMutationResult = Apollo.MutationResult<PersonalityAssessmentSaveAnswersMutation>;
export type PersonalityAssessmentSaveAnswersMutationOptions = Apollo.BaseMutationOptions<PersonalityAssessmentSaveAnswersMutation, PersonalityAssessmentSaveAnswersMutationVariables>;
export const PersonalityAssessmentInviteMembersDocument = gql`
    mutation PersonalityAssessmentInviteMembers($input: PersonalityAssessmentInviteMembersInput!) {
  personalityAssessmentInviteMembers(input: $input) {
    error
  }
}
    `;
export type PersonalityAssessmentInviteMembersMutationFn = Apollo.MutationFunction<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>;

/**
 * __usePersonalityAssessmentInviteMembersMutation__
 *
 * To run a mutation, you first call `usePersonalityAssessmentInviteMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalityAssessmentInviteMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalityAssessmentInviteMembersMutation, { data, loading, error }] = usePersonalityAssessmentInviteMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonalityAssessmentInviteMembersMutation(baseOptions?: Apollo.MutationHookOptions<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>(PersonalityAssessmentInviteMembersDocument, options);
      }
export type PersonalityAssessmentInviteMembersMutationHookResult = ReturnType<typeof usePersonalityAssessmentInviteMembersMutation>;
export type PersonalityAssessmentInviteMembersMutationResult = Apollo.MutationResult<PersonalityAssessmentInviteMembersMutation>;
export type PersonalityAssessmentInviteMembersMutationOptions = Apollo.BaseMutationOptions<PersonalityAssessmentInviteMembersMutation, PersonalityAssessmentInviteMembersMutationVariables>;
export const GetPersonalityResultsQueriesDocument = gql`
    query getPersonalityResultsQueries($filters: [PersonalityResultsQueryInput]) {
  personalityResults(filters: $filters) {
    personalityType
    name
    firstName
    lastName
    completedDate
    division
    jobTitle
  }
}
    `;

/**
 * __useGetPersonalityResultsQueriesQuery__
 *
 * To run a query within a React component, call `useGetPersonalityResultsQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalityResultsQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalityResultsQueriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPersonalityResultsQueriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>(GetPersonalityResultsQueriesDocument, options);
      }
export function useGetPersonalityResultsQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>(GetPersonalityResultsQueriesDocument, options);
        }
// @ts-ignore
export function useGetPersonalityResultsQueriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>;
export function useGetPersonalityResultsQueriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPersonalityResultsQueriesQuery | undefined, GetPersonalityResultsQueriesQueryVariables>;
export function useGetPersonalityResultsQueriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>(GetPersonalityResultsQueriesDocument, options);
        }
export type GetPersonalityResultsQueriesQueryHookResult = ReturnType<typeof useGetPersonalityResultsQueriesQuery>;
export type GetPersonalityResultsQueriesLazyQueryHookResult = ReturnType<typeof useGetPersonalityResultsQueriesLazyQuery>;
export type GetPersonalityResultsQueriesSuspenseQueryHookResult = ReturnType<typeof useGetPersonalityResultsQueriesSuspenseQuery>;
export type GetPersonalityResultsQueriesQueryResult = Apollo.QueryResult<GetPersonalityResultsQueriesQuery, GetPersonalityResultsQueriesQueryVariables>;
export const GetInsightsDocument = gql`
    mutation GetInsights($input: PersonalityInsightsInput!) {
  getInsights(input: $input) {
    distributionType
    distributionTypeSummary
    teamSummary
    mergedSummaries
    headline
  }
}
    `;
export type GetInsightsMutationFn = Apollo.MutationFunction<GetInsightsMutation, GetInsightsMutationVariables>;

/**
 * __useGetInsightsMutation__
 *
 * To run a mutation, you first call `useGetInsightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getInsightsMutation, { data, loading, error }] = useGetInsightsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInsightsMutation(baseOptions?: Apollo.MutationHookOptions<GetInsightsMutation, GetInsightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetInsightsMutation, GetInsightsMutationVariables>(GetInsightsDocument, options);
      }
export type GetInsightsMutationHookResult = ReturnType<typeof useGetInsightsMutation>;
export type GetInsightsMutationResult = Apollo.MutationResult<GetInsightsMutation>;
export type GetInsightsMutationOptions = Apollo.BaseMutationOptions<GetInsightsMutation, GetInsightsMutationVariables>;
export const GetRequisitionsDocument = gql`
    query GetRequisitions($filter: RequisitionFilter) {
  requisitions(filter: $filter) {
    items {
      id
      reference
      status
      archived
      approvalMode
      createdAt
      updatedAt
      headcount {
        fte
      }
      jobDetails {
        jobTitle
        division
        hiringTeamId
        hiringTeamName
      }
    }
    pageInfo {
      page
      pageSize
      totalItems
      totalPages
    }
  }
}
    `;

/**
 * __useGetRequisitionsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRequisitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionsQuery, GetRequisitionsQueryVariables>(GetRequisitionsDocument, options);
      }
export function useGetRequisitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionsQuery, GetRequisitionsQueryVariables>(GetRequisitionsDocument, options);
        }
// @ts-ignore
export function useGetRequisitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionsQuery, GetRequisitionsQueryVariables>;
export function useGetRequisitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionsQuery | undefined, GetRequisitionsQueryVariables>;
export function useGetRequisitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionsQuery, GetRequisitionsQueryVariables>(GetRequisitionsDocument, options);
        }
export type GetRequisitionsQueryHookResult = ReturnType<typeof useGetRequisitionsQuery>;
export type GetRequisitionsLazyQueryHookResult = ReturnType<typeof useGetRequisitionsLazyQuery>;
export type GetRequisitionsSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionsSuspenseQuery>;
export type GetRequisitionsQueryResult = Apollo.QueryResult<GetRequisitionsQuery, GetRequisitionsQueryVariables>;
export const GetRequisitionDocumentDownloadUrlDocument = gql`
    query GetRequisitionDocumentDownloadUrl($requisitionId: ID!, $fileKey: ID!) {
  requisitionDocumentDownloadUrl(requisitionId: $requisitionId, fileKey: $fileKey)
}
    `;

/**
 * __useGetRequisitionDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetRequisitionDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionDocumentDownloadUrlQuery({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useGetRequisitionDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables> & ({ variables: GetRequisitionDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>(GetRequisitionDocumentDownloadUrlDocument, options);
      }
export function useGetRequisitionDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>(GetRequisitionDocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetRequisitionDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>;
export function useGetRequisitionDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionDocumentDownloadUrlQuery | undefined, GetRequisitionDocumentDownloadUrlQueryVariables>;
export function useGetRequisitionDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>(GetRequisitionDocumentDownloadUrlDocument, options);
        }
export type GetRequisitionDocumentDownloadUrlQueryHookResult = ReturnType<typeof useGetRequisitionDocumentDownloadUrlQuery>;
export type GetRequisitionDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetRequisitionDocumentDownloadUrlLazyQuery>;
export type GetRequisitionDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionDocumentDownloadUrlSuspenseQuery>;
export type GetRequisitionDocumentDownloadUrlQueryResult = Apollo.QueryResult<GetRequisitionDocumentDownloadUrlQuery, GetRequisitionDocumentDownloadUrlQueryVariables>;
export const GetMyApprovalsDocument = gql`
    query GetMyApprovals {
  myApprovals {
    id
    type
    status
    createdAt
    actionable
    position
    requestedBy {
      id
      firstName
      lastName
      email
    }
    requisition {
      ...RequisitionDetailFields
    }
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;

/**
 * __useGetMyApprovalsQuery__
 *
 * To run a query within a React component, call `useGetMyApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyApprovalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>(GetMyApprovalsDocument, options);
      }
export function useGetMyApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>(GetMyApprovalsDocument, options);
        }
// @ts-ignore
export function useGetMyApprovalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>;
export function useGetMyApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyApprovalsQuery | undefined, GetMyApprovalsQueryVariables>;
export function useGetMyApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>(GetMyApprovalsDocument, options);
        }
export type GetMyApprovalsQueryHookResult = ReturnType<typeof useGetMyApprovalsQuery>;
export type GetMyApprovalsLazyQueryHookResult = ReturnType<typeof useGetMyApprovalsLazyQuery>;
export type GetMyApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetMyApprovalsSuspenseQuery>;
export type GetMyApprovalsQueryResult = Apollo.QueryResult<GetMyApprovalsQuery, GetMyApprovalsQueryVariables>;
export const GetApprovalsDocument = gql`
    query GetApprovals {
  approvals {
    id
    type
    status
    createdAt
    actionable
    position
    requestedBy {
      id
      firstName
      lastName
      email
    }
    requisition {
      ...RequisitionDetailFields
    }
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;

/**
 * __useGetApprovalsQuery__
 *
 * To run a query within a React component, call `useGetApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalsQuery, GetApprovalsQueryVariables>(GetApprovalsDocument, options);
      }
export function useGetApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalsQuery, GetApprovalsQueryVariables>(GetApprovalsDocument, options);
        }
// @ts-ignore
export function useGetApprovalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalsQuery, GetApprovalsQueryVariables>;
export function useGetApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApprovalsQuery | undefined, GetApprovalsQueryVariables>;
export function useGetApprovalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovalsQuery, GetApprovalsQueryVariables>(GetApprovalsDocument, options);
        }
export type GetApprovalsQueryHookResult = ReturnType<typeof useGetApprovalsQuery>;
export type GetApprovalsLazyQueryHookResult = ReturnType<typeof useGetApprovalsLazyQuery>;
export type GetApprovalsSuspenseQueryHookResult = ReturnType<typeof useGetApprovalsSuspenseQuery>;
export type GetApprovalsQueryResult = Apollo.QueryResult<GetApprovalsQuery, GetApprovalsQueryVariables>;
export const ApproveRequisitionDocument = gql`
    mutation ApproveRequisition($id: ID!, $comment: String) {
  approveRequisition(id: $id, comment: $comment) {
    id
    status
  }
}
    `;
export type ApproveRequisitionMutationFn = Apollo.MutationFunction<ApproveRequisitionMutation, ApproveRequisitionMutationVariables>;

/**
 * __useApproveRequisitionMutation__
 *
 * To run a mutation, you first call `useApproveRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRequisitionMutation, { data, loading, error }] = useApproveRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useApproveRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRequisitionMutation, ApproveRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRequisitionMutation, ApproveRequisitionMutationVariables>(ApproveRequisitionDocument, options);
      }
export type ApproveRequisitionMutationHookResult = ReturnType<typeof useApproveRequisitionMutation>;
export type ApproveRequisitionMutationResult = Apollo.MutationResult<ApproveRequisitionMutation>;
export type ApproveRequisitionMutationOptions = Apollo.BaseMutationOptions<ApproveRequisitionMutation, ApproveRequisitionMutationVariables>;
export const DeclineRequisitionDocument = gql`
    mutation DeclineRequisition($id: ID!, $comment: String) {
  declineRequisition(id: $id, comment: $comment) {
    id
    status
  }
}
    `;
export type DeclineRequisitionMutationFn = Apollo.MutationFunction<DeclineRequisitionMutation, DeclineRequisitionMutationVariables>;

/**
 * __useDeclineRequisitionMutation__
 *
 * To run a mutation, you first call `useDeclineRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineRequisitionMutation, { data, loading, error }] = useDeclineRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useDeclineRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<DeclineRequisitionMutation, DeclineRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineRequisitionMutation, DeclineRequisitionMutationVariables>(DeclineRequisitionDocument, options);
      }
export type DeclineRequisitionMutationHookResult = ReturnType<typeof useDeclineRequisitionMutation>;
export type DeclineRequisitionMutationResult = Apollo.MutationResult<DeclineRequisitionMutation>;
export type DeclineRequisitionMutationOptions = Apollo.BaseMutationOptions<DeclineRequisitionMutation, DeclineRequisitionMutationVariables>;
export const GetApproverCandidatesDocument = gql`
    query GetApproverCandidates {
  eligibleApprovers {
    id
    firstName
    lastName
    email
  }
  orgUsers {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useGetApproverCandidatesQuery__
 *
 * To run a query within a React component, call `useGetApproverCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApproverCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApproverCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApproverCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>(GetApproverCandidatesDocument, options);
      }
export function useGetApproverCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>(GetApproverCandidatesDocument, options);
        }
// @ts-ignore
export function useGetApproverCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>;
export function useGetApproverCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetApproverCandidatesQuery | undefined, GetApproverCandidatesQueryVariables>;
export function useGetApproverCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>(GetApproverCandidatesDocument, options);
        }
export type GetApproverCandidatesQueryHookResult = ReturnType<typeof useGetApproverCandidatesQuery>;
export type GetApproverCandidatesLazyQueryHookResult = ReturnType<typeof useGetApproverCandidatesLazyQuery>;
export type GetApproverCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetApproverCandidatesSuspenseQuery>;
export type GetApproverCandidatesQueryResult = Apollo.QueryResult<GetApproverCandidatesQuery, GetApproverCandidatesQueryVariables>;
export const CreateRequisitionDocument = gql`
    mutation CreateRequisition($input: RequisitionInput!) {
  createRequisition(input: $input) {
    id
    status
  }
}
    `;
export type CreateRequisitionMutationFn = Apollo.MutationFunction<CreateRequisitionMutation, CreateRequisitionMutationVariables>;

/**
 * __useCreateRequisitionMutation__
 *
 * To run a mutation, you first call `useCreateRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequisitionMutation, { data, loading, error }] = useCreateRequisitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequisitionMutation, CreateRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequisitionMutation, CreateRequisitionMutationVariables>(CreateRequisitionDocument, options);
      }
export type CreateRequisitionMutationHookResult = ReturnType<typeof useCreateRequisitionMutation>;
export type CreateRequisitionMutationResult = Apollo.MutationResult<CreateRequisitionMutation>;
export type CreateRequisitionMutationOptions = Apollo.BaseMutationOptions<CreateRequisitionMutation, CreateRequisitionMutationVariables>;
export const SaveRequisitionDraftDocument = gql`
    mutation SaveRequisitionDraft($id: ID!, $input: RequisitionInput!) {
  saveRequisitionDraft(id: $id, input: $input) {
    id
    status
  }
}
    `;
export type SaveRequisitionDraftMutationFn = Apollo.MutationFunction<SaveRequisitionDraftMutation, SaveRequisitionDraftMutationVariables>;

/**
 * __useSaveRequisitionDraftMutation__
 *
 * To run a mutation, you first call `useSaveRequisitionDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRequisitionDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRequisitionDraftMutation, { data, loading, error }] = useSaveRequisitionDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveRequisitionDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveRequisitionDraftMutation, SaveRequisitionDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRequisitionDraftMutation, SaveRequisitionDraftMutationVariables>(SaveRequisitionDraftDocument, options);
      }
export type SaveRequisitionDraftMutationHookResult = ReturnType<typeof useSaveRequisitionDraftMutation>;
export type SaveRequisitionDraftMutationResult = Apollo.MutationResult<SaveRequisitionDraftMutation>;
export type SaveRequisitionDraftMutationOptions = Apollo.BaseMutationOptions<SaveRequisitionDraftMutation, SaveRequisitionDraftMutationVariables>;
export const SubmitRequisitionDocument = gql`
    mutation SubmitRequisition($id: ID!) {
  submitRequisition(id: $id) {
    id
    status
  }
}
    `;
export type SubmitRequisitionMutationFn = Apollo.MutationFunction<SubmitRequisitionMutation, SubmitRequisitionMutationVariables>;

/**
 * __useSubmitRequisitionMutation__
 *
 * To run a mutation, you first call `useSubmitRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRequisitionMutation, { data, loading, error }] = useSubmitRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRequisitionMutation, SubmitRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRequisitionMutation, SubmitRequisitionMutationVariables>(SubmitRequisitionDocument, options);
      }
export type SubmitRequisitionMutationHookResult = ReturnType<typeof useSubmitRequisitionMutation>;
export type SubmitRequisitionMutationResult = Apollo.MutationResult<SubmitRequisitionMutation>;
export type SubmitRequisitionMutationOptions = Apollo.BaseMutationOptions<SubmitRequisitionMutation, SubmitRequisitionMutationVariables>;
export const GetRequisitionDocument = gql`
    query GetRequisition($id: ID!) {
  requisition(id: $id) {
    ...RequisitionDetailFields
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;

/**
 * __useGetRequisitionQuery__
 *
 * To run a query within a React component, call `useGetRequisitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionQuery(baseOptions: Apollo.QueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables> & ({ variables: GetRequisitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionQuery, GetRequisitionQueryVariables>(GetRequisitionDocument, options);
      }
export function useGetRequisitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionQuery, GetRequisitionQueryVariables>(GetRequisitionDocument, options);
        }
// @ts-ignore
export function useGetRequisitionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionQuery, GetRequisitionQueryVariables>;
export function useGetRequisitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionQuery | undefined, GetRequisitionQueryVariables>;
export function useGetRequisitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionQuery, GetRequisitionQueryVariables>(GetRequisitionDocument, options);
        }
export type GetRequisitionQueryHookResult = ReturnType<typeof useGetRequisitionQuery>;
export type GetRequisitionLazyQueryHookResult = ReturnType<typeof useGetRequisitionLazyQuery>;
export type GetRequisitionSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionSuspenseQuery>;
export type GetRequisitionQueryResult = Apollo.QueryResult<GetRequisitionQuery, GetRequisitionQueryVariables>;
export const GetRequisitionActivityDocument = gql`
    query GetRequisitionActivity($id: ID!) {
  requisition(id: $id) {
    id
    activity {
      id
      action
      actor
      details
      timestamp
      actorUser {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useGetRequisitionActivityQuery__
 *
 * To run a query within a React component, call `useGetRequisitionActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionActivityQuery(baseOptions: Apollo.QueryHookOptions<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables> & ({ variables: GetRequisitionActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>(GetRequisitionActivityDocument, options);
      }
export function useGetRequisitionActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>(GetRequisitionActivityDocument, options);
        }
// @ts-ignore
export function useGetRequisitionActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>;
export function useGetRequisitionActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequisitionActivityQuery | undefined, GetRequisitionActivityQueryVariables>;
export function useGetRequisitionActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>(GetRequisitionActivityDocument, options);
        }
export type GetRequisitionActivityQueryHookResult = ReturnType<typeof useGetRequisitionActivityQuery>;
export type GetRequisitionActivityLazyQueryHookResult = ReturnType<typeof useGetRequisitionActivityLazyQuery>;
export type GetRequisitionActivitySuspenseQueryHookResult = ReturnType<typeof useGetRequisitionActivitySuspenseQuery>;
export type GetRequisitionActivityQueryResult = Apollo.QueryResult<GetRequisitionActivityQuery, GetRequisitionActivityQueryVariables>;
export const GetLinkedJobHiredCountsDocument = gql`
    query GetLinkedJobHiredCounts($id: ID!) {
  requisition(id: $id) {
    id
    linkedJobs {
      id
      applicantCounts {
        completed {
          type
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetLinkedJobHiredCountsQuery__
 *
 * To run a query within a React component, call `useGetLinkedJobHiredCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedJobHiredCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedJobHiredCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLinkedJobHiredCountsQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables> & ({ variables: GetLinkedJobHiredCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>(GetLinkedJobHiredCountsDocument, options);
      }
export function useGetLinkedJobHiredCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>(GetLinkedJobHiredCountsDocument, options);
        }
// @ts-ignore
export function useGetLinkedJobHiredCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>;
export function useGetLinkedJobHiredCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLinkedJobHiredCountsQuery | undefined, GetLinkedJobHiredCountsQueryVariables>;
export function useGetLinkedJobHiredCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>(GetLinkedJobHiredCountsDocument, options);
        }
export type GetLinkedJobHiredCountsQueryHookResult = ReturnType<typeof useGetLinkedJobHiredCountsQuery>;
export type GetLinkedJobHiredCountsLazyQueryHookResult = ReturnType<typeof useGetLinkedJobHiredCountsLazyQuery>;
export type GetLinkedJobHiredCountsSuspenseQueryHookResult = ReturnType<typeof useGetLinkedJobHiredCountsSuspenseQuery>;
export type GetLinkedJobHiredCountsQueryResult = Apollo.QueryResult<GetLinkedJobHiredCountsQuery, GetLinkedJobHiredCountsQueryVariables>;
export const UpdateApprovedRequisitionDocument = gql`
    mutation UpdateApprovedRequisition($id: ID!, $input: RequisitionInput!) {
  updateApprovedRequisition(id: $id, input: $input) {
    ...RequisitionDetailFields
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;
export type UpdateApprovedRequisitionMutationFn = Apollo.MutationFunction<UpdateApprovedRequisitionMutation, UpdateApprovedRequisitionMutationVariables>;

/**
 * __useUpdateApprovedRequisitionMutation__
 *
 * To run a mutation, you first call `useUpdateApprovedRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovedRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovedRequisitionMutation, { data, loading, error }] = useUpdateApprovedRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApprovedRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApprovedRequisitionMutation, UpdateApprovedRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApprovedRequisitionMutation, UpdateApprovedRequisitionMutationVariables>(UpdateApprovedRequisitionDocument, options);
      }
export type UpdateApprovedRequisitionMutationHookResult = ReturnType<typeof useUpdateApprovedRequisitionMutation>;
export type UpdateApprovedRequisitionMutationResult = Apollo.MutationResult<UpdateApprovedRequisitionMutation>;
export type UpdateApprovedRequisitionMutationOptions = Apollo.BaseMutationOptions<UpdateApprovedRequisitionMutation, UpdateApprovedRequisitionMutationVariables>;
export const AddApproverToRequisitionDocument = gql`
    mutation AddApproverToRequisition($id: ID!, $approver: ApproverInput!) {
  addApproverToRequisition(id: $id, approver: $approver) {
    ...RequisitionDetailFields
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;
export type AddApproverToRequisitionMutationFn = Apollo.MutationFunction<AddApproverToRequisitionMutation, AddApproverToRequisitionMutationVariables>;

/**
 * __useAddApproverToRequisitionMutation__
 *
 * To run a mutation, you first call `useAddApproverToRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddApproverToRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addApproverToRequisitionMutation, { data, loading, error }] = useAddApproverToRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approver: // value for 'approver'
 *   },
 * });
 */
export function useAddApproverToRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<AddApproverToRequisitionMutation, AddApproverToRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddApproverToRequisitionMutation, AddApproverToRequisitionMutationVariables>(AddApproverToRequisitionDocument, options);
      }
export type AddApproverToRequisitionMutationHookResult = ReturnType<typeof useAddApproverToRequisitionMutation>;
export type AddApproverToRequisitionMutationResult = Apollo.MutationResult<AddApproverToRequisitionMutation>;
export type AddApproverToRequisitionMutationOptions = Apollo.BaseMutationOptions<AddApproverToRequisitionMutation, AddApproverToRequisitionMutationVariables>;
export const SetRequisitionApproversDocument = gql`
    mutation SetRequisitionApprovers($id: ID!, $approvers: [ApproverInput!]!) {
  setRequisitionApprovers(id: $id, approvers: $approvers) {
    ...RequisitionDetailFields
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;
export type SetRequisitionApproversMutationFn = Apollo.MutationFunction<SetRequisitionApproversMutation, SetRequisitionApproversMutationVariables>;

/**
 * __useSetRequisitionApproversMutation__
 *
 * To run a mutation, you first call `useSetRequisitionApproversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRequisitionApproversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRequisitionApproversMutation, { data, loading, error }] = useSetRequisitionApproversMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approvers: // value for 'approvers'
 *   },
 * });
 */
export function useSetRequisitionApproversMutation(baseOptions?: Apollo.MutationHookOptions<SetRequisitionApproversMutation, SetRequisitionApproversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRequisitionApproversMutation, SetRequisitionApproversMutationVariables>(SetRequisitionApproversDocument, options);
      }
export type SetRequisitionApproversMutationHookResult = ReturnType<typeof useSetRequisitionApproversMutation>;
export type SetRequisitionApproversMutationResult = Apollo.MutationResult<SetRequisitionApproversMutation>;
export type SetRequisitionApproversMutationOptions = Apollo.BaseMutationOptions<SetRequisitionApproversMutation, SetRequisitionApproversMutationVariables>;
export const RemoveApproverFromRequisitionDocument = gql`
    mutation RemoveApproverFromRequisition($id: ID!, $userId: ID!) {
  removeApproverFromRequisition(id: $id, userId: $userId) {
    ...RequisitionDetailFields
  }
}
    ${RequisitionDetailFieldsFragmentDoc}`;
export type RemoveApproverFromRequisitionMutationFn = Apollo.MutationFunction<RemoveApproverFromRequisitionMutation, RemoveApproverFromRequisitionMutationVariables>;

/**
 * __useRemoveApproverFromRequisitionMutation__
 *
 * To run a mutation, you first call `useRemoveApproverFromRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApproverFromRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApproverFromRequisitionMutation, { data, loading, error }] = useRemoveApproverFromRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveApproverFromRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveApproverFromRequisitionMutation, RemoveApproverFromRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveApproverFromRequisitionMutation, RemoveApproverFromRequisitionMutationVariables>(RemoveApproverFromRequisitionDocument, options);
      }
export type RemoveApproverFromRequisitionMutationHookResult = ReturnType<typeof useRemoveApproverFromRequisitionMutation>;
export type RemoveApproverFromRequisitionMutationResult = Apollo.MutationResult<RemoveApproverFromRequisitionMutation>;
export type RemoveApproverFromRequisitionMutationOptions = Apollo.BaseMutationOptions<RemoveApproverFromRequisitionMutation, RemoveApproverFromRequisitionMutationVariables>;
export const WithdrawRequisitionDocument = gql`
    mutation WithdrawRequisition($id: ID!) {
  withdrawRequisition(id: $id) {
    id
    status
  }
}
    `;
export type WithdrawRequisitionMutationFn = Apollo.MutationFunction<WithdrawRequisitionMutation, WithdrawRequisitionMutationVariables>;

/**
 * __useWithdrawRequisitionMutation__
 *
 * To run a mutation, you first call `useWithdrawRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawRequisitionMutation, { data, loading, error }] = useWithdrawRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithdrawRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawRequisitionMutation, WithdrawRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawRequisitionMutation, WithdrawRequisitionMutationVariables>(WithdrawRequisitionDocument, options);
      }
export type WithdrawRequisitionMutationHookResult = ReturnType<typeof useWithdrawRequisitionMutation>;
export type WithdrawRequisitionMutationResult = Apollo.MutationResult<WithdrawRequisitionMutation>;
export type WithdrawRequisitionMutationOptions = Apollo.BaseMutationOptions<WithdrawRequisitionMutation, WithdrawRequisitionMutationVariables>;
export const SetRequisitionArchivedDocument = gql`
    mutation SetRequisitionArchived($id: ID!, $archived: Boolean!) {
  setRequisitionArchived(id: $id, archived: $archived) {
    id
    archived
  }
}
    `;
export type SetRequisitionArchivedMutationFn = Apollo.MutationFunction<SetRequisitionArchivedMutation, SetRequisitionArchivedMutationVariables>;

/**
 * __useSetRequisitionArchivedMutation__
 *
 * To run a mutation, you first call `useSetRequisitionArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRequisitionArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRequisitionArchivedMutation, { data, loading, error }] = useSetRequisitionArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetRequisitionArchivedMutation(baseOptions?: Apollo.MutationHookOptions<SetRequisitionArchivedMutation, SetRequisitionArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRequisitionArchivedMutation, SetRequisitionArchivedMutationVariables>(SetRequisitionArchivedDocument, options);
      }
export type SetRequisitionArchivedMutationHookResult = ReturnType<typeof useSetRequisitionArchivedMutation>;
export type SetRequisitionArchivedMutationResult = Apollo.MutationResult<SetRequisitionArchivedMutation>;
export type SetRequisitionArchivedMutationOptions = Apollo.BaseMutationOptions<SetRequisitionArchivedMutation, SetRequisitionArchivedMutationVariables>;
export const CloseRequisitionDocument = gql`
    mutation CloseRequisition($id: ID!) {
  closeRequisition(id: $id) {
    id
    status
  }
}
    `;
export type CloseRequisitionMutationFn = Apollo.MutationFunction<CloseRequisitionMutation, CloseRequisitionMutationVariables>;

/**
 * __useCloseRequisitionMutation__
 *
 * To run a mutation, you first call `useCloseRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeRequisitionMutation, { data, loading, error }] = useCloseRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<CloseRequisitionMutation, CloseRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseRequisitionMutation, CloseRequisitionMutationVariables>(CloseRequisitionDocument, options);
      }
export type CloseRequisitionMutationHookResult = ReturnType<typeof useCloseRequisitionMutation>;
export type CloseRequisitionMutationResult = Apollo.MutationResult<CloseRequisitionMutation>;
export type CloseRequisitionMutationOptions = Apollo.BaseMutationOptions<CloseRequisitionMutation, CloseRequisitionMutationVariables>;
export const ReopenRequisitionDocument = gql`
    mutation ReopenRequisition($id: ID!) {
  reopenRequisition(id: $id) {
    id
    status
  }
}
    `;
export type ReopenRequisitionMutationFn = Apollo.MutationFunction<ReopenRequisitionMutation, ReopenRequisitionMutationVariables>;

/**
 * __useReopenRequisitionMutation__
 *
 * To run a mutation, you first call `useReopenRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenRequisitionMutation, { data, loading, error }] = useReopenRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<ReopenRequisitionMutation, ReopenRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenRequisitionMutation, ReopenRequisitionMutationVariables>(ReopenRequisitionDocument, options);
      }
export type ReopenRequisitionMutationHookResult = ReturnType<typeof useReopenRequisitionMutation>;
export type ReopenRequisitionMutationResult = Apollo.MutationResult<ReopenRequisitionMutation>;
export type ReopenRequisitionMutationOptions = Apollo.BaseMutationOptions<ReopenRequisitionMutation, ReopenRequisitionMutationVariables>;
export const DeleteRequisitionDocument = gql`
    mutation DeleteRequisition($id: ID!) {
  deleteRequisition(id: $id)
}
    `;
export type DeleteRequisitionMutationFn = Apollo.MutationFunction<DeleteRequisitionMutation, DeleteRequisitionMutationVariables>;

/**
 * __useDeleteRequisitionMutation__
 *
 * To run a mutation, you first call `useDeleteRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequisitionMutation, { data, loading, error }] = useDeleteRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequisitionMutation, DeleteRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequisitionMutation, DeleteRequisitionMutationVariables>(DeleteRequisitionDocument, options);
      }
export type DeleteRequisitionMutationHookResult = ReturnType<typeof useDeleteRequisitionMutation>;
export type DeleteRequisitionMutationResult = Apollo.MutationResult<DeleteRequisitionMutation>;
export type DeleteRequisitionMutationOptions = Apollo.BaseMutationOptions<DeleteRequisitionMutation, DeleteRequisitionMutationVariables>;
export const ResubmitRequisitionDocument = gql`
    mutation ResubmitRequisition($id: ID!, $amendmentsSummary: String!, $input: RequisitionInput) {
  resubmitRequisition(id: $id, amendmentsSummary: $amendmentsSummary, input: $input) {
    id
    status
  }
}
    `;
export type ResubmitRequisitionMutationFn = Apollo.MutationFunction<ResubmitRequisitionMutation, ResubmitRequisitionMutationVariables>;

/**
 * __useResubmitRequisitionMutation__
 *
 * To run a mutation, you first call `useResubmitRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubmitRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubmitRequisitionMutation, { data, loading, error }] = useResubmitRequisitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amendmentsSummary: // value for 'amendmentsSummary'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResubmitRequisitionMutation(baseOptions?: Apollo.MutationHookOptions<ResubmitRequisitionMutation, ResubmitRequisitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResubmitRequisitionMutation, ResubmitRequisitionMutationVariables>(ResubmitRequisitionDocument, options);
      }
export type ResubmitRequisitionMutationHookResult = ReturnType<typeof useResubmitRequisitionMutation>;
export type ResubmitRequisitionMutationResult = Apollo.MutationResult<ResubmitRequisitionMutation>;
export type ResubmitRequisitionMutationOptions = Apollo.BaseMutationOptions<ResubmitRequisitionMutation, ResubmitRequisitionMutationVariables>;
export const ShareCultureReportDocument = gql`
    mutation ShareCultureReport($input: SharePageInput!) {
  shareCultureReport(input: $input) {
    link
  }
}
    `;
export type ShareCultureReportMutationFn = Apollo.MutationFunction<ShareCultureReportMutation, ShareCultureReportMutationVariables>;

/**
 * __useShareCultureReportMutation__
 *
 * To run a mutation, you first call `useShareCultureReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCultureReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCultureReportMutation, { data, loading, error }] = useShareCultureReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareCultureReportMutation(baseOptions?: Apollo.MutationHookOptions<ShareCultureReportMutation, ShareCultureReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareCultureReportMutation, ShareCultureReportMutationVariables>(ShareCultureReportDocument, options);
      }
export type ShareCultureReportMutationHookResult = ReturnType<typeof useShareCultureReportMutation>;
export type ShareCultureReportMutationResult = Apollo.MutationResult<ShareCultureReportMutation>;
export type ShareCultureReportMutationOptions = Apollo.BaseMutationOptions<ShareCultureReportMutation, ShareCultureReportMutationVariables>;
export const ExpireShareLinkDocument = gql`
    mutation ExpireShareLink($sk: String!) {
  expireShareLink(sk: $sk)
}
    `;
export type ExpireShareLinkMutationFn = Apollo.MutationFunction<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>;

/**
 * __useExpireShareLinkMutation__
 *
 * To run a mutation, you first call `useExpireShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireShareLinkMutation, { data, loading, error }] = useExpireShareLinkMutation({
 *   variables: {
 *      sk: // value for 'sk'
 *   },
 * });
 */
export function useExpireShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>(ExpireShareLinkDocument, options);
      }
export type ExpireShareLinkMutationHookResult = ReturnType<typeof useExpireShareLinkMutation>;
export type ExpireShareLinkMutationResult = Apollo.MutationResult<ExpireShareLinkMutation>;
export type ExpireShareLinkMutationOptions = Apollo.BaseMutationOptions<ExpireShareLinkMutation, ExpireShareLinkMutationVariables>;
export const SharePageLinksDocument = gql`
    query SharePageLinks {
  sharePageLinks {
    sk
    dateShared
    link
    title
    expiryDate
    sharer
    sharerEmail
    shareContent
    type
  }
}
    `;

/**
 * __useSharePageLinksQuery__
 *
 * To run a query within a React component, call `useSharePageLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharePageLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharePageLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharePageLinksQuery(baseOptions?: Apollo.QueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharePageLinksQuery, SharePageLinksQueryVariables>(SharePageLinksDocument, options);
      }
export function useSharePageLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharePageLinksQuery, SharePageLinksQueryVariables>(SharePageLinksDocument, options);
        }
// @ts-ignore
export function useSharePageLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>): Apollo.UseSuspenseQueryResult<SharePageLinksQuery, SharePageLinksQueryVariables>;
export function useSharePageLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>): Apollo.UseSuspenseQueryResult<SharePageLinksQuery | undefined, SharePageLinksQueryVariables>;
export function useSharePageLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharePageLinksQuery, SharePageLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharePageLinksQuery, SharePageLinksQueryVariables>(SharePageLinksDocument, options);
        }
export type SharePageLinksQueryHookResult = ReturnType<typeof useSharePageLinksQuery>;
export type SharePageLinksLazyQueryHookResult = ReturnType<typeof useSharePageLinksLazyQuery>;
export type SharePageLinksSuspenseQueryHookResult = ReturnType<typeof useSharePageLinksSuspenseQuery>;
export type SharePageLinksQueryResult = Apollo.QueryResult<SharePageLinksQuery, SharePageLinksQueryVariables>;
export const FetchTagActivitiesWithoutHistoryDocument = gql`
    query FetchTagActivitiesWithoutHistory($filter: TagActivityFilter!) {
  tagActivities(filter: $filter) {
    id
    tag {
      __typename
      ... on SystemTag {
        id
      }
      ... on OrganisationTag {
        id
        label
      }
    }
    actionedByUser {
      ...TagActivityActionedByUserFields
    }
    action
    targetApplicant {
      candidateId
    }
  }
}
    ${TagActivityActionedByUserFieldsFragmentDoc}`;

/**
 * __useFetchTagActivitiesWithoutHistoryQuery__
 *
 * To run a query within a React component, call `useFetchTagActivitiesWithoutHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTagActivitiesWithoutHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTagActivitiesWithoutHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTagActivitiesWithoutHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables> & ({ variables: FetchTagActivitiesWithoutHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>(FetchTagActivitiesWithoutHistoryDocument, options);
      }
export function useFetchTagActivitiesWithoutHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>(FetchTagActivitiesWithoutHistoryDocument, options);
        }
// @ts-ignore
export function useFetchTagActivitiesWithoutHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>;
export function useFetchTagActivitiesWithoutHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<FetchTagActivitiesWithoutHistoryQuery | undefined, FetchTagActivitiesWithoutHistoryQueryVariables>;
export function useFetchTagActivitiesWithoutHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>(FetchTagActivitiesWithoutHistoryDocument, options);
        }
export type FetchTagActivitiesWithoutHistoryQueryHookResult = ReturnType<typeof useFetchTagActivitiesWithoutHistoryQuery>;
export type FetchTagActivitiesWithoutHistoryLazyQueryHookResult = ReturnType<typeof useFetchTagActivitiesWithoutHistoryLazyQuery>;
export type FetchTagActivitiesWithoutHistorySuspenseQueryHookResult = ReturnType<typeof useFetchTagActivitiesWithoutHistorySuspenseQuery>;
export type FetchTagActivitiesWithoutHistoryQueryResult = Apollo.QueryResult<FetchTagActivitiesWithoutHistoryQuery, FetchTagActivitiesWithoutHistoryQueryVariables>;
export const FetchOrganisationTagActivitiesDocument = gql`
    query FetchOrganisationTagActivities($filter: TagActivityFilter!) {
  tagActivities(filter: $filter) {
    id
    tag {
      __typename
      ... on OrganisationTag {
        id
        label
      }
    }
    actionedByUser {
      ...TagActivityActionedByUserFields
    }
    notes
    action
    targetApplicant {
      candidateId
    }
  }
}
    ${TagActivityActionedByUserFieldsFragmentDoc}`;

/**
 * __useFetchOrganisationTagActivitiesQuery__
 *
 * To run a query within a React component, call `useFetchOrganisationTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrganisationTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrganisationTagActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchOrganisationTagActivitiesQuery(baseOptions: Apollo.QueryHookOptions<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables> & ({ variables: FetchOrganisationTagActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>(FetchOrganisationTagActivitiesDocument, options);
      }
export function useFetchOrganisationTagActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>(FetchOrganisationTagActivitiesDocument, options);
        }
// @ts-ignore
export function useFetchOrganisationTagActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>;
export function useFetchOrganisationTagActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<FetchOrganisationTagActivitiesQuery | undefined, FetchOrganisationTagActivitiesQueryVariables>;
export function useFetchOrganisationTagActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>(FetchOrganisationTagActivitiesDocument, options);
        }
export type FetchOrganisationTagActivitiesQueryHookResult = ReturnType<typeof useFetchOrganisationTagActivitiesQuery>;
export type FetchOrganisationTagActivitiesLazyQueryHookResult = ReturnType<typeof useFetchOrganisationTagActivitiesLazyQuery>;
export type FetchOrganisationTagActivitiesSuspenseQueryHookResult = ReturnType<typeof useFetchOrganisationTagActivitiesSuspenseQuery>;
export type FetchOrganisationTagActivitiesQueryResult = Apollo.QueryResult<FetchOrganisationTagActivitiesQuery, FetchOrganisationTagActivitiesQueryVariables>;
export const FetchApplicantTagActivitiesDocument = gql`
    query FetchApplicantTagActivities($filter: TagActivityFilter!) {
  tagActivities(filter: $filter) {
    id
    tag {
      __typename
      ... on SystemTag {
        id
      }
      ... on OrganisationTag {
        id
        label
        assignedCount
      }
    }
    actionedByUser {
      ...TagActivityActionedByUserFields
    }
    action
    notes
    targetApplicant {
      candidateId
    }
    history {
      action
      actionedByUser {
        ...TagActivityActionedByUserFields
      }
      notes
    }
  }
}
    ${TagActivityActionedByUserFieldsFragmentDoc}`;

/**
 * __useFetchApplicantTagActivitiesQuery__
 *
 * To run a query within a React component, call `useFetchApplicantTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantTagActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchApplicantTagActivitiesQuery(baseOptions: Apollo.QueryHookOptions<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables> & ({ variables: FetchApplicantTagActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>(FetchApplicantTagActivitiesDocument, options);
      }
export function useFetchApplicantTagActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>(FetchApplicantTagActivitiesDocument, options);
        }
// @ts-ignore
export function useFetchApplicantTagActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>;
export function useFetchApplicantTagActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<FetchApplicantTagActivitiesQuery | undefined, FetchApplicantTagActivitiesQueryVariables>;
export function useFetchApplicantTagActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>(FetchApplicantTagActivitiesDocument, options);
        }
export type FetchApplicantTagActivitiesQueryHookResult = ReturnType<typeof useFetchApplicantTagActivitiesQuery>;
export type FetchApplicantTagActivitiesLazyQueryHookResult = ReturnType<typeof useFetchApplicantTagActivitiesLazyQuery>;
export type FetchApplicantTagActivitiesSuspenseQueryHookResult = ReturnType<typeof useFetchApplicantTagActivitiesSuspenseQuery>;
export type FetchApplicantTagActivitiesQueryResult = Apollo.QueryResult<FetchApplicantTagActivitiesQuery, FetchApplicantTagActivitiesQueryVariables>;
export const FetchOrganisationTagsDocument = gql`
    query FetchOrganisationTags {
  organisationTags {
    id
    label
    tagCategory
    assignedCount
  }
}
    `;

/**
 * __useFetchOrganisationTagsQuery__
 *
 * To run a query within a React component, call `useFetchOrganisationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrganisationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrganisationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchOrganisationTagsQuery(baseOptions?: Apollo.QueryHookOptions<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>(FetchOrganisationTagsDocument, options);
      }
export function useFetchOrganisationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>(FetchOrganisationTagsDocument, options);
        }
// @ts-ignore
export function useFetchOrganisationTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>;
export function useFetchOrganisationTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchOrganisationTagsQuery | undefined, FetchOrganisationTagsQueryVariables>;
export function useFetchOrganisationTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>(FetchOrganisationTagsDocument, options);
        }
export type FetchOrganisationTagsQueryHookResult = ReturnType<typeof useFetchOrganisationTagsQuery>;
export type FetchOrganisationTagsLazyQueryHookResult = ReturnType<typeof useFetchOrganisationTagsLazyQuery>;
export type FetchOrganisationTagsSuspenseQueryHookResult = ReturnType<typeof useFetchOrganisationTagsSuspenseQuery>;
export type FetchOrganisationTagsQueryResult = Apollo.QueryResult<FetchOrganisationTagsQuery, FetchOrganisationTagsQueryVariables>;
export const SystemTagActivitySetDocument = gql`
    mutation systemTagActivitySet($input: SystemTagActivityInput!) {
  systemTagActivitySet(input: $input) {
    tagActivity {
      id
      tag {
        ... on SystemTag {
          id
          label
        }
      }
      targetApplicant {
        listingId
        candidateId
      }
      action
      actionedByUser {
        ...TagActivityActionedByUserFields
      }
    }
    errors {
      message
    }
  }
}
    ${TagActivityActionedByUserFieldsFragmentDoc}`;
export type SystemTagActivitySetMutationFn = Apollo.MutationFunction<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>;

/**
 * __useSystemTagActivitySetMutation__
 *
 * To run a mutation, you first call `useSystemTagActivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemTagActivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemTagActivitySetMutation, { data, loading, error }] = useSystemTagActivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemTagActivitySetMutation(baseOptions?: Apollo.MutationHookOptions<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>(SystemTagActivitySetDocument, options);
      }
export type SystemTagActivitySetMutationHookResult = ReturnType<typeof useSystemTagActivitySetMutation>;
export type SystemTagActivitySetMutationResult = Apollo.MutationResult<SystemTagActivitySetMutation>;
export type SystemTagActivitySetMutationOptions = Apollo.BaseMutationOptions<SystemTagActivitySetMutation, SystemTagActivitySetMutationVariables>;
export const OrganisationTagCreateDocument = gql`
    mutation OrganisationTagCreate($input: OrganisationTagCreateInput!) {
  organisationTagCreate(input: $input) {
    tag {
      __typename
      ... on OrganisationTag {
        id
        label
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type OrganisationTagCreateMutationFn = Apollo.MutationFunction<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>;

/**
 * __useOrganisationTagCreateMutation__
 *
 * To run a mutation, you first call `useOrganisationTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTagCreateMutation, { data, loading, error }] = useOrganisationTagCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>(OrganisationTagCreateDocument, options);
      }
export type OrganisationTagCreateMutationHookResult = ReturnType<typeof useOrganisationTagCreateMutation>;
export type OrganisationTagCreateMutationResult = Apollo.MutationResult<OrganisationTagCreateMutation>;
export type OrganisationTagCreateMutationOptions = Apollo.BaseMutationOptions<OrganisationTagCreateMutation, OrganisationTagCreateMutationVariables>;
export const OrganisationTagActivitySetDocument = gql`
    mutation OrganisationTagActivitySet($input: OrganisationTagActivityInput!) {
  organisationTagActivitySet(input: $input) {
    tagActivities {
      id
      tag {
        ... on SystemTag {
          id
          label
        }
        ... on OrganisationTag {
          id
          label
        }
      }
      targetApplicant {
        listingId
        candidateId
      }
      notes
      action
      actionedByUser {
        ...TagActivityActionedByUserFields
      }
    }
    errors {
      message
    }
  }
}
    ${TagActivityActionedByUserFieldsFragmentDoc}`;
export type OrganisationTagActivitySetMutationFn = Apollo.MutationFunction<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>;

/**
 * __useOrganisationTagActivitySetMutation__
 *
 * To run a mutation, you first call `useOrganisationTagActivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagActivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTagActivitySetMutation, { data, loading, error }] = useOrganisationTagActivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTagActivitySetMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>(OrganisationTagActivitySetDocument, options);
      }
export type OrganisationTagActivitySetMutationHookResult = ReturnType<typeof useOrganisationTagActivitySetMutation>;
export type OrganisationTagActivitySetMutationResult = Apollo.MutationResult<OrganisationTagActivitySetMutation>;
export type OrganisationTagActivitySetMutationOptions = Apollo.BaseMutationOptions<OrganisationTagActivitySetMutation, OrganisationTagActivitySetMutationVariables>;
export const DeleteOrganisationTagDocument = gql`
    mutation DeleteOrganisationTag($input: DeleteOrganisationTagInput!) {
  deleteOrganisationTag(input: $input) {
    tag {
      __typename
      ... on OrganisationTag {
        id
        label
      }
    }
    errors {
      message
    }
  }
}
    `;
export type DeleteOrganisationTagMutationFn = Apollo.MutationFunction<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>;

/**
 * __useDeleteOrganisationTagMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationTagMutation, { data, loading, error }] = useDeleteOrganisationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>(DeleteOrganisationTagDocument, options);
      }
export type DeleteOrganisationTagMutationHookResult = ReturnType<typeof useDeleteOrganisationTagMutation>;
export type DeleteOrganisationTagMutationResult = Apollo.MutationResult<DeleteOrganisationTagMutation>;
export type DeleteOrganisationTagMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationTagMutation, DeleteOrganisationTagMutationVariables>;
export const GetHirePipelineTagActivitiesDocument = gql`
    query GetHirePipelineTagActivities($listingIds: [ID!]) {
  tagActivities(filter: {listingIds: $listingIds, category: ACTIVITY}) {
    id
    action
    targetApplicant {
      id
      candidateId
      listingId
      name
    }
    tag {
      ... on SystemTag {
        id
        label
      }
      ... on OrganisationTag {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useGetHirePipelineTagActivitiesQuery__
 *
 * To run a query within a React component, call `useGetHirePipelineTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirePipelineTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirePipelineTagActivitiesQuery({
 *   variables: {
 *      listingIds: // value for 'listingIds'
 *   },
 * });
 */
export function useGetHirePipelineTagActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>(GetHirePipelineTagActivitiesDocument, options);
      }
export function useGetHirePipelineTagActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>(GetHirePipelineTagActivitiesDocument, options);
        }
// @ts-ignore
export function useGetHirePipelineTagActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>;
export function useGetHirePipelineTagActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetHirePipelineTagActivitiesQuery | undefined, GetHirePipelineTagActivitiesQueryVariables>;
export function useGetHirePipelineTagActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>(GetHirePipelineTagActivitiesDocument, options);
        }
export type GetHirePipelineTagActivitiesQueryHookResult = ReturnType<typeof useGetHirePipelineTagActivitiesQuery>;
export type GetHirePipelineTagActivitiesLazyQueryHookResult = ReturnType<typeof useGetHirePipelineTagActivitiesLazyQuery>;
export type GetHirePipelineTagActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetHirePipelineTagActivitiesSuspenseQuery>;
export type GetHirePipelineTagActivitiesQueryResult = Apollo.QueryResult<GetHirePipelineTagActivitiesQuery, GetHirePipelineTagActivitiesQueryVariables>;
export const GetTeamMembersDocument = gql`
    query GetTeamMembers($pagination: Pagination) {
  teams(pagination: $pagination) {
    items {
      id
      name
      members {
        employer {
          id
          firstName
          lastName
        }
      }
    }
    pageInfo {
      totalPages
    }
  }
}
    `;

/**
 * __useGetTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
      }
export function useGetTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
        }
// @ts-ignore
export function useGetTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export function useGetTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamMembersQuery | undefined, GetTeamMembersQueryVariables>;
export function useGetTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
        }
export type GetTeamMembersQueryHookResult = ReturnType<typeof useGetTeamMembersQuery>;
export type GetTeamMembersLazyQueryHookResult = ReturnType<typeof useGetTeamMembersLazyQuery>;
export type GetTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetTeamMembersSuspenseQuery>;
export type GetTeamMembersQueryResult = Apollo.QueryResult<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const CreateUploadRequestDocument = gql`
    mutation CreateUploadRequest($input: CreateUploadRequestInput!) {
  createUploadRequest(input: $input) {
    id
    uploadUrl
    downloadUrl
  }
}
    `;
export type CreateUploadRequestMutationFn = Apollo.MutationFunction<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>;

/**
 * __useCreateUploadRequestMutation__
 *
 * To run a mutation, you first call `useCreateUploadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadRequestMutation, { data, loading, error }] = useCreateUploadRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>(CreateUploadRequestDocument, options);
      }
export type CreateUploadRequestMutationHookResult = ReturnType<typeof useCreateUploadRequestMutation>;
export type CreateUploadRequestMutationResult = Apollo.MutationResult<CreateUploadRequestMutation>;
export type CreateUploadRequestMutationOptions = Apollo.BaseMutationOptions<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>;